/* eslint-disable */
//THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
import { IJSONObject, IJSONValue } from '../../utils/interfaces';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: IJSONValue; output: IJSONValue; }
  JSONObject: { input: IJSONObject; output: IJSONObject; }
  Upload: { input: string | File | Blob; output: string | File | Blob; }
};

export type AbandonQuotationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
  reason_id: Scalars['String']['input'];
};

export type Action = {
  __typename?: 'Action';
  _count: ActionCount;
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  user_permissions?: Maybe<Array<UserPermission>>;
};

export type ActionCount = {
  __typename?: 'ActionCount';
  user_permissions: Scalars['Int']['output'];
};

export type ActionOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ActionRelationFilter = {
  is?: InputMaybe<ActionWhereInput>;
  isNot?: InputMaybe<ActionWhereInput>;
};

export type ActionWhereInput = {
  AND?: InputMaybe<Array<ActionWhereInput>>;
  NOT?: InputMaybe<Array<ActionWhereInput>>;
  OR?: InputMaybe<Array<ActionWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ActivateInternalUserInput = {
  token: Scalars['String']['input'];
  user_password: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: City;
  city_id: Scalars['Int']['output'];
  company?: Maybe<Company>;
  complement?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  country_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<District>;
  district_id?: Maybe<Scalars['Int']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  zip_code?: Maybe<ZipCode>;
  zip_code_address?: Maybe<Scalars['String']['output']>;
};

export type AddressGraphQlOutput = {
  __typename?: 'AddressGraphQLOutput';
  city?: Maybe<CityGraphQlOutput>;
  city_id: Scalars['Int']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryGraphQlOutput>;
  country_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<DistrictGraphQlOutput>;
  district_id?: Maybe<Scalars['Int']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateGraphQlOutput>;
  state_id?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  zip_code?: Maybe<ZipCodeGraphQlOutput>;
  zip_code_address?: Maybe<Scalars['String']['output']>;
};

export type AddressListRelationFilter = {
  every?: InputMaybe<AddressWhereInput>;
  none?: InputMaybe<AddressWhereInput>;
  some?: InputMaybe<AddressWhereInput>;
};

export type AddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  city?: InputMaybe<CityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrder>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  complement?: InputMaybe<SortOrderInput>;
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  country_id?: InputMaybe<SortOrderInput>;
  created_at?: InputMaybe<SortOrder>;
  district?: InputMaybe<DistrictOrderByWithRelationInput>;
  district_id?: InputMaybe<SortOrderInput>;
  district_name?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  number?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<StateOrderByWithRelationInput>;
  state_id?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrderInput>;
  updated_at?: InputMaybe<SortOrder>;
  zip_code?: InputMaybe<ZipCodeOrderByWithRelationInput>;
  zip_code_address?: InputMaybe<SortOrderInput>;
};

export type AddressRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  city?: InputMaybe<CityRelationFilter>;
  city_id?: InputMaybe<IntFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  complement?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<CountryRelationFilter>;
  country_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  district?: InputMaybe<DistrictRelationFilter>;
  district_id?: InputMaybe<IntNullableFilter>;
  district_name?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StateRelationFilter>;
  state_id?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  zip_code?: InputMaybe<ZipCodeRelationFilter>;
  zip_code_address?: InputMaybe<StringNullableFilter>;
};

export type AggregateFreight = {
  __typename?: 'AggregateFreight';
  _avg?: Maybe<FreightAvgAggregate>;
  _count?: Maybe<FreightCountAggregate>;
  _max?: Maybe<FreightMaxAggregate>;
  _min?: Maybe<FreightMinAggregate>;
  _sum?: Maybe<FreightSumAggregate>;
};

export type AggregatorsFreightsInput = {
  _avg?: InputMaybe<FreightAvgAggregateInput>;
  _count?: InputMaybe<FreightCountAggregateInput>;
  _max?: InputMaybe<FreightMaxAggregateInput>;
  _min?: InputMaybe<FreightMinAggregateInput>;
  _sum?: InputMaybe<FreightSumAggregateInput>;
};

export type ApproveCompanyInput = {
  company_id: Scalars['String']['input'];
  manager_id: Scalars['String']['input'];
};

export type AttachFileOnFreightGraphQlRequest = {
  creator_id: Scalars['String']['input'];
  freight_id: Scalars['String']['input'];
  short_description?: InputMaybe<Scalars['String']['input']>;
};

export type AuthUser = {
  __typename?: 'AuthUser';
  _count: AuthUserCount;
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  password_recovered_at?: Maybe<Scalars['DateTime']['output']>;
  permissions?: Maybe<Array<UserHasPermission>>;
  reference_user_id: Scalars['String']['output'];
  roles?: Maybe<Array<UserHasRole>>;
  updated_at: Scalars['DateTime']['output'];
};

export type AuthUserCount = {
  __typename?: 'AuthUserCount';
  permissions: Scalars['Int']['output'];
  roles: Scalars['Int']['output'];
};

export type AuthUserModel = {
  __typename?: 'AuthUserModel';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reference_user_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AuthUserOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<UserHasPermissionOrderByRelationAggregateInput>;
  reference_user_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AuthUserRelationFilter = {
  is?: InputMaybe<AuthUserWhereInput>;
  isNot?: InputMaybe<AuthUserWhereInput>;
};

export type AuthUserWhereInput = {
  AND?: InputMaybe<Array<AuthUserWhereInput>>;
  NOT?: InputMaybe<Array<AuthUserWhereInput>>;
  OR?: InputMaybe<Array<AuthUserWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  password?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<UserHasPermissionListRelationFilter>;
  reference_user_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type CachePermission = {
  __typename?: 'CachePermission';
  actions: Array<Scalars['String']['output']>;
  module: Scalars['String']['output'];
};

export type CancelFreightInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  freight_id: Scalars['String']['input'];
  reason_id: Scalars['String']['input'];
  shipper_id: Scalars['String']['input'];
};

export type CancelQuotationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  freight_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
  reason_id: Scalars['String']['input'];
  shipper_id: Scalars['String']['input'];
};

export type Cancellation = {
  __typename?: 'Cancellation';
  cancellationReason: CancellationReason;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: FreightCompany;
  owner_id: Scalars['String']['output'];
  quotation: Quotation;
  quotation_id: Scalars['String']['output'];
  reason_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CancellationListRelationFilter = {
  every?: InputMaybe<CancellationWhereInput>;
  none?: InputMaybe<CancellationWhereInput>;
  some?: InputMaybe<CancellationWhereInput>;
};

export type CancellationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CancellationOrderByWithRelationInput = {
  cancellationReason?: InputMaybe<CancellationReasonOrderByWithRelationInput>;
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  owner_id?: InputMaybe<SortOrder>;
  quotation?: InputMaybe<QuotationOrderByWithRelationInput>;
  quotation_id?: InputMaybe<SortOrder>;
  reason_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  _count: CancellationReasonCount;
  cancellation?: Maybe<Array<Cancellation>>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  trigger: CancellationTriggerEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type CancellationReasonCount = {
  __typename?: 'CancellationReasonCount';
  cancellation: Scalars['Int']['output'];
};

export type CancellationReasonInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trigger: CancellationTriggerEnum;
};

export type CancellationReasonOrderByWithRelationInput = {
  cancellation?: InputMaybe<CancellationOrderByRelationAggregateInput>;
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  trigger?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type CancellationReasonRelationFilter = {
  is?: InputMaybe<CancellationReasonWhereInput>;
  isNot?: InputMaybe<CancellationReasonWhereInput>;
};

export type CancellationReasonWhereInput = {
  AND?: InputMaybe<Array<CancellationReasonWhereInput>>;
  NOT?: InputMaybe<Array<CancellationReasonWhereInput>>;
  OR?: InputMaybe<Array<CancellationReasonWhereInput>>;
  cancellation?: InputMaybe<CancellationListRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  trigger?: InputMaybe<EnumCancellationTriggerEnumFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export enum CancellationTriggerEnum {
  Abandonment = 'ABANDONMENT',
  Expiration = 'EXPIRATION',
  Shipper = 'SHIPPER',
  Waiver = 'WAIVER'
}

export type CancellationWhereInput = {
  AND?: InputMaybe<Array<CancellationWhereInput>>;
  NOT?: InputMaybe<Array<CancellationWhereInput>>;
  OR?: InputMaybe<Array<CancellationWhereInput>>;
  cancellationReason?: InputMaybe<CancellationReasonRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  owner?: InputMaybe<FreightCompanyRelationFilter>;
  owner_id?: InputMaybe<UuidFilter>;
  quotation?: InputMaybe<QuotationRelationFilter>;
  quotation_id?: InputMaybe<UuidFilter>;
  reason_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type CarrierFreight = {
  __typename?: 'CarrierFreight';
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  carrier?: Maybe<FreightCompany>;
  carrier_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  freight: Freight;
  freight_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  quote_limit: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ChangeCompanyStatusInput = {
  company_id: Scalars['String']['input'];
  manager_id?: InputMaybe<Scalars['String']['input']>;
  new_status: CompanyStatusEnum;
};

export type City = {
  __typename?: 'City';
  _count: CityCount;
  address?: Maybe<Array<Address>>;
  city_area?: Maybe<Scalars['String']['output']>;
  city_code_ibge?: Maybe<Scalars['String']['output']>;
  city_name: Scalars['String']['output'];
  city_name_without_accent: Scalars['String']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  districts?: Maybe<Array<District>>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['String']['output'];
  states?: Maybe<State>;
  zip_codes?: Maybe<Array<ZipCode>>;
};

export type CityCount = {
  __typename?: 'CityCount';
  address: Scalars['Int']['output'];
  districts: Scalars['Int']['output'];
  zip_codes: Scalars['Int']['output'];
};

export type CityGraphQlOutput = {
  __typename?: 'CityGraphQLOutput';
  city_area?: Maybe<Scalars['String']['output']>;
  city_code_ibge?: Maybe<Scalars['String']['output']>;
  city_name: Scalars['String']['output'];
  city_name_without_accent: Scalars['String']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['String']['output'];
  states?: Maybe<StateGraphQlOutput>;
};

export type CityListRelationFilter = {
  every?: InputMaybe<CityWhereInput>;
  none?: InputMaybe<CityWhereInput>;
  some?: InputMaybe<CityWhereInput>;
};

export type CityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CityOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByRelationAggregateInput>;
  city_area?: InputMaybe<SortOrderInput>;
  city_code_ibge?: InputMaybe<SortOrderInput>;
  city_name?: InputMaybe<SortOrder>;
  city_name_without_accent?: InputMaybe<SortOrder>;
  ddd?: InputMaybe<SortOrderInput>;
  districts?: InputMaybe<DistrictOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  state_id?: InputMaybe<SortOrder>;
  states?: InputMaybe<StateOrderByWithRelationInput>;
  zip_codes?: InputMaybe<ZipCodeOrderByRelationAggregateInput>;
};

export type CityRelationFilter = {
  is?: InputMaybe<CityWhereInput>;
  isNot?: InputMaybe<CityWhereInput>;
};

export type CityWhereInput = {
  AND?: InputMaybe<Array<CityWhereInput>>;
  NOT?: InputMaybe<Array<CityWhereInput>>;
  OR?: InputMaybe<Array<CityWhereInput>>;
  address?: InputMaybe<AddressListRelationFilter>;
  city_area?: InputMaybe<StringNullableFilter>;
  city_code_ibge?: InputMaybe<StringNullableFilter>;
  city_name?: InputMaybe<StringFilter>;
  city_name_without_accent?: InputMaybe<StringFilter>;
  ddd?: InputMaybe<StringNullableFilter>;
  districts?: InputMaybe<DistrictListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  state_id?: InputMaybe<StringFilter>;
  states?: InputMaybe<StateRelationFilter>;
  zip_codes?: InputMaybe<ZipCodeListRelationFilter>;
};

export type Company = {
  __typename?: 'Company';
  _count: CompanyCount;
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['String']['output']>;
  children_companies?: Maybe<Array<Company>>;
  companyStatus?: Maybe<Array<CompanyHasStatus>>;
  company_function: FunctionEnum;
  company_name: Scalars['String']['output'];
  company_type: CompanyTypeEnum;
  contacts?: Maybe<Array<Contact>>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  document_number: Scalars['String']['output'];
  document_type: DocumentTypeEnum;
  fleet_quantity?: Maybe<Scalars['Int']['output']>;
  has_fleet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mother_company?: Maybe<Company>;
  mother_company_id?: Maybe<Scalars['String']['output']>;
  operationArea?: Maybe<Array<OperationArea>>;
  policies?: Maybe<Array<Policy>>;
  reference_company?: Maybe<Company>;
  reference_company_id?: Maybe<Scalars['String']['output']>;
  referenced_by_companies?: Maybe<Array<Company>>;
  settings?: Maybe<CompanySettings>;
  trade_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_logo?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<UserHasCompany>>;
};

export type CompanyCount = {
  __typename?: 'CompanyCount';
  children_companies: Scalars['Int']['output'];
  companyStatus: Scalars['Int']['output'];
  contacts: Scalars['Int']['output'];
  operationArea: Scalars['Int']['output'];
  policies: Scalars['Int']['output'];
  referenced_by_companies: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type CompanyGraphQlOutput = {
  __typename?: 'CompanyGraphQLOutput';
  address?: Maybe<AddressGraphQlOutput>;
  address_id?: Maybe<Scalars['String']['output']>;
  companyStatus?: Maybe<Array<CompanyHasStatusGraphQlOutput>>;
  company_function: FunctionEnum;
  company_name: Scalars['String']['output'];
  company_type: CompanyTypeEnum;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  document_number: Scalars['String']['output'];
  document_type: DocumentTypeEnum;
  fleet_quantity?: Maybe<Scalars['Int']['output']>;
  has_fleet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mother_company?: Maybe<CompanyMinimalGraphQlOutput>;
  mother_company_id?: Maybe<Scalars['String']['output']>;
  reference_company?: Maybe<CompanyMinimalGraphQlOutput>;
  reference_company_id?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CompanySettingsGraphQlOutput>;
  trade_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_logo?: Maybe<Scalars['String']['output']>;
};

export type CompanyHasStatus = {
  __typename?: 'CompanyHasStatus';
  company: Company;
  company_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manager?: Maybe<User>;
  manager_id?: Maybe<Scalars['String']['output']>;
  status: CompanyStatusEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type CompanyHasStatusGraphQlOutput = {
  __typename?: 'CompanyHasStatusGraphQLOutput';
  company?: Maybe<CompanyMinimalGraphQlOutput>;
  company_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  manager?: Maybe<UserMinimalGraphQlOutput>;
  manager_id?: Maybe<Scalars['ID']['output']>;
  status: CompanyStatusEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type CompanyHasStatusListRelationFilter = {
  every?: InputMaybe<CompanyHasStatusWhereInput>;
  none?: InputMaybe<CompanyHasStatusWhereInput>;
  some?: InputMaybe<CompanyHasStatusWhereInput>;
};

export type CompanyHasStatusOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompanyHasStatusWhereInput = {
  AND?: InputMaybe<Array<CompanyHasStatusWhereInput>>;
  NOT?: InputMaybe<Array<CompanyHasStatusWhereInput>>;
  OR?: InputMaybe<Array<CompanyHasStatusWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  manager?: InputMaybe<UserRelationFilter>;
  manager_id?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumCompanyStatusEnumFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type CompanyInGroup = {
  __typename?: 'CompanyInGroup';
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  group: Group;
  group_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CompanyInGroupListRelationFilter = {
  every?: InputMaybe<CompanyInGroupWhereInput>;
  none?: InputMaybe<CompanyInGroupWhereInput>;
  some?: InputMaybe<CompanyInGroupWhereInput>;
};

export type CompanyInGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompanyInGroupWhereInput = {
  AND?: InputMaybe<Array<CompanyInGroupWhereInput>>;
  NOT?: InputMaybe<Array<CompanyInGroupWhereInput>>;
  OR?: InputMaybe<Array<CompanyInGroupWhereInput>>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  group_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type CompanyListRelationFilter = {
  every?: InputMaybe<CompanyWhereInput>;
  none?: InputMaybe<CompanyWhereInput>;
  some?: InputMaybe<CompanyWhereInput>;
};

export type CompanyMinimalGraphQlOutput = {
  __typename?: 'CompanyMinimalGraphQLOutput';
  address_id?: Maybe<Scalars['String']['output']>;
  company_function: FunctionEnum;
  company_name: Scalars['String']['output'];
  company_type: CompanyTypeEnum;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  document_number: Scalars['String']['output'];
  document_type: DocumentTypeEnum;
  fleet_quantity?: Maybe<Scalars['Int']['output']>;
  has_fleet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mother_company_id?: Maybe<Scalars['String']['output']>;
  reference_company_id?: Maybe<Scalars['String']['output']>;
  trade_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_logo?: Maybe<Scalars['String']['output']>;
};

export type CompanyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompanyOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  address_id?: InputMaybe<SortOrderInput>;
  children_companies?: InputMaybe<CompanyOrderByRelationAggregateInput>;
  companyStatus?: InputMaybe<CompanyHasStatusOrderByRelationAggregateInput>;
  company_function?: InputMaybe<SortOrder>;
  company_name?: InputMaybe<SortOrder>;
  company_type?: InputMaybe<SortOrder>;
  contacts?: InputMaybe<ContactOrderByRelationAggregateInput>;
  created_at?: InputMaybe<SortOrder>;
  document_number?: InputMaybe<SortOrder>;
  document_type?: InputMaybe<SortOrder>;
  fleet_quantity?: InputMaybe<SortOrderInput>;
  has_fleet?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  mother_company?: InputMaybe<CompanyOrderByWithRelationInput>;
  mother_company_id?: InputMaybe<SortOrderInput>;
  operationArea?: InputMaybe<OperationAreaOrderByRelationAggregateInput>;
  policies?: InputMaybe<PolicyOrderByRelationAggregateInput>;
  reference_company?: InputMaybe<CompanyOrderByWithRelationInput>;
  reference_company_id?: InputMaybe<SortOrderInput>;
  referenced_by_companies?: InputMaybe<CompanyOrderByRelationAggregateInput>;
  trade_name?: InputMaybe<SortOrderInput>;
  updated_at?: InputMaybe<SortOrder>;
  url_logo?: InputMaybe<SortOrderInput>;
  users?: InputMaybe<UserHasCompanyOrderByRelationAggregateInput>;
};

export type CompanyRating = {
  __typename?: 'CompanyRating';
  average: Scalars['Int']['output'];
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  function: FreightFunctionEnum;
  id: Scalars['ID']['output'];
  rating_sum: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CompanyRatingOrderByWithRelationInput = {
  average?: InputMaybe<SortOrder>;
  company?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  company_id?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  function?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rating_sum?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type CompanyRatingRelationFilter = {
  is?: InputMaybe<CompanyRatingWhereInput>;
  isNot?: InputMaybe<CompanyRatingWhereInput>;
};

export type CompanyRatingWhereInput = {
  AND?: InputMaybe<Array<CompanyRatingWhereInput>>;
  NOT?: InputMaybe<Array<CompanyRatingWhereInput>>;
  OR?: InputMaybe<Array<CompanyRatingWhereInput>>;
  average?: InputMaybe<IntFilter>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  count?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  function?: InputMaybe<EnumFreightFunctionEnumFilter>;
  id?: InputMaybe<UuidFilter>;
  rating_sum?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type CompanyRelationFilter = {
  is?: InputMaybe<CompanyWhereInput>;
  isNot?: InputMaybe<CompanyWhereInput>;
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  changed_by: Scalars['String']['output'];
  changer: User;
  company: Company;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  theme: Theme;
  theme_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CompanySettingsGraphQlOutput = {
  __typename?: 'CompanySettingsGraphQLOutput';
  changed_by: Scalars['String']['output'];
  changer?: Maybe<UserMinimalGraphQlOutput>;
  company?: Maybe<CompanyMinimalGraphQlOutput>;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  theme?: Maybe<ThemeGraphQlOutput>;
  theme_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum CompanyStatusEnum {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  InAnalysis = 'IN_ANALYSIS',
  Pending = 'PENDING',
  RectifiedData = 'RECTIFIED_DATA',
  Reproved = 'REPROVED',
  WaitingData = 'WAITING_DATA'
}

export enum CompanyTypeEnum {
  Branch = 'BRANCH',
  Parent = 'PARENT',
  Unit = 'UNIT'
}

export type CompanyWhereInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  address?: InputMaybe<AddressRelationFilter>;
  address_id?: InputMaybe<UuidNullableFilter>;
  children_companies?: InputMaybe<CompanyListRelationFilter>;
  companyStatus?: InputMaybe<CompanyHasStatusListRelationFilter>;
  company_function?: InputMaybe<EnumFunctionEnumFilter>;
  company_name?: InputMaybe<StringFilter>;
  company_type?: InputMaybe<EnumCompanyTypeEnumFilter>;
  contacts?: InputMaybe<ContactListRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  document_number?: InputMaybe<StringFilter>;
  document_type?: InputMaybe<EnumDocumentTypeEnumFilter>;
  fleet_quantity?: InputMaybe<IntNullableFilter>;
  has_fleet?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  mother_company?: InputMaybe<CompanyRelationFilter>;
  mother_company_id?: InputMaybe<UuidNullableFilter>;
  operationArea?: InputMaybe<OperationAreaListRelationFilter>;
  policies?: InputMaybe<PolicyListRelationFilter>;
  reference_company?: InputMaybe<CompanyRelationFilter>;
  reference_company_id?: InputMaybe<UuidNullableFilter>;
  referenced_by_companies?: InputMaybe<CompanyListRelationFilter>;
  trade_name?: InputMaybe<StringNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  url_logo?: InputMaybe<StringNullableFilter>;
  users?: InputMaybe<UserHasCompanyListRelationFilter>;
};

export type ComplementCompanyDto = {
  address_data?: InputMaybe<CreateAddressCompanyInput>;
  areas_to_include?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_data?: InputMaybe<CreateContactCompanyInput>;
  fleet_quantity?: InputMaybe<Scalars['Int']['input']>;
  has_fleet?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mother_company_id?: InputMaybe<Scalars['String']['input']>;
  parent_data?: InputMaybe<CreateParentCompanyInput>;
  reference_company_id?: InputMaybe<Scalars['String']['input']>;
  url_logo?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmationId = {
  id: Scalars['String']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  company: Company;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ContactListRelationFilter = {
  every?: InputMaybe<ContactWhereInput>;
  none?: InputMaybe<ContactWhereInput>;
  some?: InputMaybe<ContactWhereInput>;
};

export type ContactOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContactUncheckedUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactWhereInput = {
  AND?: InputMaybe<Array<ContactWhereInput>>;
  NOT?: InputMaybe<Array<ContactWhereInput>>;
  OR?: InputMaybe<Array<ContactWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type Country = {
  __typename?: 'Country';
  _count: CountryCount;
  address?: Maybe<Array<Address>>;
  ddi?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
  states?: Maybe<Array<State>>;
};

export type CountryCount = {
  __typename?: 'CountryCount';
  address: Scalars['Int']['output'];
  states: Scalars['Int']['output'];
};

export type CountryGraphQlOutput = {
  __typename?: 'CountryGraphQLOutput';
  ddi?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByRelationAggregateInput>;
  ddi?: InputMaybe<SortOrderInput>;
  initials?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  states?: InputMaybe<StateOrderByRelationAggregateInput>;
};

export type CountryRelationFilter = {
  is?: InputMaybe<CountryWhereInput>;
  isNot?: InputMaybe<CountryWhereInput>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  NOT?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  address?: InputMaybe<AddressListRelationFilter>;
  ddi?: InputMaybe<StringNullableFilter>;
  initials?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  states?: InputMaybe<StateListRelationFilter>;
};

export type CreateAddressCompanyInput = {
  city_id: Scalars['Int']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  country_id: Scalars['String']['input'];
  district_id?: InputMaybe<Scalars['Int']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state_id: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip_code_address?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyDto = {
  address_data?: InputMaybe<CreateAddressCompanyInput>;
  areas?: InputMaybe<Array<Scalars['String']['input']>>;
  company_function: FunctionEnum;
  company_name: Scalars['String']['input'];
  company_type: CompanyTypeEnum;
  contact_data: CreateContactCompanyInput;
  document_number: Scalars['String']['input'];
  document_type: DocumentTypeEnum;
  fleet_quantity?: InputMaybe<Scalars['Int']['input']>;
  has_fleet?: InputMaybe<Scalars['Boolean']['input']>;
  mother_company_id?: InputMaybe<Scalars['String']['input']>;
  parent_data?: InputMaybe<CreateParentCompanyInput>;
  reference_company_id?: InputMaybe<Scalars['String']['input']>;
  trade_name?: InputMaybe<Scalars['String']['input']>;
  url_logo?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['String']['input'];
};

export type CreateContactCompanyInput = {
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateFreightInput = {
  creator_id: Scalars['String']['input'];
  landing_date: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['DateTime']['input']>;
  note_value?: InputMaybe<Scalars['Int']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  packing_id: Scalars['String']['input'];
  product_id: Scalars['String']['input'];
  product_type_id: Scalars['String']['input'];
  related_groups?: InputMaybe<Array<IdDto>>;
  route_id: Scalars['String']['input'];
  shipment_date: Scalars['DateTime']['input'];
  suggested_value?: InputMaybe<Scalars['Int']['input']>;
  total_volume: Scalars['Int']['input'];
  unit_type?: InputMaybe<UnitTypeEnum>;
  variety_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFreightRatingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  evaluator_id: Scalars['String']['input'];
  freight_id: Scalars['String']['input'];
  rated_id: Scalars['String']['input'];
  reason_id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};

export type CreateGroupInput = {
  carrier_ids: Array<IdDto>;
  name: Scalars['String']['input'];
  owner_id: Scalars['String']['input'];
};

export type CreateManyCancellationReasonInput = {
  cancellation_reasons: Array<CancellationReasonInput>;
};

export type CreateManyModulesInput = {
  modules: Array<CreateModuleInput>;
};

export type CreateManyPackingsGraphQlInput = {
  data: Array<CreatePackingGraphQlInput>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateManyPermissionTemplatesInput = {
  role: TruckerRolesEnum;
  template_lines: Array<TemplateLine>;
};

export type CreateManyProductTypesHasPackingsInput = {
  data: Array<ProductTypeHasPackingObject>;
};

export type CreateManyProductTypesInput = {
  names: Array<ProductTypeName>;
};

export type CreateManyProductsInput = {
  data: Array<CreateProductInput>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyUserHasPermissionsInput = {
  permissions: Array<EnablePermissionInput>;
  role: TruckerRolesEnum;
  user_id: Scalars['String']['input'];
};

export type CreateManyUserPermissionsInput = {
  data: Array<CreateUserPermissionInput>;
};

export type CreateManyVarietiesGraphQlInput = {
  data: Array<CreateVarietyGraphQlInput>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  product_id: Scalars['ID']['input'];
};

export type CreateMissingFreightInput = {
  creator_id: Scalars['String']['input'];
  landing_date: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['DateTime']['input']>;
  note_value?: InputMaybe<Scalars['Int']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  packing_id: Scalars['String']['input'];
  parent_id: Scalars['String']['input'];
  route_id: Scalars['String']['input'];
  shipment_date: Scalars['DateTime']['input'];
  suggested_value?: InputMaybe<Scalars['Int']['input']>;
  total_volume: Scalars['Int']['input'];
};

export type CreateModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePackingGraphQlInput = {
  capacity: Scalars['Int']['input'];
  measuring_unity: UnitTypeEnum;
  name: Scalars['String']['input'];
};

export type CreateParentCompanyInput = {
  parent_company_name: Scalars['String']['input'];
  parent_company_type: CompanyTypeEnum;
  parent_document_number: Scalars['String']['input'];
  parent_document_type: DocumentTypeEnum;
  parent_trade_name?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlaceInput = {
  balance_capacity?: InputMaybe<Scalars['Int']['input']>;
  cadence: Scalars['Int']['input'];
  city_id: Scalars['Int']['input'];
  closing_hour: Scalars['DateTime']['input'];
  company_id: Scalars['String']['input'];
  dirt_road_distance?: InputMaybe<Scalars['Int']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  has_dirt_road?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  opening_hour: Scalars['DateTime']['input'];
  state_id: Scalars['String']['input'];
};

export type CreatePlaceRouteInput = {
  balance_capacity?: InputMaybe<Scalars['Int']['input']>;
  cadence: Scalars['Int']['input'];
  city_id: Scalars['Int']['input'];
  city_name: Scalars['String']['input'];
  closing_hour: Scalars['DateTime']['input'];
  dirt_road_distance?: InputMaybe<Scalars['Int']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  has_dirt_road?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  move_type: MoveTypeEnum;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  opening_hour: Scalars['DateTime']['input'];
  reference_place_id: Scalars['String']['input'];
  state_id: Scalars['String']['input'];
  state_name: Scalars['String']['input'];
};

export type CreateProductInput = {
  name: Scalars['String']['input'];
  type_id: Scalars['String']['input'];
};

export type CreateQuotationConfirmation = {
  assigned_volume: Scalars['Int']['input'];
  cnh: Scalars['String']['input'];
  driver_name: Scalars['String']['input'];
  vehicle_plate: Scalars['String']['input'];
  vehicle_type_id: Scalars['String']['input'];
};

export type CreateQuotationConfirmationsInput = {
  data: Array<CreateQuotationConfirmation>;
  quotation_id: Scalars['String']['input'];
};

export type CreateQuotationInput = {
  creator_id: Scalars['String']['input'];
  freight_id: Scalars['String']['input'];
  has_vehicle: Scalars['Boolean']['input'];
  owner_id: Scalars['String']['input'];
  total_volume: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
  value_per_unit: Scalars['Int']['input'];
};

export type CreateQuotationRatingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  evaluator_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
  rated_id: Scalars['String']['input'];
  reason_id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};

export type CreateRatingReasonInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trigger: RatingTriggerEnum;
};

export type CreateRefusalReasonInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trigger: RefusalTriggerEnum;
};

export type CreateRefusalReasonsInput = {
  data: Array<CreateRefusalReasonInput>;
};

export type CreateRouteInput = {
  company_id: Scalars['String']['input'];
  estimate_time: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  places: Array<CreatePlaceRouteInput>;
  total_distance: Scalars['Int']['input'];
};

export type CreateThemeGraphQlInput = {
  config: Scalars['JSONObject']['input'];
  name: Scalars['String']['input'];
};

export type CreateTruckerUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role_name: RoleTruckerUserEnum;
};

export type CreateUserInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CreateUserInternallyInput = {
  company_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  role: UserInternalAvailableRolesEnum;
};

export type CreateUserPermissionInput = {
  action_id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  module_id: Scalars['String']['input'];
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  token: Scalars['String']['output'];
};

export type CreateVarietyGraphQlInput = {
  name: Scalars['String']['input'];
};

export type CreateVehicleTypeInput = {
  capacity: Scalars['Int']['input'];
  measuring_unity?: InputMaybe<UnitMeasureEnum>;
  name: Scalars['String']['input'];
};

export type Cte = {
  __typename?: 'Cte';
  confirmation: QuotationConfirmation;
  confirmation_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  driver: Driver;
  driver_id: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  loaded_volume: Scalars['Int']['output'];
  quotation: Quotation;
  quotation_id: Scalars['String']['output'];
  unit_type: UnitTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type CteListRelationFilter = {
  every?: InputMaybe<CteWhereInput>;
  none?: InputMaybe<CteWhereInput>;
  some?: InputMaybe<CteWhereInput>;
};

export type CteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CteWhereInput = {
  AND?: InputMaybe<Array<CteWhereInput>>;
  NOT?: InputMaybe<Array<CteWhereInput>>;
  OR?: InputMaybe<Array<CteWhereInput>>;
  confirmation?: InputMaybe<QuotationConfirmationRelationFilter>;
  confirmation_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  driver?: InputMaybe<DriverRelationFilter>;
  driver_id?: InputMaybe<UuidFilter>;
  filename?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  quotation?: InputMaybe<QuotationRelationFilter>;
  quotation_id?: InputMaybe<UuidFilter>;
  unit_type?: InputMaybe<EnumUnitTypeEnumFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type CustomCancellationReasonsWhereInput = {
  trigger: EnumCancellationTriggerEnumFilter;
};

export type CustomRoutesWhereInput = {
  company: FindCompanyWhereInput;
  id?: InputMaybe<UuidFilter>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum DefaultRolesEnum {
  Carrier = 'CARRIER',
  Quotator = 'QUOTATOR',
  Shipper = 'SHIPPER'
}

export type DelegateQuotationInput = {
  children_id: Scalars['String']['input'];
  current_owner_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
};

export type DeleteCancellationReasonInput = {
  id: Scalars['String']['input'];
};

export type DeleteGroupInput = {
  group_id: Scalars['String']['input'];
  owner_id: Scalars['String']['input'];
};

export type DeleteLogoDto = {
  url: Scalars['String']['input'];
};

export type DeleteManyCancellationReasonInput = {
  ids: Array<DeleteCancellationReasonInput>;
};

export type DeleteManyPackingsGraphQlInput = {
  data: Array<PackingIdGraphQlInput>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteManyProductTypesHasPackingsInput = {
  product_types_has_packings: Array<ProductTypeHasPackingObject>;
};

export type DeleteManyProductTypesInput = {
  ids: Array<ProductTypeId>;
};

export type DeleteManyProductsInput = {
  data: Array<DeleteProductInput>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteManyVarietiesGraphQlInput = {
  data: Array<DeleteVarietyGraphQlInput>;
  product_id: Scalars['String']['input'];
};

export type DeletePermissionTemplateInput = {
  role: TruckerRolesEnum;
};

export type DeletePlaceInput = {
  place_id: Scalars['String']['input'];
};

export type DeletePolicyDto = {
  policy_id: Scalars['String']['input'];
};

export type DeleteProductInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuotationConfirmationsInput = {
  confirmations: Array<ConfirmationId>;
  quotation_id: Scalars['String']['input'];
};

export type DeleteRatingReason = {
  id: Scalars['String']['input'];
};

export type DeleteRefusalReasonInput = {
  id: Scalars['String']['input'];
};

export type DeleteRefusalReasonsInput = {
  data: Array<DeleteRefusalReasonInput>;
};

export type DeleteRouteInput = {
  id: Scalars['String']['input'];
};

export type DeleteThemeGraphQlOutput = {
  __typename?: 'DeleteThemeGraphQLOutput';
  theme_id: Scalars['String']['output'];
};

export type DeleteUrlResponse = {
  __typename?: 'DeleteUrlResponse';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteVarietyGraphQlInput = {
  variety_id: Scalars['String']['input'];
};

export type DeleteVehicleTypeInput = {
  vehicle_id: Scalars['String']['input'];
};

export type DetachOneFileFromFreightGraphQlRequest = {
  attachment_id: Scalars['String']['input'];
  freight_id: Scalars['String']['input'];
};

export type DetachOneFileFromFreightGraphQlResponse = {
  __typename?: 'DetachOneFileFromFreightGraphQLResponse';
  attachment_id: Scalars['String']['output'];
};

export type District = {
  __typename?: 'District';
  _count: DistrictCount;
  address?: Maybe<Array<Address>>;
  city?: Maybe<City>;
  city_id: Scalars['Int']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  district_name: Scalars['String']['output'];
  district_name_without_accent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id: Scalars['String']['output'];
  zip_codes?: Maybe<Array<ZipCode>>;
};

export type DistrictCount = {
  __typename?: 'DistrictCount';
  address: Scalars['Int']['output'];
  zip_codes: Scalars['Int']['output'];
};

export type DistrictGraphQlOutput = {
  __typename?: 'DistrictGraphQLOutput';
  city?: Maybe<CityGraphQlOutput>;
  city_id: Scalars['Int']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  district_name: Scalars['String']['output'];
  district_name_without_accent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateGraphQlOutput>;
  state_id: Scalars['String']['output'];
};

export type DistrictListRelationFilter = {
  every?: InputMaybe<DistrictWhereInput>;
  none?: InputMaybe<DistrictWhereInput>;
  some?: InputMaybe<DistrictWhereInput>;
};

export type DistrictOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DistrictOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByRelationAggregateInput>;
  city?: InputMaybe<CityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrder>;
  ddd?: InputMaybe<SortOrderInput>;
  district_name?: InputMaybe<SortOrder>;
  district_name_without_accent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<StateOrderByWithRelationInput>;
  state_id?: InputMaybe<SortOrder>;
  zip_codes?: InputMaybe<ZipCodeOrderByRelationAggregateInput>;
};

export type DistrictRelationFilter = {
  is?: InputMaybe<DistrictWhereInput>;
  isNot?: InputMaybe<DistrictWhereInput>;
};

export type DistrictWhereInput = {
  AND?: InputMaybe<Array<DistrictWhereInput>>;
  NOT?: InputMaybe<Array<DistrictWhereInput>>;
  OR?: InputMaybe<Array<DistrictWhereInput>>;
  address?: InputMaybe<AddressListRelationFilter>;
  city?: InputMaybe<CityRelationFilter>;
  city_id?: InputMaybe<IntFilter>;
  ddd?: InputMaybe<StringNullableFilter>;
  district_name?: InputMaybe<StringFilter>;
  district_name_without_accent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StateRelationFilter>;
  state_id?: InputMaybe<StringFilter>;
  zip_codes?: InputMaybe<ZipCodeListRelationFilter>;
};

export enum DocumentTypeEnum {
  Cnpj = 'CNPJ',
  Cpf = 'CPF'
}

export type Driver = {
  __typename?: 'Driver';
  _count: DriverCount;
  carrier: FreightCompany;
  carrier_id: Scalars['String']['output'];
  cnh: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  ctes?: Maybe<Array<Cte>>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quotation_confirmations?: Maybe<Array<QuotationConfirmation>>;
  updated_at: Scalars['DateTime']['output'];
};

export type DriverCount = {
  __typename?: 'DriverCount';
  ctes: Scalars['Int']['output'];
  quotation_confirmations: Scalars['Int']['output'];
};

export type DriverListRelationFilter = {
  every?: InputMaybe<DriverWhereInput>;
  none?: InputMaybe<DriverWhereInput>;
  some?: InputMaybe<DriverWhereInput>;
};

export type DriverOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DriverRelationFilter = {
  is?: InputMaybe<DriverWhereInput>;
  isNot?: InputMaybe<DriverWhereInput>;
};

export type DriverWhereInput = {
  AND?: InputMaybe<Array<DriverWhereInput>>;
  NOT?: InputMaybe<Array<DriverWhereInput>>;
  OR?: InputMaybe<Array<DriverWhereInput>>;
  carrier?: InputMaybe<FreightCompanyRelationFilter>;
  carrier_id?: InputMaybe<UuidFilter>;
  cnh?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  ctes?: InputMaybe<CteListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  quotation_confirmations?: InputMaybe<QuotationConfirmationListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type EnablePermissionInput = {
  enable: Scalars['Boolean']['input'];
  permission_id: Scalars['String']['input'];
};

export type EnumCancellationTriggerEnumFilter = {
  equals?: InputMaybe<CancellationTriggerEnum>;
  in?: InputMaybe<Array<CancellationTriggerEnum>>;
  not?: InputMaybe<NestedEnumCancellationTriggerEnumFilter>;
  notIn?: InputMaybe<Array<CancellationTriggerEnum>>;
};

export type EnumCompanyStatusEnumFilter = {
  equals?: InputMaybe<CompanyStatusEnum>;
  in?: InputMaybe<Array<CompanyStatusEnum>>;
  not?: InputMaybe<NestedEnumCompanyStatusEnumFilter>;
  notIn?: InputMaybe<Array<CompanyStatusEnum>>;
};

export type EnumCompanyTypeEnumFilter = {
  equals?: InputMaybe<CompanyTypeEnum>;
  in?: InputMaybe<Array<CompanyTypeEnum>>;
  not?: InputMaybe<NestedEnumCompanyTypeEnumFilter>;
  notIn?: InputMaybe<Array<CompanyTypeEnum>>;
};

export type EnumDocumentTypeEnumFilter = {
  equals?: InputMaybe<DocumentTypeEnum>;
  in?: InputMaybe<Array<DocumentTypeEnum>>;
  not?: InputMaybe<NestedEnumDocumentTypeEnumFilter>;
  notIn?: InputMaybe<Array<DocumentTypeEnum>>;
};

export type EnumFreightCompanyTypeEnumFilter = {
  equals?: InputMaybe<FreightCompanyTypeEnum>;
  in?: InputMaybe<Array<FreightCompanyTypeEnum>>;
  not?: InputMaybe<NestedEnumFreightCompanyTypeEnumFilter>;
  notIn?: InputMaybe<Array<FreightCompanyTypeEnum>>;
};

export type EnumFreightDocumentTypeEnumFilter = {
  equals?: InputMaybe<FreightDocumentTypeEnum>;
  in?: InputMaybe<Array<FreightDocumentTypeEnum>>;
  not?: InputMaybe<NestedEnumFreightDocumentTypeEnumFilter>;
  notIn?: InputMaybe<Array<FreightDocumentTypeEnum>>;
};

export type EnumFreightFunctionEnumFilter = {
  equals?: InputMaybe<FreightFunctionEnum>;
  in?: InputMaybe<Array<FreightFunctionEnum>>;
  not?: InputMaybe<NestedEnumFreightFunctionEnumFilter>;
  notIn?: InputMaybe<Array<FreightFunctionEnum>>;
};

export type EnumFunctionEnumFilter = {
  equals?: InputMaybe<FunctionEnum>;
  in?: InputMaybe<Array<FunctionEnum>>;
  not?: InputMaybe<NestedEnumFunctionEnumFilter>;
  notIn?: InputMaybe<Array<FunctionEnum>>;
};

export type EnumMoveTypeEnumFilter = {
  equals?: InputMaybe<MoveTypeEnum>;
  in?: InputMaybe<Array<MoveTypeEnum>>;
  not?: InputMaybe<NestedEnumMoveTypeEnumFilter>;
  notIn?: InputMaybe<Array<MoveTypeEnum>>;
};

export type EnumRatingTriggerEnumFilter = {
  equals?: InputMaybe<RatingTriggerEnum>;
  in?: InputMaybe<Array<RatingTriggerEnum>>;
  not?: InputMaybe<NestedEnumRatingTriggerEnumFilter>;
  notIn?: InputMaybe<Array<RatingTriggerEnum>>;
};

export type EnumRefusalTriggerEnumFilter = {
  equals?: InputMaybe<RefusalTriggerEnum>;
  in?: InputMaybe<Array<RefusalTriggerEnum>>;
  not?: InputMaybe<NestedEnumRefusalTriggerEnumFilter>;
  notIn?: InputMaybe<Array<RefusalTriggerEnum>>;
};

export type EnumUnitMeasureEnumFilter = {
  equals?: InputMaybe<UnitMeasureEnum>;
  in?: InputMaybe<Array<UnitMeasureEnum>>;
  not?: InputMaybe<NestedEnumUnitMeasureEnumFilter>;
  notIn?: InputMaybe<Array<UnitMeasureEnum>>;
};

export type EnumUnitTypeEnumFilter = {
  equals?: InputMaybe<UnitTypeEnum>;
  in?: InputMaybe<Array<UnitTypeEnum>>;
  not?: InputMaybe<NestedEnumUnitTypeEnumFilter>;
  notIn?: InputMaybe<Array<UnitTypeEnum>>;
};

export type FileGraphQlResponse = {
  __typename?: 'FileGraphQLResponse';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type Files = {
  __typename?: 'Files';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  user: User;
  user_id: Scalars['String']['output'];
};

export type FilesListRelationFilter = {
  every?: InputMaybe<FilesWhereInput>;
  none?: InputMaybe<FilesWhereInput>;
  some?: InputMaybe<FilesWhereInput>;
};

export type FilesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FilesWhereInput = {
  AND?: InputMaybe<Array<FilesWhereInput>>;
  NOT?: InputMaybe<Array<FilesWhereInput>>;
  OR?: InputMaybe<Array<FilesWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  url?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type FindCities = {
  __typename?: 'FindCities';
  city_area?: Maybe<Scalars['String']['output']>;
  city_code_ibge?: Maybe<Scalars['String']['output']>;
  city_name: Scalars['String']['output'];
  city_name_without_accent: Scalars['String']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['String']['output'];
};

export type FindCompanyWhereInput = {
  reference_external_company_id: UuidFilter;
};

export type FindManyThemesGraphQlOuput = {
  __typename?: 'FindManyThemesGraphQLOuput';
  data: Array<ThemeGraphQlOutput>;
  length: Scalars['Int']['output'];
};

export type FindPlaceInput = {
  id: Scalars['ID']['input'];
};

export type FindPlacesWhereInput = {
  company: FindCompanyWhereInput;
  id?: InputMaybe<UuidFilter>;
};

export type FindReproachInput = {
  company_id: Scalars['String']['input'];
};

export type FindReproachResponse = {
  __typename?: 'FindReproachResponse';
  reasons: Array<Reason>;
  reproach: Reproach;
};

export type FindRoleInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FindRouteInput = {
  id: Scalars['String']['input'];
};

export type FindUserGraphQlOutput = {
  __typename?: 'FindUserGraphQLOutput';
  active: Scalars['Boolean']['output'];
  companies?: Maybe<Array<UserHasCompanyGraphqQlOutput>>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FindVehicleTypeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FindZipCode = {
  __typename?: 'FindZipCode';
  active?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<City>;
  district?: Maybe<District>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type FindZipCodeDto = {
  zip_code: Scalars['String']['input'];
};

export type FinishQuotationInput = {
  owner_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
};

export type Freight = {
  __typename?: 'Freight';
  _count: FreightCount;
  allocated_volume: Scalars['Int']['output'];
  child?: Maybe<Freight>;
  created_at: Scalars['DateTime']['output'];
  creator: FreightUser;
  creator_id: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expires_in?: Maybe<Scalars['DateTime']['output']>;
  freight_ratings?: Maybe<Array<FreightRating>>;
  id: Scalars['ID']['output'];
  landing_date: Scalars['DateTime']['output'];
  loaded_volume: Scalars['Int']['output'];
  note_value?: Maybe<Scalars['Int']['output']>;
  numeric_id: Scalars['Int']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  owner: FreightCompany;
  owner_id: Scalars['String']['output'];
  package_id: Scalars['String']['output'];
  packing: Packing;
  parent?: Maybe<Freight>;
  parent_id?: Maybe<Scalars['String']['output']>;
  product: Product;
  product_id: Scalars['String']['output'];
  product_type: ProductType;
  product_type_id: Scalars['String']['output'];
  product_variety?: Maybe<Variety>;
  product_variety_id?: Maybe<Scalars['String']['output']>;
  quotations?: Maybe<Array<Quotation>>;
  quote_limit: Scalars['DateTime']['output'];
  refusals?: Maybe<Array<Refusal>>;
  related_carriers?: Maybe<Array<CarrierFreight>>;
  related_groups?: Maybe<Array<GroupFreight>>;
  route: Route;
  route_id: Scalars['String']['output'];
  shipment_date: Scalars['DateTime']['output'];
  status: FreightStatus;
  status_id: Scalars['String']['output'];
  suggested_value?: Maybe<Scalars['Int']['output']>;
  total_volume: Scalars['Int']['output'];
  unallocated_volume: Scalars['Int']['output'];
  unit_type: UnitTypeEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type FreightAddress = {
  __typename?: 'FreightAddress';
  city: FreightCity;
  city_id: Scalars['Int']['output'];
  company?: Maybe<FreightCompany>;
  complement?: Maybe<Scalars['String']['output']>;
  country?: Maybe<FreightCountry>;
  country_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<FreightDistrict>;
  district_id?: Maybe<Scalars['Int']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  reference_address_id: Scalars['String']['output'];
  state?: Maybe<FreightState>;
  state_id?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  zip_code?: Maybe<FreightZipCode>;
  zip_code_address?: Maybe<Scalars['String']['output']>;
};

export type FreightAddressListRelationFilter = {
  every?: InputMaybe<FreightAddressWhereInput>;
  none?: InputMaybe<FreightAddressWhereInput>;
  some?: InputMaybe<FreightAddressWhereInput>;
};

export type FreightAddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightAddressOrderByWithRelationInput = {
  city?: InputMaybe<FreightCityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrder>;
  company?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  complement?: InputMaybe<SortOrder>;
  country?: InputMaybe<FreightCountryOrderByWithRelationInput>;
  country_id?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  district?: InputMaybe<FreightDistrictOrderByWithRelationInput>;
  district_id?: InputMaybe<SortOrder>;
  district_name?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  reference_address_id?: InputMaybe<SortOrder>;
  state?: InputMaybe<FreightStateOrderByWithRelationInput>;
  state_id?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  zip_code?: InputMaybe<FreightZipCodeOrderByWithRelationInput>;
  zip_code_address?: InputMaybe<SortOrder>;
};

export type FreightAddressRelationFilter = {
  is?: InputMaybe<FreightAddressWhereInput>;
  isNot?: InputMaybe<FreightAddressWhereInput>;
};

export type FreightAddressWhereInput = {
  AND?: InputMaybe<Array<FreightAddressWhereInput>>;
  NOT?: InputMaybe<Array<FreightAddressWhereInput>>;
  OR?: InputMaybe<Array<FreightAddressWhereInput>>;
  city?: InputMaybe<FreightCityRelationFilter>;
  city_id?: InputMaybe<IntFilter>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  complement?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<FreightCountryRelationFilter>;
  country_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  district?: InputMaybe<FreightDistrictRelationFilter>;
  district_id?: InputMaybe<IntNullableFilter>;
  district_name?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringNullableFilter>;
  reference_address_id?: InputMaybe<UuidFilter>;
  state?: InputMaybe<FreightStateRelationFilter>;
  state_id?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  zip_code?: InputMaybe<FreightZipCodeRelationFilter>;
  zip_code_address?: InputMaybe<StringNullableFilter>;
};

export type FreightAttachmentGraphQlResponse = {
  __typename?: 'FreightAttachmentGraphQLResponse';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<FreightUserGraphQlResponse>;
  creator_id: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<FileGraphQlResponse>;
  file_id: Scalars['String']['output'];
  freight_id: Scalars['String']['output'];
  short_description?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type FreightAttachmentOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  creator_id?: InputMaybe<SortOrder>;
  file_id?: InputMaybe<SortOrder>;
  freight_id?: InputMaybe<SortOrder>;
  short_description?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type FreightAttachmentWhereInput = {
  AND?: InputMaybe<Array<FreightAttachmentWhereInput>>;
  NOT?: InputMaybe<Array<FreightAttachmentWhereInput>>;
  OR?: InputMaybe<Array<FreightAttachmentWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  creator_id?: InputMaybe<UuidFilter>;
  file_id?: InputMaybe<UuidFilter>;
  freight_id?: InputMaybe<UuidFilter>;
  short_description?: InputMaybe<StringNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type FreightAttachmentsGraphQlResponse = {
  __typename?: 'FreightAttachmentsGraphQLResponse';
  data: Array<FreightAttachmentGraphQlResponse>;
  length: Scalars['Int']['output'];
};

export type FreightAvgAggregate = {
  __typename?: 'FreightAvgAggregate';
  allocated_volume?: Maybe<Scalars['Float']['output']>;
  loaded_volume?: Maybe<Scalars['Float']['output']>;
  note_value?: Maybe<Scalars['Float']['output']>;
  numeric_id?: Maybe<Scalars['Float']['output']>;
  suggested_value?: Maybe<Scalars['Float']['output']>;
  total_volume?: Maybe<Scalars['Float']['output']>;
  unallocated_volume?: Maybe<Scalars['Float']['output']>;
};

export type FreightAvgAggregateInput = {
  allocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  loaded_volume?: InputMaybe<Scalars['Boolean']['input']>;
  note_value?: InputMaybe<Scalars['Boolean']['input']>;
  numeric_id?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_value?: InputMaybe<Scalars['Boolean']['input']>;
  total_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unallocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreightCity = {
  __typename?: 'FreightCity';
  _count: FreightCityCount;
  address?: Maybe<Array<FreightAddress>>;
  city_area?: Maybe<Scalars['String']['output']>;
  city_code_ibge?: Maybe<Scalars['String']['output']>;
  city_name: Scalars['String']['output'];
  city_name_without_accent: Scalars['String']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  districts?: Maybe<Array<FreightDistrict>>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  place_routes?: Maybe<Array<PlaceRoute>>;
  places?: Maybe<Array<Place>>;
  state_id: Scalars['String']['output'];
  states?: Maybe<FreightState>;
  zip_codes?: Maybe<Array<FreightZipCode>>;
};

export type FreightCityCount = {
  __typename?: 'FreightCityCount';
  address: Scalars['Int']['output'];
  districts: Scalars['Int']['output'];
  place_routes: Scalars['Int']['output'];
  places: Scalars['Int']['output'];
  zip_codes: Scalars['Int']['output'];
};

export type FreightCityListRelationFilter = {
  every?: InputMaybe<FreightCityWhereInput>;
  none?: InputMaybe<FreightCityWhereInput>;
  some?: InputMaybe<FreightCityWhereInput>;
};

export type FreightCityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightCityOrderByWithRelationInput = {
  address?: InputMaybe<FreightAddressOrderByRelationAggregateInput>;
  city_area?: InputMaybe<SortOrder>;
  city_code_ibge?: InputMaybe<SortOrder>;
  city_name?: InputMaybe<SortOrder>;
  city_name_without_accent?: InputMaybe<SortOrder>;
  ddd?: InputMaybe<SortOrder>;
  districts?: InputMaybe<FreightDistrictOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  places?: InputMaybe<PlaceOrderByRelationAggregateInput>;
  state_id?: InputMaybe<SortOrder>;
  states?: InputMaybe<FreightStateOrderByWithRelationInput>;
  zip_codes?: InputMaybe<FreightZipCodeOrderByRelationAggregateInput>;
};

export type FreightCityRelationFilter = {
  is?: InputMaybe<FreightCityWhereInput>;
  isNot?: InputMaybe<FreightCityWhereInput>;
};

export type FreightCityWhereInput = {
  AND?: InputMaybe<Array<FreightCityWhereInput>>;
  NOT?: InputMaybe<Array<FreightCityWhereInput>>;
  OR?: InputMaybe<Array<FreightCityWhereInput>>;
  address?: InputMaybe<FreightAddressListRelationFilter>;
  city_area?: InputMaybe<StringNullableFilter>;
  city_code_ibge?: InputMaybe<StringNullableFilter>;
  city_name?: InputMaybe<StringFilter>;
  city_name_without_accent?: InputMaybe<StringFilter>;
  ddd?: InputMaybe<StringNullableFilter>;
  districts?: InputMaybe<FreightDistrictListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  places?: InputMaybe<PlaceListRelationFilter>;
  state_id?: InputMaybe<StringFilter>;
  states?: InputMaybe<FreightStateRelationFilter>;
  zip_codes?: InputMaybe<FreightZipCodeListRelationFilter>;
};

export type FreightCompany = {
  __typename?: 'FreightCompany';
  _count: FreightCompanyCount;
  address?: Maybe<FreightAddress>;
  address_id?: Maybe<Scalars['String']['output']>;
  cancellations?: Maybe<Array<Cancellation>>;
  carrier_quotations?: Maybe<Array<Quotation>>;
  children_companies?: Maybe<Array<FreightCompany>>;
  company_function: FreightFunctionEnum;
  company_name: Scalars['String']['output'];
  company_type: FreightCompanyTypeEnum;
  contacts?: Maybe<Array<FreightContact>>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  document_number: Scalars['String']['output'];
  document_type: FreightDocumentTypeEnum;
  drivers?: Maybe<Array<Driver>>;
  fleet_quantity?: Maybe<Scalars['Int']['output']>;
  freight_ratings?: Maybe<Array<FreightRating>>;
  freights?: Maybe<Array<Freight>>;
  groups?: Maybe<Array<Group>>;
  has_fleet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  member_groups?: Maybe<Array<CompanyInGroup>>;
  mother_company?: Maybe<FreightCompany>;
  mother_company_id?: Maybe<Scalars['String']['output']>;
  operationArea?: Maybe<Array<FreightOperationArea>>;
  places?: Maybe<Array<Place>>;
  quotation_rating?: Maybe<Array<QuotationRating>>;
  rated_freights?: Maybe<Array<FreightRating>>;
  rated_quotations?: Maybe<Array<QuotationRating>>;
  rating?: Maybe<CompanyRating>;
  reference_company?: Maybe<FreightCompany>;
  reference_company_id?: Maybe<Scalars['String']['output']>;
  reference_external_company_id: Scalars['String']['output'];
  referenced_by_companies?: Maybe<Array<FreightCompany>>;
  refusals?: Maybe<Array<Refusal>>;
  related_freights?: Maybe<Array<CarrierFreight>>;
  routes?: Maybe<Array<Route>>;
  shipper_quotations?: Maybe<Array<Quotation>>;
  trade_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_logo?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<FreightUserHasCompany>>;
};

export type FreightCompanyCount = {
  __typename?: 'FreightCompanyCount';
  cancellations: Scalars['Int']['output'];
  carrier_quotations: Scalars['Int']['output'];
  children_companies: Scalars['Int']['output'];
  contacts: Scalars['Int']['output'];
  drivers: Scalars['Int']['output'];
  freight_ratings: Scalars['Int']['output'];
  freights: Scalars['Int']['output'];
  groups: Scalars['Int']['output'];
  member_groups: Scalars['Int']['output'];
  operationArea: Scalars['Int']['output'];
  packings: Scalars['Int']['output'];
  places: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
  quotation_rating: Scalars['Int']['output'];
  rated_freights: Scalars['Int']['output'];
  rated_quotations: Scalars['Int']['output'];
  referenced_by_companies: Scalars['Int']['output'];
  refusals: Scalars['Int']['output'];
  related_freights: Scalars['Int']['output'];
  routes: Scalars['Int']['output'];
  shipper_quotations: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
  varieties: Scalars['Int']['output'];
};

export type FreightCompanyListRelationFilter = {
  every?: InputMaybe<FreightCompanyWhereInput>;
  none?: InputMaybe<FreightCompanyWhereInput>;
  some?: InputMaybe<FreightCompanyWhereInput>;
};

export type FreightCompanyMinimalGraphQlOutput = {
  __typename?: 'FreightCompanyMinimalGraphQLOutput';
  address_id?: Maybe<Scalars['String']['output']>;
  company_function: FreightFunctionEnum;
  company_name: Scalars['String']['output'];
  company_type: FreightCompanyTypeEnum;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  document_number: Scalars['String']['output'];
  document_type: FreightDocumentTypeEnum;
  fleet_quantity?: Maybe<Scalars['Int']['output']>;
  has_fleet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mother_company_id?: Maybe<Scalars['String']['output']>;
  reference_company_id?: Maybe<Scalars['String']['output']>;
  reference_external_company_id: Scalars['String']['output'];
  trade_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_logo?: Maybe<Scalars['String']['output']>;
};

export type FreightCompanyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightCompanyOrderByWithRelationInput = {
  address?: InputMaybe<FreightAddressOrderByWithRelationInput>;
  address_id?: InputMaybe<SortOrder>;
  cancellations?: InputMaybe<CancellationOrderByRelationAggregateInput>;
  carrier_quotations?: InputMaybe<QuotationOrderByRelationAggregateInput>;
  children_companies?: InputMaybe<FreightCompanyOrderByRelationAggregateInput>;
  company_function?: InputMaybe<SortOrder>;
  company_name?: InputMaybe<SortOrder>;
  company_type?: InputMaybe<SortOrder>;
  contacts?: InputMaybe<FreightContactOrderByRelationAggregateInput>;
  created_at?: InputMaybe<SortOrder>;
  document_number?: InputMaybe<SortOrder>;
  document_type?: InputMaybe<SortOrder>;
  drivers?: InputMaybe<DriverOrderByRelationAggregateInput>;
  fleet_quantity?: InputMaybe<SortOrder>;
  freight_ratings?: InputMaybe<FreightRatingOrderByRelationAggregateInput>;
  freights?: InputMaybe<FreightOrderByRelationAggregateInput>;
  groups?: InputMaybe<GroupOrderByRelationAggregateInput>;
  has_fleet?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  member_groups?: InputMaybe<CompanyInGroupOrderByRelationAggregateInput>;
  mother_company?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  mother_company_id?: InputMaybe<SortOrder>;
  operationArea?: InputMaybe<FreightOperationAreaOrderByRelationAggregateInput>;
  places?: InputMaybe<PlaceOrderByRelationAggregateInput>;
  quotation_rating?: InputMaybe<QuotationRatingOrderByRelationAggregateInput>;
  rated_freights?: InputMaybe<FreightRatingOrderByRelationAggregateInput>;
  rated_quotations?: InputMaybe<QuotationRatingOrderByRelationAggregateInput>;
  rating?: InputMaybe<CompanyRatingOrderByWithRelationInput>;
  reference_company?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  reference_company_id?: InputMaybe<SortOrder>;
  reference_external_company_id?: InputMaybe<SortOrder>;
  referenced_by_companies?: InputMaybe<FreightCompanyOrderByRelationAggregateInput>;
  refusals?: InputMaybe<RefusalOrderByRelationAggregateInput>;
  routes?: InputMaybe<RouteOrderByRelationAggregateInput>;
  shipper_quotations?: InputMaybe<QuotationOrderByRelationAggregateInput>;
  trade_name?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  url_logo?: InputMaybe<SortOrder>;
  users?: InputMaybe<FreightUserHasCompanyOrderByRelationAggregateInput>;
};

export type FreightCompanyRelationFilter = {
  is?: InputMaybe<FreightCompanyWhereInput>;
  isNot?: InputMaybe<FreightCompanyWhereInput>;
};

export enum FreightCompanyTypeEnum {
  Branch = 'BRANCH',
  Parent = 'PARENT',
  Unit = 'UNIT'
}

export type FreightCompanyWhereInput = {
  AND?: InputMaybe<Array<FreightCompanyWhereInput>>;
  NOT?: InputMaybe<Array<FreightCompanyWhereInput>>;
  OR?: InputMaybe<Array<FreightCompanyWhereInput>>;
  address?: InputMaybe<FreightAddressRelationFilter>;
  address_id?: InputMaybe<UuidNullableFilter>;
  cancellations?: InputMaybe<CancellationListRelationFilter>;
  carrier_quotations?: InputMaybe<QuotationListRelationFilter>;
  children_companies?: InputMaybe<FreightCompanyListRelationFilter>;
  company_function?: InputMaybe<EnumFreightFunctionEnumFilter>;
  company_name?: InputMaybe<StringFilter>;
  company_type?: InputMaybe<EnumFreightCompanyTypeEnumFilter>;
  contacts?: InputMaybe<FreightContactListRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  document_number?: InputMaybe<StringFilter>;
  document_type?: InputMaybe<EnumFreightDocumentTypeEnumFilter>;
  drivers?: InputMaybe<DriverListRelationFilter>;
  fleet_quantity?: InputMaybe<IntNullableFilter>;
  freight_ratings?: InputMaybe<FreightRatingListRelationFilter>;
  freights?: InputMaybe<FreightListRelationFilter>;
  groups?: InputMaybe<GroupListRelationFilter>;
  has_fleet?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  member_groups?: InputMaybe<CompanyInGroupListRelationFilter>;
  mother_company?: InputMaybe<FreightCompanyRelationFilter>;
  mother_company_id?: InputMaybe<UuidNullableFilter>;
  operationArea?: InputMaybe<FreightOperationAreaListRelationFilter>;
  places?: InputMaybe<PlaceListRelationFilter>;
  quotation_rating?: InputMaybe<QuotationRatingListRelationFilter>;
  rated_freights?: InputMaybe<FreightRatingListRelationFilter>;
  rated_quotations?: InputMaybe<QuotationRatingListRelationFilter>;
  rating?: InputMaybe<CompanyRatingRelationFilter>;
  reference_company?: InputMaybe<FreightCompanyRelationFilter>;
  reference_company_id?: InputMaybe<UuidNullableFilter>;
  reference_external_company_id?: InputMaybe<UuidFilter>;
  referenced_by_companies?: InputMaybe<FreightCompanyListRelationFilter>;
  refusals?: InputMaybe<RefusalListRelationFilter>;
  routes?: InputMaybe<RouteListRelationFilter>;
  shipper_quotations?: InputMaybe<QuotationListRelationFilter>;
  trade_name?: InputMaybe<StringNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  url_logo?: InputMaybe<StringNullableFilter>;
  users?: InputMaybe<FreightUserHasCompanyListRelationFilter>;
};

export type FreightContact = {
  __typename?: 'FreightContact';
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  reference_contact_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FreightContactListRelationFilter = {
  every?: InputMaybe<FreightContactWhereInput>;
  none?: InputMaybe<FreightContactWhereInput>;
  some?: InputMaybe<FreightContactWhereInput>;
};

export type FreightContactOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightContactWhereInput = {
  AND?: InputMaybe<Array<FreightContactWhereInput>>;
  NOT?: InputMaybe<Array<FreightContactWhereInput>>;
  OR?: InputMaybe<Array<FreightContactWhereInput>>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringFilter>;
  reference_contact_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type FreightCount = {
  __typename?: 'FreightCount';
  attachments: Scalars['Int']['output'];
  freight_ratings: Scalars['Int']['output'];
  quotations: Scalars['Int']['output'];
  refusals: Scalars['Int']['output'];
  related_carriers: Scalars['Int']['output'];
  related_groups: Scalars['Int']['output'];
};

export type FreightCountAggregate = {
  __typename?: 'FreightCountAggregate';
  _all: Scalars['Int']['output'];
  allocated_volume: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  creator_id: Scalars['Int']['output'];
  deleted_at: Scalars['Int']['output'];
  expires_in: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  landing_date: Scalars['Int']['output'];
  loaded_volume: Scalars['Int']['output'];
  note_value: Scalars['Int']['output'];
  numeric_id: Scalars['Int']['output'];
  observation: Scalars['Int']['output'];
  owner_id: Scalars['Int']['output'];
  package_id: Scalars['Int']['output'];
  parent_id: Scalars['Int']['output'];
  product_id: Scalars['Int']['output'];
  product_type_id: Scalars['Int']['output'];
  product_variety_id: Scalars['Int']['output'];
  quote_limit: Scalars['Int']['output'];
  route_id: Scalars['Int']['output'];
  shipment_date: Scalars['Int']['output'];
  status_id: Scalars['Int']['output'];
  suggested_value: Scalars['Int']['output'];
  total_volume: Scalars['Int']['output'];
  unallocated_volume: Scalars['Int']['output'];
  unit_type: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
};

export type FreightCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']['input']>;
  allocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  creator_id?: InputMaybe<Scalars['Boolean']['input']>;
  expires_in?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  landing_date?: InputMaybe<Scalars['Boolean']['input']>;
  loaded_volume?: InputMaybe<Scalars['Boolean']['input']>;
  note_value?: InputMaybe<Scalars['Boolean']['input']>;
  numeric_id?: InputMaybe<Scalars['Boolean']['input']>;
  observation?: InputMaybe<Scalars['Boolean']['input']>;
  owner_id?: InputMaybe<Scalars['Boolean']['input']>;
  package_id?: InputMaybe<Scalars['Boolean']['input']>;
  parent_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_variety_id?: InputMaybe<Scalars['Boolean']['input']>;
  quote_limit?: InputMaybe<Scalars['Boolean']['input']>;
  route_id?: InputMaybe<Scalars['Boolean']['input']>;
  shipment_date?: InputMaybe<Scalars['Boolean']['input']>;
  status_id?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_value?: InputMaybe<Scalars['Boolean']['input']>;
  total_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unallocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unit_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreightCountry = {
  __typename?: 'FreightCountry';
  _count: FreightCountryCount;
  address?: Maybe<Array<FreightAddress>>;
  ddi?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
  states?: Maybe<Array<FreightState>>;
};

export type FreightCountryCount = {
  __typename?: 'FreightCountryCount';
  address: Scalars['Int']['output'];
  states: Scalars['Int']['output'];
};

export type FreightCountryOrderByWithRelationInput = {
  address?: InputMaybe<FreightAddressOrderByRelationAggregateInput>;
  ddi?: InputMaybe<SortOrder>;
  initials?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  states?: InputMaybe<FreightStateOrderByRelationAggregateInput>;
};

export type FreightCountryRelationFilter = {
  is?: InputMaybe<FreightCountryWhereInput>;
  isNot?: InputMaybe<FreightCountryWhereInput>;
};

export type FreightCountryWhereInput = {
  AND?: InputMaybe<Array<FreightCountryWhereInput>>;
  NOT?: InputMaybe<Array<FreightCountryWhereInput>>;
  OR?: InputMaybe<Array<FreightCountryWhereInput>>;
  address?: InputMaybe<FreightAddressListRelationFilter>;
  ddi?: InputMaybe<StringNullableFilter>;
  initials?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  states?: InputMaybe<FreightStateListRelationFilter>;
};

export type FreightDistrict = {
  __typename?: 'FreightDistrict';
  _count: FreightDistrictCount;
  address?: Maybe<Array<FreightAddress>>;
  city?: Maybe<FreightCity>;
  city_id: Scalars['Int']['output'];
  ddd?: Maybe<Scalars['String']['output']>;
  district_name: Scalars['String']['output'];
  district_name_without_accent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FreightState>;
  state_id: Scalars['String']['output'];
  zip_codes?: Maybe<Array<FreightZipCode>>;
};

export type FreightDistrictCount = {
  __typename?: 'FreightDistrictCount';
  address: Scalars['Int']['output'];
  zip_codes: Scalars['Int']['output'];
};

export type FreightDistrictListRelationFilter = {
  every?: InputMaybe<FreightDistrictWhereInput>;
  none?: InputMaybe<FreightDistrictWhereInput>;
  some?: InputMaybe<FreightDistrictWhereInput>;
};

export type FreightDistrictOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightDistrictOrderByWithRelationInput = {
  address?: InputMaybe<FreightAddressOrderByRelationAggregateInput>;
  city?: InputMaybe<FreightCityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrder>;
  ddd?: InputMaybe<SortOrder>;
  district_name?: InputMaybe<SortOrder>;
  district_name_without_accent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  state?: InputMaybe<FreightStateOrderByWithRelationInput>;
  state_id?: InputMaybe<SortOrder>;
  zip_codes?: InputMaybe<FreightZipCodeOrderByRelationAggregateInput>;
};

export type FreightDistrictRelationFilter = {
  is?: InputMaybe<FreightDistrictWhereInput>;
  isNot?: InputMaybe<FreightDistrictWhereInput>;
};

export type FreightDistrictWhereInput = {
  AND?: InputMaybe<Array<FreightDistrictWhereInput>>;
  NOT?: InputMaybe<Array<FreightDistrictWhereInput>>;
  OR?: InputMaybe<Array<FreightDistrictWhereInput>>;
  address?: InputMaybe<FreightAddressListRelationFilter>;
  city?: InputMaybe<FreightCityRelationFilter>;
  city_id?: InputMaybe<IntFilter>;
  ddd?: InputMaybe<StringNullableFilter>;
  district_name?: InputMaybe<StringFilter>;
  district_name_without_accent?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<FreightStateRelationFilter>;
  state_id?: InputMaybe<StringFilter>;
  zip_codes?: InputMaybe<FreightZipCodeListRelationFilter>;
};

export enum FreightDocumentTypeEnum {
  Cnpj = 'CNPJ',
  Cpf = 'CPF'
}

export enum FreightFunctionEnum {
  Carrier = 'CARRIER',
  Shipper = 'SHIPPER'
}

export type FreightListRelationFilter = {
  every?: InputMaybe<FreightWhereInput>;
  none?: InputMaybe<FreightWhereInput>;
  some?: InputMaybe<FreightWhereInput>;
};

export type FreightMaxAggregate = {
  __typename?: 'FreightMaxAggregate';
  allocated_volume?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creator_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expires_in?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  landing_date?: Maybe<Scalars['DateTime']['output']>;
  loaded_volume?: Maybe<Scalars['Int']['output']>;
  note_value?: Maybe<Scalars['Int']['output']>;
  numeric_id?: Maybe<Scalars['Int']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  package_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  product_type_id?: Maybe<Scalars['String']['output']>;
  product_variety_id?: Maybe<Scalars['String']['output']>;
  quote_limit?: Maybe<Scalars['DateTime']['output']>;
  route_id?: Maybe<Scalars['String']['output']>;
  shipment_date?: Maybe<Scalars['DateTime']['output']>;
  status_id?: Maybe<Scalars['String']['output']>;
  suggested_value?: Maybe<Scalars['Int']['output']>;
  total_volume?: Maybe<Scalars['Int']['output']>;
  unallocated_volume?: Maybe<Scalars['Int']['output']>;
  unit_type?: Maybe<UnitTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FreightMaxAggregateInput = {
  allocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  creator_id?: InputMaybe<Scalars['Boolean']['input']>;
  expires_in?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  landing_date?: InputMaybe<Scalars['Boolean']['input']>;
  loaded_volume?: InputMaybe<Scalars['Boolean']['input']>;
  note_value?: InputMaybe<Scalars['Boolean']['input']>;
  numeric_id?: InputMaybe<Scalars['Boolean']['input']>;
  observation?: InputMaybe<Scalars['Boolean']['input']>;
  owner_id?: InputMaybe<Scalars['Boolean']['input']>;
  package_id?: InputMaybe<Scalars['Boolean']['input']>;
  parent_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_variety_id?: InputMaybe<Scalars['Boolean']['input']>;
  quote_limit?: InputMaybe<Scalars['Boolean']['input']>;
  route_id?: InputMaybe<Scalars['Boolean']['input']>;
  shipment_date?: InputMaybe<Scalars['Boolean']['input']>;
  status_id?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_value?: InputMaybe<Scalars['Boolean']['input']>;
  total_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unallocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unit_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreightMinAggregate = {
  __typename?: 'FreightMinAggregate';
  allocated_volume?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creator_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expires_in?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  landing_date?: Maybe<Scalars['DateTime']['output']>;
  loaded_volume?: Maybe<Scalars['Int']['output']>;
  note_value?: Maybe<Scalars['Int']['output']>;
  numeric_id?: Maybe<Scalars['Int']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  package_id?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  product_type_id?: Maybe<Scalars['String']['output']>;
  product_variety_id?: Maybe<Scalars['String']['output']>;
  quote_limit?: Maybe<Scalars['DateTime']['output']>;
  route_id?: Maybe<Scalars['String']['output']>;
  shipment_date?: Maybe<Scalars['DateTime']['output']>;
  status_id?: Maybe<Scalars['String']['output']>;
  suggested_value?: Maybe<Scalars['Int']['output']>;
  total_volume?: Maybe<Scalars['Int']['output']>;
  unallocated_volume?: Maybe<Scalars['Int']['output']>;
  unit_type?: Maybe<UnitTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FreightMinAggregateInput = {
  allocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  creator_id?: InputMaybe<Scalars['Boolean']['input']>;
  expires_in?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  landing_date?: InputMaybe<Scalars['Boolean']['input']>;
  loaded_volume?: InputMaybe<Scalars['Boolean']['input']>;
  note_value?: InputMaybe<Scalars['Boolean']['input']>;
  numeric_id?: InputMaybe<Scalars['Boolean']['input']>;
  observation?: InputMaybe<Scalars['Boolean']['input']>;
  owner_id?: InputMaybe<Scalars['Boolean']['input']>;
  package_id?: InputMaybe<Scalars['Boolean']['input']>;
  parent_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  product_variety_id?: InputMaybe<Scalars['Boolean']['input']>;
  quote_limit?: InputMaybe<Scalars['Boolean']['input']>;
  route_id?: InputMaybe<Scalars['Boolean']['input']>;
  shipment_date?: InputMaybe<Scalars['Boolean']['input']>;
  status_id?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_value?: InputMaybe<Scalars['Boolean']['input']>;
  total_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unallocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unit_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreightOperationArea = {
  __typename?: 'FreightOperationArea';
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  state: FreightState;
  state_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FreightOperationAreaListRelationFilter = {
  every?: InputMaybe<FreightOperationAreaWhereInput>;
  none?: InputMaybe<FreightOperationAreaWhereInput>;
  some?: InputMaybe<FreightOperationAreaWhereInput>;
};

export type FreightOperationAreaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightOperationAreaWhereInput = {
  AND?: InputMaybe<Array<FreightOperationAreaWhereInput>>;
  NOT?: InputMaybe<Array<FreightOperationAreaWhereInput>>;
  OR?: InputMaybe<Array<FreightOperationAreaWhereInput>>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  state_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type FreightOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightOrderByWithRelationInput = {
  allocated_volume?: InputMaybe<SortOrder>;
  child?: InputMaybe<FreightOrderByWithRelationInput>;
  created_at?: InputMaybe<SortOrder>;
  creator?: InputMaybe<FreightUserOrderByWithRelationInput>;
  creator_id?: InputMaybe<SortOrder>;
  expires_in?: InputMaybe<SortOrder>;
  freight_ratings?: InputMaybe<FreightRatingOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  landing_date?: InputMaybe<SortOrder>;
  loaded_volume?: InputMaybe<SortOrder>;
  note_value?: InputMaybe<SortOrder>;
  numeric_id?: InputMaybe<SortOrder>;
  observation?: InputMaybe<SortOrder>;
  owner?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  owner_id?: InputMaybe<SortOrder>;
  package_id?: InputMaybe<SortOrder>;
  packing?: InputMaybe<PackingOrderByWithRelationInput>;
  parent?: InputMaybe<FreightOrderByWithRelationInput>;
  parent_id?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  product_id?: InputMaybe<SortOrder>;
  product_type?: InputMaybe<ProductTypeOrderByWithRelationInput>;
  product_type_id?: InputMaybe<SortOrder>;
  product_variety?: InputMaybe<VarietyOrderByWithRelationInput>;
  product_variety_id?: InputMaybe<SortOrder>;
  quotations?: InputMaybe<QuotationOrderByRelationAggregateInput>;
  quote_limit?: InputMaybe<SortOrder>;
  refusals?: InputMaybe<RefusalOrderByRelationAggregateInput>;
  route?: InputMaybe<RouteOrderByWithRelationInput>;
  route_id?: InputMaybe<SortOrder>;
  shipment_date?: InputMaybe<SortOrder>;
  status?: InputMaybe<FreightStatusOrderByWithRelationInput>;
  status_id?: InputMaybe<SortOrder>;
  suggested_value?: InputMaybe<SortOrder>;
  total_volume?: InputMaybe<SortOrder>;
  unallocated_volume?: InputMaybe<SortOrder>;
  unit_type?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type FreightRating = {
  __typename?: 'FreightRating';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  evaluator: FreightCompany;
  evaluator_id: Scalars['String']['output'];
  freight: Freight;
  freight_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rated: FreightCompany;
  rated_id: Scalars['String']['output'];
  reason?: Maybe<RatingReason>;
  reason_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type FreightRatingListRelationFilter = {
  every?: InputMaybe<FreightRatingWhereInput>;
  none?: InputMaybe<FreightRatingWhereInput>;
  some?: InputMaybe<FreightRatingWhereInput>;
};

export type FreightRatingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightRatingOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  evaluator?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  evaluator_id?: InputMaybe<SortOrder>;
  freight?: InputMaybe<FreightOrderByWithRelationInput>;
  freight_id?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rated?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  rated_id?: InputMaybe<SortOrder>;
  reason?: InputMaybe<RatingReasonOrderByWithRelationInput>;
  reason_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type FreightRatingWhereInput = {
  AND?: InputMaybe<Array<FreightRatingWhereInput>>;
  NOT?: InputMaybe<Array<FreightRatingWhereInput>>;
  OR?: InputMaybe<Array<FreightRatingWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  evaluator?: InputMaybe<FreightCompanyRelationFilter>;
  evaluator_id?: InputMaybe<UuidFilter>;
  freight?: InputMaybe<FreightRelationFilter>;
  freight_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  rated?: InputMaybe<FreightCompanyRelationFilter>;
  rated_id?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<RatingReasonRelationFilter>;
  reason_id?: InputMaybe<UuidNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<IntFilter>;
};

export type FreightRelationFilter = {
  is?: InputMaybe<FreightWhereInput>;
  isNot?: InputMaybe<FreightWhereInput>;
};

export type FreightState = {
  __typename?: 'FreightState';
  _count: FreightStateCount;
  address?: Maybe<Array<FreightAddress>>;
  capital?: Maybe<Scalars['String']['output']>;
  capital_without_accent?: Maybe<Scalars['String']['output']>;
  cities?: Maybe<Array<FreightCity>>;
  country?: Maybe<FreightCountry>;
  country_id?: Maybe<Scalars['String']['output']>;
  districts?: Maybe<Array<FreightDistrict>>;
  final_zip_code?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  operationArea?: Maybe<Array<FreightOperationArea>>;
  place_routes?: Maybe<Array<PlaceRoute>>;
  places?: Maybe<Array<Place>>;
  region?: Maybe<Scalars['String']['output']>;
  region_without_accent?: Maybe<Scalars['String']['output']>;
  starting_zip_code?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_name_without_accent?: Maybe<Scalars['String']['output']>;
  zip_codes?: Maybe<Array<FreightZipCode>>;
};

export type FreightStateCount = {
  __typename?: 'FreightStateCount';
  address: Scalars['Int']['output'];
  cities: Scalars['Int']['output'];
  districts: Scalars['Int']['output'];
  operationArea: Scalars['Int']['output'];
  place_routes: Scalars['Int']['output'];
  places: Scalars['Int']['output'];
  zip_codes: Scalars['Int']['output'];
};

export type FreightStateListRelationFilter = {
  every?: InputMaybe<FreightStateWhereInput>;
  none?: InputMaybe<FreightStateWhereInput>;
  some?: InputMaybe<FreightStateWhereInput>;
};

export type FreightStateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightStateOrderByWithRelationInput = {
  address?: InputMaybe<FreightAddressOrderByRelationAggregateInput>;
  capital?: InputMaybe<SortOrder>;
  capital_without_accent?: InputMaybe<SortOrder>;
  cities?: InputMaybe<FreightCityOrderByRelationAggregateInput>;
  country?: InputMaybe<FreightCountryOrderByWithRelationInput>;
  country_id?: InputMaybe<SortOrder>;
  districts?: InputMaybe<FreightDistrictOrderByRelationAggregateInput>;
  final_zip_code?: InputMaybe<SortOrder>;
  initials?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  operationArea?: InputMaybe<FreightOperationAreaOrderByRelationAggregateInput>;
  places?: InputMaybe<PlaceOrderByRelationAggregateInput>;
  region?: InputMaybe<SortOrder>;
  region_without_accent?: InputMaybe<SortOrder>;
  starting_zip_code?: InputMaybe<SortOrder>;
  state_name?: InputMaybe<SortOrder>;
  state_name_without_accent?: InputMaybe<SortOrder>;
  zip_codes?: InputMaybe<FreightZipCodeOrderByRelationAggregateInput>;
};

export type FreightStateRelationFilter = {
  is?: InputMaybe<FreightStateWhereInput>;
  isNot?: InputMaybe<FreightStateWhereInput>;
};

export type FreightStateWhereInput = {
  AND?: InputMaybe<Array<FreightStateWhereInput>>;
  NOT?: InputMaybe<Array<FreightStateWhereInput>>;
  OR?: InputMaybe<Array<FreightStateWhereInput>>;
  address?: InputMaybe<FreightAddressListRelationFilter>;
  capital?: InputMaybe<StringNullableFilter>;
  capital_without_accent?: InputMaybe<StringNullableFilter>;
  cities?: InputMaybe<FreightCityListRelationFilter>;
  country?: InputMaybe<FreightCountryRelationFilter>;
  country_id?: InputMaybe<StringNullableFilter>;
  districts?: InputMaybe<FreightDistrictListRelationFilter>;
  final_zip_code?: InputMaybe<StringNullableFilter>;
  initials?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  operationArea?: InputMaybe<FreightOperationAreaListRelationFilter>;
  places?: InputMaybe<PlaceListRelationFilter>;
  region?: InputMaybe<StringNullableFilter>;
  region_without_accent?: InputMaybe<StringNullableFilter>;
  starting_zip_code?: InputMaybe<StringNullableFilter>;
  state_name?: InputMaybe<StringNullableFilter>;
  state_name_without_accent?: InputMaybe<StringNullableFilter>;
  zip_codes?: InputMaybe<FreightZipCodeListRelationFilter>;
};

export type FreightStatus = {
  __typename?: 'FreightStatus';
  _count: FreightStatusCount;
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  freights?: Maybe<Array<Freight>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FreightStatusCount = {
  __typename?: 'FreightStatusCount';
  freights: Scalars['Int']['output'];
};

export type FreightStatusOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type FreightStatusRelationFilter = {
  is?: InputMaybe<FreightStatusWhereInput>;
  isNot?: InputMaybe<FreightStatusWhereInput>;
};

export type FreightStatusWhereInput = {
  AND?: InputMaybe<Array<FreightStatusWhereInput>>;
  NOT?: InputMaybe<Array<FreightStatusWhereInput>>;
  OR?: InputMaybe<Array<FreightStatusWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type FreightSumAggregate = {
  __typename?: 'FreightSumAggregate';
  allocated_volume?: Maybe<Scalars['Int']['output']>;
  loaded_volume?: Maybe<Scalars['Int']['output']>;
  note_value?: Maybe<Scalars['Int']['output']>;
  numeric_id?: Maybe<Scalars['Int']['output']>;
  suggested_value?: Maybe<Scalars['Int']['output']>;
  total_volume?: Maybe<Scalars['Int']['output']>;
  unallocated_volume?: Maybe<Scalars['Int']['output']>;
};

export type FreightSumAggregateInput = {
  allocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
  loaded_volume?: InputMaybe<Scalars['Boolean']['input']>;
  note_value?: InputMaybe<Scalars['Boolean']['input']>;
  numeric_id?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_value?: InputMaybe<Scalars['Boolean']['input']>;
  total_volume?: InputMaybe<Scalars['Boolean']['input']>;
  unallocated_volume?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreightUser = {
  __typename?: 'FreightUser';
  _count: FreightUserCount;
  active: Scalars['Boolean']['output'];
  companies?: Maybe<Array<FreightUserHasCompany>>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  freights?: Maybe<Array<Freight>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quotations?: Maybe<Array<Quotation>>;
  reference_user_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FreightUserCount = {
  __typename?: 'FreightUserCount';
  companies: Scalars['Int']['output'];
  freightAttachments: Scalars['Int']['output'];
  freights: Scalars['Int']['output'];
  quotations: Scalars['Int']['output'];
};

export type FreightUserGraphQlResponse = {
  __typename?: 'FreightUserGraphQLResponse';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reference_user_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FreightUserHasCompany = {
  __typename?: 'FreightUserHasCompany';
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  user: FreightUser;
  user_id: Scalars['String']['output'];
};

export type FreightUserHasCompanyListRelationFilter = {
  every?: InputMaybe<FreightUserHasCompanyWhereInput>;
  none?: InputMaybe<FreightUserHasCompanyWhereInput>;
  some?: InputMaybe<FreightUserHasCompanyWhereInput>;
};

export type FreightUserHasCompanyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightUserHasCompanyWhereInput = {
  AND?: InputMaybe<Array<FreightUserHasCompanyWhereInput>>;
  NOT?: InputMaybe<Array<FreightUserHasCompanyWhereInput>>;
  OR?: InputMaybe<Array<FreightUserHasCompanyWhereInput>>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  user?: InputMaybe<FreightUserRelationFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type FreightUserOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  companies?: InputMaybe<FreightUserHasCompanyOrderByRelationAggregateInput>;
  created_at?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  freights?: InputMaybe<FreightOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  quotations?: InputMaybe<QuotationOrderByRelationAggregateInput>;
  reference_user_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type FreightUserRelationFilter = {
  is?: InputMaybe<FreightUserWhereInput>;
  isNot?: InputMaybe<FreightUserWhereInput>;
};

export type FreightUserWhereInput = {
  AND?: InputMaybe<Array<FreightUserWhereInput>>;
  NOT?: InputMaybe<Array<FreightUserWhereInput>>;
  OR?: InputMaybe<Array<FreightUserWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  companies?: InputMaybe<FreightUserHasCompanyListRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  freights?: InputMaybe<FreightListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  quotations?: InputMaybe<QuotationListRelationFilter>;
  reference_user_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type FreightWhereInput = {
  AND?: InputMaybe<Array<FreightWhereInput>>;
  NOT?: InputMaybe<Array<FreightWhereInput>>;
  OR?: InputMaybe<Array<FreightWhereInput>>;
  allocated_volume?: InputMaybe<IntFilter>;
  child?: InputMaybe<FreightRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<FreightUserRelationFilter>;
  creator_id?: InputMaybe<UuidFilter>;
  expires_in?: InputMaybe<DateTimeNullableFilter>;
  freight_ratings?: InputMaybe<FreightRatingListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  landing_date?: InputMaybe<DateTimeFilter>;
  loaded_volume?: InputMaybe<IntFilter>;
  note_value?: InputMaybe<IntNullableFilter>;
  numeric_id?: InputMaybe<IntFilter>;
  observation?: InputMaybe<StringNullableFilter>;
  owner?: InputMaybe<FreightCompanyRelationFilter>;
  owner_id?: InputMaybe<UuidFilter>;
  package_id?: InputMaybe<UuidFilter>;
  packing?: InputMaybe<PackingRelationFilter>;
  parent?: InputMaybe<FreightRelationFilter>;
  parent_id?: InputMaybe<UuidNullableFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  product_id?: InputMaybe<UuidFilter>;
  product_type?: InputMaybe<ProductTypeRelationFilter>;
  product_type_id?: InputMaybe<UuidFilter>;
  product_variety?: InputMaybe<VarietyRelationFilter>;
  product_variety_id?: InputMaybe<UuidNullableFilter>;
  quotations?: InputMaybe<QuotationListRelationFilter>;
  quote_limit?: InputMaybe<DateTimeFilter>;
  refusals?: InputMaybe<RefusalListRelationFilter>;
  route?: InputMaybe<RouteRelationFilter>;
  route_id?: InputMaybe<UuidFilter>;
  shipment_date?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<FreightStatusRelationFilter>;
  status_id?: InputMaybe<UuidFilter>;
  suggested_value?: InputMaybe<IntNullableFilter>;
  total_volume?: InputMaybe<IntFilter>;
  unallocated_volume?: InputMaybe<IntFilter>;
  unit_type?: InputMaybe<EnumUnitTypeEnumFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type FreightZipCode = {
  __typename?: 'FreightZipCode';
  _count: FreightZipCodeCount;
  active: Scalars['Int']['output'];
  address?: Maybe<Array<FreightAddress>>;
  city?: Maybe<FreightCity>;
  city_id?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<FreightDistrict>;
  district_id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FreightState>;
  state_id?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_name_without_accent?: Maybe<Scalars['String']['output']>;
  street_without_accent?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_without_accent?: Maybe<Scalars['String']['output']>;
  zip_code: Scalars['String']['output'];
};

export type FreightZipCodeCount = {
  __typename?: 'FreightZipCodeCount';
  address: Scalars['Int']['output'];
};

export type FreightZipCodeListRelationFilter = {
  every?: InputMaybe<FreightZipCodeWhereInput>;
  none?: InputMaybe<FreightZipCodeWhereInput>;
  some?: InputMaybe<FreightZipCodeWhereInput>;
};

export type FreightZipCodeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FreightZipCodeOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  address?: InputMaybe<FreightAddressOrderByRelationAggregateInput>;
  city?: InputMaybe<FreightCityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrder>;
  district?: InputMaybe<FreightDistrictOrderByWithRelationInput>;
  district_id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  state?: InputMaybe<FreightStateOrderByWithRelationInput>;
  state_id?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  street_name?: InputMaybe<SortOrder>;
  street_name_without_accent?: InputMaybe<SortOrder>;
  street_without_accent?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  type_without_accent?: InputMaybe<SortOrder>;
  zip_code?: InputMaybe<SortOrder>;
};

export type FreightZipCodeRelationFilter = {
  is?: InputMaybe<FreightZipCodeWhereInput>;
  isNot?: InputMaybe<FreightZipCodeWhereInput>;
};

export type FreightZipCodeWhereInput = {
  AND?: InputMaybe<Array<FreightZipCodeWhereInput>>;
  NOT?: InputMaybe<Array<FreightZipCodeWhereInput>>;
  OR?: InputMaybe<Array<FreightZipCodeWhereInput>>;
  active?: InputMaybe<IntFilter>;
  address?: InputMaybe<FreightAddressListRelationFilter>;
  city?: InputMaybe<FreightCityRelationFilter>;
  city_id?: InputMaybe<IntNullableFilter>;
  district?: InputMaybe<FreightDistrictRelationFilter>;
  district_id?: InputMaybe<IntNullableFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<FreightStateRelationFilter>;
  state_id?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  street_name?: InputMaybe<StringNullableFilter>;
  street_name_without_accent?: InputMaybe<StringNullableFilter>;
  street_without_accent?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  type_without_accent?: InputMaybe<StringNullableFilter>;
  zip_code?: InputMaybe<StringFilter>;
};

export type Freights = {
  __typename?: 'Freights';
  data: Array<Freight>;
  length: Scalars['Int']['output'];
};

export enum FunctionEnum {
  Carrier = 'CARRIER',
  Shipper = 'SHIPPER'
}

export type GetUserRolesInput = {
  token: Scalars['String']['input'];
};

export type Group = {
  __typename?: 'Group';
  _count: GroupCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<CompanyInGroup>>;
  name: Scalars['String']['output'];
  owner: FreightCompany;
  owner_id: Scalars['String']['output'];
  related_freights?: Maybe<Array<GroupFreight>>;
  updated_at: Scalars['DateTime']['output'];
};

export type GroupCount = {
  __typename?: 'GroupCount';
  members: Scalars['Int']['output'];
  related_freights: Scalars['Int']['output'];
};

export type GroupFreight = {
  __typename?: 'GroupFreight';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  freight: Freight;
  freight_id: Scalars['String']['output'];
  group: Group;
  group_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type GroupListRelationFilter = {
  every?: InputMaybe<GroupWhereInput>;
  none?: InputMaybe<GroupWhereInput>;
  some?: InputMaybe<GroupWhereInput>;
};

export type GroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GroupOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  members?: InputMaybe<CompanyInGroupOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  owner_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type GroupWhereInput = {
  AND?: InputMaybe<Array<GroupWhereInput>>;
  NOT?: InputMaybe<Array<GroupWhereInput>>;
  OR?: InputMaybe<Array<GroupWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  members?: InputMaybe<CompanyInGroupListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<FreightCompanyRelationFilter>;
  owner_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type Groups = {
  __typename?: 'Groups';
  data: Array<Group>;
  length: Scalars['Int']['output'];
};

export type HasSuccess = {
  __typename?: 'HasSuccess';
  has_success: Scalars['Boolean']['output'];
};

export type HideFreightInput = {
  carrier_id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  freight_id: Scalars['String']['input'];
  reason_id: Scalars['String']['input'];
};

export type HireQuotationsInput = {
  freight_id: Scalars['String']['input'];
  quotations: Array<QuotationVolumeInput>;
  shipper_id: Scalars['String']['input'];
};

export type IdDto = {
  id: Scalars['String']['input'];
};

export type IdGraphQlResponse = {
  __typename?: 'IdGraphQLResponse';
  id: Scalars['ID']['output'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LinkRoleInput = {
  new_role: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type LinkUserToCompanyInput = {
  company_id: Scalars['String']['input'];
  role_name: DefaultRolesEnum;
  user_id: Scalars['String']['input'];
};

export type LoadInput = {
  confirmation_id: Scalars['String']['input'];
  driver_id: Scalars['String']['input'];
  owner_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
};

export type Login = {
  __typename?: 'Login';
  access_token: Scalars['String']['output'];
  permissions?: Maybe<Array<CachePermission>>;
  refresh_token: Scalars['String']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

export type LoginInput = {
  credential: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Logo = {
  __typename?: 'Logo';
  url: Scalars['String']['output'];
};

export type ManyIdsGraphQlResponse = {
  __typename?: 'ManyIdsGraphQLResponse';
  data: Array<IdGraphQlResponse>;
  length: Scalars['Int']['output'];
};

export type Module = {
  __typename?: 'Module';
  _count: ModuleCount;
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_permissions?: Maybe<Array<UserPermission>>;
};

export type ModuleCount = {
  __typename?: 'ModuleCount';
  user_permissions: Scalars['Int']['output'];
};

export type ModuleOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type ModuleRelationFilter = {
  is?: InputMaybe<ModuleWhereInput>;
  isNot?: InputMaybe<ModuleWhereInput>;
};

export type ModuleWhereInput = {
  AND?: InputMaybe<Array<ModuleWhereInput>>;
  NOT?: InputMaybe<Array<ModuleWhereInput>>;
  OR?: InputMaybe<Array<ModuleWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export enum MoveTypeEnum {
  Delivery = 'DELIVERY',
  Withdrawal = 'WITHDRAWAL'
}

export type Mutation = {
  __typename?: 'Mutation';
  AbandonQuotation: Quotation;
  ActivateUser: HasSuccess;
  ApproveCompany: CompanyHasStatus;
  AttachFileOnFreight: FreightAttachmentGraphQlResponse;
  CancelFreight: Freight;
  CancelQuotation: Quotation;
  ChangeCompanyStatus: CompanyHasStatus;
  ComplementCompany: Company;
  CreateCompany: Company;
  CreateFreight: Freight;
  CreateFreightRating: FreightRating;
  CreateGroup: Group;
  CreateManyCancellationReasons: Array<CancellationReason>;
  CreateManyModules: Array<Module>;
  CreateManyPackings: PackingsGraphQlOutput;
  CreateManyPermissionTemplates: HasSuccess;
  CreateManyProductTypes: Array<ProductType>;
  CreateManyProductTypesHasPackings: Array<ProductTypeHasPacking>;
  CreateManyProducts: ProductsGraphQlOutput;
  CreateManyRatingReasons: Array<RatingReason>;
  CreateManyRefusalReasons: Array<RefusalReason>;
  CreateManyUserHasPermissions: Array<UserHasPermission>;
  CreateManyUserPermissions: HasSuccess;
  CreateManyVarieties: VarietiesGraphQlOutput;
  CreateMissingFreight: Freight;
  CreatePlace: Place;
  CreateQuotation: Quotation;
  CreateQuotationConfirmations: Array<QuotationConfirmation>;
  CreateQuotationRating: QuotationRating;
  CreateRoute: Route;
  CreateTheme: ThemeGraphQlOutput;
  CreateTruckerUser: UserModel;
  CreateUser: CreateUserResponse;
  CreateUserInternally: FindUserGraphQlOutput;
  CreateVehicleType: VehicleType;
  DelegateQuotation: Quotation;
  DeleteGroup: Group;
  DeleteLogo: DeleteUrlResponse;
  DeleteManyCancellationReasons: Array<CancellationReason>;
  DeleteManyPackings: PackingsGraphQlOutput;
  DeleteManyProductTypes: Array<ProductType>;
  DeleteManyProductTypesHasPackings: Array<ProductTypeHasPacking>;
  DeleteManyProducts: ProductsGraphQlOutput;
  DeleteManyRatingReasons: Array<RatingReason>;
  DeleteManyRefusalReasons: Array<RefusalReason>;
  DeleteManyVarieties: ManyIdsGraphQlResponse;
  DeletePermissionTemplate: HasSuccess;
  DeletePlace: Place;
  DeletePolicy: DeleteUrlResponse;
  DeletePolicySignUp: DeleteUrlResponse;
  DeleteQuotationConfirmations: Array<QuotationConfirmation>;
  DeleteRoute: Route;
  DeleteTheme: DeleteThemeGraphQlOutput;
  DeleteTruckerUser: AuthUserModel;
  DeleteVehicleType: VehicleType;
  DetachOneFileFromFreight: DetachOneFileFromFreightGraphQlResponse;
  FinishQuotation: Quotation;
  HideFreight: Refusal;
  HireQuotations: Freight;
  LinkRole: UserHasRole;
  LinkUserToCompany: FindUserGraphQlOutput;
  Load: Quotation;
  Login: Login;
  RecoveryPassword: HasSuccess;
  RectifyCompany: Company;
  RefreshToken: Login;
  ReproachCompany: Reproach;
  SendRecoveryCode: HasSuccess;
  SendValidationEmail: SendValidationEmailResponse;
  UnlinkRole: UserHasRole;
  UnlinkUserCompany: FindUserGraphQlOutput;
  Unload: Quotation;
  UpdateCommissionPayment: Quotation;
  UpdateCompanySettings: CompanySettingsGraphQlOutput;
  UpdateGroup: Group;
  UpdateManyCancellationReasons: Array<CancellationReason>;
  UpdateManyPackings: PackingsGraphQlOutput;
  UpdateManyProducts: ProductsGraphQlOutput;
  UpdateManyRatingReasons: Array<RatingReason>;
  UpdateManyRefusalReasons: Array<RefusalReason>;
  UpdateManyUserHasPermissions: Array<UserHasPermission>;
  UpdateManyUserPermissions: HasSuccess;
  UpdateModule: Module;
  UpdatePermissionTemplate: HasSuccess;
  UpdatePlace: Place;
  UpdateQuotationConfirmations: Array<QuotationConfirmation>;
  UpdateTheme: ThemeGraphQlOutput;
  UploadLogo: Logo;
  UploadPolicy: Policy;
  UploadPolicyWithoutStream: Policy;
  WaiverQuotation: Quotation;
};


export type MutationAbandonQuotationArgs = {
  input: AbandonQuotationInput;
};


export type MutationActivateUserArgs = {
  input: ActivateInternalUserInput;
};


export type MutationApproveCompanyArgs = {
  input: ApproveCompanyInput;
};


export type MutationAttachFileOnFreightArgs = {
  file: Scalars['Upload']['input'];
  input: AttachFileOnFreightGraphQlRequest;
};


export type MutationCancelFreightArgs = {
  input: CancelFreightInput;
};


export type MutationCancelQuotationArgs = {
  input: CancelQuotationInput;
};


export type MutationChangeCompanyStatusArgs = {
  input: ChangeCompanyStatusInput;
};


export type MutationComplementCompanyArgs = {
  input: ComplementCompanyDto;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyDto;
};


export type MutationCreateFreightArgs = {
  input: CreateFreightInput;
};


export type MutationCreateFreightRatingArgs = {
  input: CreateFreightRatingInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateManyCancellationReasonsArgs = {
  input: CreateManyCancellationReasonInput;
};


export type MutationCreateManyModulesArgs = {
  input: CreateManyModulesInput;
};


export type MutationCreateManyPackingsArgs = {
  input: CreateManyPackingsGraphQlInput;
};


export type MutationCreateManyPermissionTemplatesArgs = {
  input: CreateManyPermissionTemplatesInput;
};


export type MutationCreateManyProductTypesArgs = {
  input: CreateManyProductTypesInput;
};


export type MutationCreateManyProductTypesHasPackingsArgs = {
  input: CreateManyProductTypesHasPackingsInput;
};


export type MutationCreateManyProductsArgs = {
  input: CreateManyProductsInput;
};


export type MutationCreateManyRatingReasonsArgs = {
  data: Array<CreateRatingReasonInput>;
};


export type MutationCreateManyRefusalReasonsArgs = {
  input: CreateRefusalReasonsInput;
};


export type MutationCreateManyUserHasPermissionsArgs = {
  input: CreateManyUserHasPermissionsInput;
};


export type MutationCreateManyUserPermissionsArgs = {
  input: CreateManyUserPermissionsInput;
};


export type MutationCreateManyVarietiesArgs = {
  input: CreateManyVarietiesGraphQlInput;
};


export type MutationCreateMissingFreightArgs = {
  input: CreateMissingFreightInput;
};


export type MutationCreatePlaceArgs = {
  input: CreatePlaceInput;
};


export type MutationCreateQuotationArgs = {
  input: CreateQuotationInput;
};


export type MutationCreateQuotationConfirmationsArgs = {
  input: CreateQuotationConfirmationsInput;
};


export type MutationCreateQuotationRatingArgs = {
  input: CreateQuotationRatingInput;
};


export type MutationCreateRouteArgs = {
  input: CreateRouteInput;
};


export type MutationCreateThemeArgs = {
  input: CreateThemeGraphQlInput;
};


export type MutationCreateTruckerUserArgs = {
  input: CreateTruckerUserInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserInternallyArgs = {
  input: CreateUserInternallyInput;
};


export type MutationCreateVehicleTypeArgs = {
  input: CreateVehicleTypeInput;
};


export type MutationDelegateQuotationArgs = {
  input: DelegateQuotationInput;
};


export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type MutationDeleteLogoArgs = {
  input: DeleteLogoDto;
};


export type MutationDeleteManyCancellationReasonsArgs = {
  input: DeleteManyCancellationReasonInput;
};


export type MutationDeleteManyPackingsArgs = {
  input: DeleteManyPackingsGraphQlInput;
};


export type MutationDeleteManyProductTypesArgs = {
  input: DeleteManyProductTypesInput;
};


export type MutationDeleteManyProductTypesHasPackingsArgs = {
  input: DeleteManyProductTypesHasPackingsInput;
};


export type MutationDeleteManyProductsArgs = {
  input: DeleteManyProductsInput;
};


export type MutationDeleteManyRatingReasonsArgs = {
  data: Array<DeleteRatingReason>;
};


export type MutationDeleteManyRefusalReasonsArgs = {
  input: DeleteRefusalReasonsInput;
};


export type MutationDeleteManyVarietiesArgs = {
  input: DeleteManyVarietiesGraphQlInput;
};


export type MutationDeletePermissionTemplateArgs = {
  input: DeletePermissionTemplateInput;
};


export type MutationDeletePlaceArgs = {
  input: DeletePlaceInput;
};


export type MutationDeletePolicyArgs = {
  input: DeletePolicyDto;
};


export type MutationDeletePolicySignUpArgs = {
  input: DeletePolicyDto;
};


export type MutationDeleteQuotationConfirmationsArgs = {
  input: DeleteQuotationConfirmationsInput;
};


export type MutationDeleteRouteArgs = {
  input: DeleteRouteInput;
};


export type MutationDeleteThemeArgs = {
  theme_id: Scalars['String']['input'];
};


export type MutationDeleteTruckerUserArgs = {
  user_id: Scalars['String']['input'];
};


export type MutationDeleteVehicleTypeArgs = {
  input: DeleteVehicleTypeInput;
};


export type MutationDetachOneFileFromFreightArgs = {
  input: DetachOneFileFromFreightGraphQlRequest;
};


export type MutationFinishQuotationArgs = {
  input: FinishQuotationInput;
};


export type MutationHideFreightArgs = {
  input: HideFreightInput;
};


export type MutationHireQuotationsArgs = {
  input: HireQuotationsInput;
};


export type MutationLinkRoleArgs = {
  input: LinkRoleInput;
};


export type MutationLinkUserToCompanyArgs = {
  input: LinkUserToCompanyInput;
};


export type MutationLoadArgs = {
  file: Scalars['Upload']['input'];
  input: LoadInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRecoveryPasswordArgs = {
  input: RecoveryPasswordInput;
};


export type MutationRectifyCompanyArgs = {
  input: RectifyCompanyInput;
};


export type MutationReproachCompanyArgs = {
  input: ReproachCompanyInput;
};


export type MutationSendRecoveryCodeArgs = {
  input: SendRecoveryCodeInput;
};


export type MutationSendValidationEmailArgs = {
  input: SendValidationEmailInput;
};


export type MutationUnlinkRoleArgs = {
  input: UnlinkRoleInput;
};


export type MutationUnlinkUserCompanyArgs = {
  input: RemoveUserInternallyInput;
};


export type MutationUnloadArgs = {
  input: UnloadInput;
};


export type MutationUpdateCommissionPaymentArgs = {
  input: UpdateCommissionPaymentInput;
};


export type MutationUpdateCompanySettingsArgs = {
  input: UpdateCompanySettingsGraphQlInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateManyCancellationReasonsArgs = {
  input: UpdateManyCancellationReasonInput;
};


export type MutationUpdateManyPackingsArgs = {
  input: UpdateManyPackingsGraphQlInput;
};


export type MutationUpdateManyProductsArgs = {
  input: UpdateManyProductsInput;
};


export type MutationUpdateManyRatingReasonsArgs = {
  data: Array<UpdateRatingReasonInput>;
};


export type MutationUpdateManyRefusalReasonsArgs = {
  input: UpdateRefusalReasonsInput;
};


export type MutationUpdateManyUserHasPermissionsArgs = {
  input: UpdateManyUserHasPermissionsInput;
};


export type MutationUpdateManyUserPermissionsArgs = {
  input: UpdateManyUserPermissionsInput;
};


export type MutationUpdateModuleArgs = {
  input: UpdateModuleInput;
};


export type MutationUpdatePermissionTemplateArgs = {
  input: UpdatePermissionTemplateInput;
};


export type MutationUpdatePlaceArgs = {
  input: UpdatePlaceInput;
};


export type MutationUpdateQuotationConfirmationsArgs = {
  input: UpdateQuotationConfirmationsInput;
};


export type MutationUpdateThemeArgs = {
  input: UpdateThemeGraphQlInput;
};


export type MutationUploadLogoArgs = {
  file: Scalars['Upload']['input'];
  input: UploadLogoInput;
};


export type MutationUploadPolicyArgs = {
  file: Scalars['Upload']['input'];
  input: PolicyInput;
};


export type MutationUploadPolicyWithoutStreamArgs = {
  file: Scalars['Upload']['input'];
  input: PolicyInput;
};


export type MutationWaiverQuotationArgs = {
  input: WaiverQuotationInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumCancellationTriggerEnumFilter = {
  equals?: InputMaybe<CancellationTriggerEnum>;
  in?: InputMaybe<Array<CancellationTriggerEnum>>;
  not?: InputMaybe<NestedEnumCancellationTriggerEnumFilter>;
  notIn?: InputMaybe<Array<CancellationTriggerEnum>>;
};

export type NestedEnumCompanyStatusEnumFilter = {
  equals?: InputMaybe<CompanyStatusEnum>;
  in?: InputMaybe<Array<CompanyStatusEnum>>;
  not?: InputMaybe<NestedEnumCompanyStatusEnumFilter>;
  notIn?: InputMaybe<Array<CompanyStatusEnum>>;
};

export type NestedEnumCompanyTypeEnumFilter = {
  equals?: InputMaybe<CompanyTypeEnum>;
  in?: InputMaybe<Array<CompanyTypeEnum>>;
  not?: InputMaybe<NestedEnumCompanyTypeEnumFilter>;
  notIn?: InputMaybe<Array<CompanyTypeEnum>>;
};

export type NestedEnumDocumentTypeEnumFilter = {
  equals?: InputMaybe<DocumentTypeEnum>;
  in?: InputMaybe<Array<DocumentTypeEnum>>;
  not?: InputMaybe<NestedEnumDocumentTypeEnumFilter>;
  notIn?: InputMaybe<Array<DocumentTypeEnum>>;
};

export type NestedEnumFreightCompanyTypeEnumFilter = {
  equals?: InputMaybe<FreightCompanyTypeEnum>;
  in?: InputMaybe<Array<FreightCompanyTypeEnum>>;
  not?: InputMaybe<NestedEnumFreightCompanyTypeEnumFilter>;
  notIn?: InputMaybe<Array<FreightCompanyTypeEnum>>;
};

export type NestedEnumFreightDocumentTypeEnumFilter = {
  equals?: InputMaybe<FreightDocumentTypeEnum>;
  in?: InputMaybe<Array<FreightDocumentTypeEnum>>;
  not?: InputMaybe<NestedEnumFreightDocumentTypeEnumFilter>;
  notIn?: InputMaybe<Array<FreightDocumentTypeEnum>>;
};

export type NestedEnumFreightFunctionEnumFilter = {
  equals?: InputMaybe<FreightFunctionEnum>;
  in?: InputMaybe<Array<FreightFunctionEnum>>;
  not?: InputMaybe<NestedEnumFreightFunctionEnumFilter>;
  notIn?: InputMaybe<Array<FreightFunctionEnum>>;
};

export type NestedEnumFunctionEnumFilter = {
  equals?: InputMaybe<FunctionEnum>;
  in?: InputMaybe<Array<FunctionEnum>>;
  not?: InputMaybe<NestedEnumFunctionEnumFilter>;
  notIn?: InputMaybe<Array<FunctionEnum>>;
};

export type NestedEnumMoveTypeEnumFilter = {
  equals?: InputMaybe<MoveTypeEnum>;
  in?: InputMaybe<Array<MoveTypeEnum>>;
  not?: InputMaybe<NestedEnumMoveTypeEnumFilter>;
  notIn?: InputMaybe<Array<MoveTypeEnum>>;
};

export type NestedEnumRatingTriggerEnumFilter = {
  equals?: InputMaybe<RatingTriggerEnum>;
  in?: InputMaybe<Array<RatingTriggerEnum>>;
  not?: InputMaybe<NestedEnumRatingTriggerEnumFilter>;
  notIn?: InputMaybe<Array<RatingTriggerEnum>>;
};

export type NestedEnumRefusalTriggerEnumFilter = {
  equals?: InputMaybe<RefusalTriggerEnum>;
  in?: InputMaybe<Array<RefusalTriggerEnum>>;
  not?: InputMaybe<NestedEnumRefusalTriggerEnumFilter>;
  notIn?: InputMaybe<Array<RefusalTriggerEnum>>;
};

export type NestedEnumUnitMeasureEnumFilter = {
  equals?: InputMaybe<UnitMeasureEnum>;
  in?: InputMaybe<Array<UnitMeasureEnum>>;
  not?: InputMaybe<NestedEnumUnitMeasureEnumFilter>;
  notIn?: InputMaybe<Array<UnitMeasureEnum>>;
};

export type NestedEnumUnitTypeEnumFilter = {
  equals?: InputMaybe<UnitTypeEnum>;
  in?: InputMaybe<Array<UnitTypeEnum>>;
  not?: InputMaybe<NestedEnumUnitTypeEnumFilter>;
  notIn?: InputMaybe<Array<UnitTypeEnum>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type OperationArea = {
  __typename?: 'OperationArea';
  company: Company;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  state: State;
  state_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OperationAreaListRelationFilter = {
  every?: InputMaybe<OperationAreaWhereInput>;
  none?: InputMaybe<OperationAreaWhereInput>;
  some?: InputMaybe<OperationAreaWhereInput>;
};

export type OperationAreaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OperationAreaWhereInput = {
  AND?: InputMaybe<Array<OperationAreaWhereInput>>;
  NOT?: InputMaybe<Array<OperationAreaWhereInput>>;
  OR?: InputMaybe<Array<OperationAreaWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  state_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type Packing = {
  __typename?: 'Packing';
  _count: PackingCount;
  capacity: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  measuring_unity: UnitTypeEnum;
  name: Scalars['String']['output'];
  owner?: Maybe<FreightCompany>;
  owner_id?: Maybe<Scalars['String']['output']>;
  product_type_has_packing?: Maybe<Array<ProductTypeHasPacking>>;
  updated_at: Scalars['DateTime']['output'];
};

export type PackingCount = {
  __typename?: 'PackingCount';
  freights: Scalars['Int']['output'];
  product_type_has_packing: Scalars['Int']['output'];
};

export type PackingGraphQlOutput = {
  __typename?: 'PackingGraphQLOutput';
  _count: PackingCount;
  capacity: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  measuring_unity: UnitTypeEnum;
  name: Scalars['String']['output'];
  owner?: Maybe<FreightCompanyMinimalGraphQlOutput>;
  owner_id?: Maybe<Scalars['String']['output']>;
  product_type_has_packing?: Maybe<Array<ProductTypeHasPackingMinimalGraphQlResponse>>;
  updated_at: Scalars['DateTime']['output'];
};

export type PackingIdGraphQlInput = {
  packing_id: Scalars['String']['input'];
};

export type PackingMinimalGraphQlOutput = {
  __typename?: 'PackingMinimalGraphQLOutput';
  capacity: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  measuring_unity: UnitTypeEnum;
  name: Scalars['String']['output'];
  owner_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PackingOrderByWithRelationInput = {
  capacity?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  measuring_unity?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner_id?: InputMaybe<SortOrder>;
  product_type_has_packing?: InputMaybe<ProductTypeHasPackingOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export type PackingRelationFilter = {
  is?: InputMaybe<PackingWhereInput>;
  isNot?: InputMaybe<PackingWhereInput>;
};

export type PackingWhereInput = {
  AND?: InputMaybe<Array<PackingWhereInput>>;
  NOT?: InputMaybe<Array<PackingWhereInput>>;
  OR?: InputMaybe<Array<PackingWhereInput>>;
  capacity?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  measuring_unity?: InputMaybe<EnumUnitTypeEnumFilter>;
  name?: InputMaybe<StringFilter>;
  owner_id?: InputMaybe<UuidNullableFilter>;
  product_type_has_packing?: InputMaybe<ProductTypeHasPackingListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type PackingsGraphQlOutput = {
  __typename?: 'PackingsGraphQLOutput';
  data: Array<PackingGraphQlOutput>;
  length: Scalars['Int']['output'];
};

export type Pagination = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionId = {
  id: Scalars['String']['input'];
};

export type PermissionTemplate = {
  __typename?: 'PermissionTemplate';
  available: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  permission: UserPermission;
  permission_id: Scalars['String']['output'];
  role: Role;
  role_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PermissionTemplateListRelationFilter = {
  every?: InputMaybe<PermissionTemplateWhereInput>;
  none?: InputMaybe<PermissionTemplateWhereInput>;
  some?: InputMaybe<PermissionTemplateWhereInput>;
};

export type PermissionTemplateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PermissionTemplateWhereInput = {
  AND?: InputMaybe<Array<PermissionTemplateWhereInput>>;
  NOT?: InputMaybe<Array<PermissionTemplateWhereInput>>;
  OR?: InputMaybe<Array<PermissionTemplateWhereInput>>;
  available?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  permission_id?: InputMaybe<UuidFilter>;
  role_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type Place = {
  __typename?: 'Place';
  _count: PlaceCount;
  balance_capacity?: Maybe<Scalars['Int']['output']>;
  balance_measure: UnitMeasureEnum;
  cadence: Scalars['Int']['output'];
  city: FreightCity;
  city_id: Scalars['Int']['output'];
  city_name: Scalars['String']['output'];
  closing_hour: Scalars['DateTime']['output'];
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  dirt_road_distance: Scalars['Int']['output'];
  distance_measure: UnitMeasureEnum;
  files?: Maybe<Array<PlaceFile>>;
  has_balance: Scalars['Boolean']['output'];
  has_dirt_road: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  opening_hour: Scalars['DateTime']['output'];
  state: FreightState;
  state_id: Scalars['String']['output'];
  state_name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PlaceCount = {
  __typename?: 'PlaceCount';
  files: Scalars['Int']['output'];
};

export type PlaceFile = {
  __typename?: 'PlaceFile';
  bucket_url: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  place: Place;
  place_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PlaceListRelationFilter = {
  every?: InputMaybe<PlaceWhereInput>;
  none?: InputMaybe<PlaceWhereInput>;
  some?: InputMaybe<PlaceWhereInput>;
};

export type PlaceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PlaceOrderByWithRelationInput = {
  balance_capacity?: InputMaybe<SortOrder>;
  balance_measure?: InputMaybe<SortOrder>;
  cadence?: InputMaybe<SortOrder>;
  city?: InputMaybe<FreightCityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrder>;
  city_name?: InputMaybe<SortOrder>;
  closing_hour?: InputMaybe<SortOrder>;
  company?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  company_id?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  dirt_road_distance?: InputMaybe<SortOrder>;
  distance_measure?: InputMaybe<SortOrder>;
  has_balance?: InputMaybe<SortOrder>;
  has_dirt_road?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  opening_hour?: InputMaybe<SortOrder>;
  state_id?: InputMaybe<SortOrder>;
  state_name?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type PlaceRoute = {
  __typename?: 'PlaceRoute';
  _count: PlaceRouteCount;
  balance_capacity?: Maybe<Scalars['Int']['output']>;
  balance_measure: UnitMeasureEnum;
  cadence: Scalars['Int']['output'];
  city: FreightCity;
  city_id: Scalars['Int']['output'];
  city_name: Scalars['String']['output'];
  closing_hour: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  dirt_road_distance: Scalars['Int']['output'];
  distance_measure: UnitMeasureEnum;
  files?: Maybe<Array<PlaceRouteFile>>;
  freight_route_id?: Maybe<Scalars['String']['output']>;
  has_balance: Scalars['Boolean']['output'];
  has_dirt_road: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  move_type: MoveTypeEnum;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  opening_hour: Scalars['DateTime']['output'];
  reference_place_id: Scalars['String']['output'];
  route: Route;
  route_id: Scalars['String']['output'];
  state: FreightState;
  state_id: Scalars['String']['output'];
  state_name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PlaceRouteCount = {
  __typename?: 'PlaceRouteCount';
  files: Scalars['Int']['output'];
};

export type PlaceRouteFile = {
  __typename?: 'PlaceRouteFile';
  bucket_url: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  place: PlaceRoute;
  place_route_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PlaceRouteListRelationFilter = {
  every?: InputMaybe<PlaceRouteWhereInput>;
  none?: InputMaybe<PlaceRouteWhereInput>;
  some?: InputMaybe<PlaceRouteWhereInput>;
};

export type PlaceRouteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PlaceRouteWhereInput = {
  AND?: InputMaybe<Array<PlaceRouteWhereInput>>;
  NOT?: InputMaybe<Array<PlaceRouteWhereInput>>;
  OR?: InputMaybe<Array<PlaceRouteWhereInput>>;
  balance_capacity?: InputMaybe<IntNullableFilter>;
  balance_measure?: InputMaybe<EnumUnitMeasureEnumFilter>;
  cadence?: InputMaybe<IntFilter>;
  city?: InputMaybe<FreightCityRelationFilter>;
  city_id?: InputMaybe<IntFilter>;
  city_name?: InputMaybe<StringFilter>;
  closing_hour?: InputMaybe<DateTimeFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  dirt_road_distance?: InputMaybe<IntFilter>;
  distance_measure?: InputMaybe<EnumUnitMeasureEnumFilter>;
  freight_route_id?: InputMaybe<UuidNullableFilter>;
  has_balance?: InputMaybe<BoolFilter>;
  has_dirt_road?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  move_type?: InputMaybe<EnumMoveTypeEnumFilter>;
  name?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringNullableFilter>;
  opening_hour?: InputMaybe<DateTimeFilter>;
  reference_place_id?: InputMaybe<UuidFilter>;
  route?: InputMaybe<RouteRelationFilter>;
  route_id?: InputMaybe<UuidFilter>;
  state_id?: InputMaybe<StringFilter>;
  state_name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type PlaceWhereInput = {
  AND?: InputMaybe<Array<PlaceWhereInput>>;
  NOT?: InputMaybe<Array<PlaceWhereInput>>;
  OR?: InputMaybe<Array<PlaceWhereInput>>;
  balance_measure?: InputMaybe<EnumUnitMeasureEnumFilter>;
  cadence?: InputMaybe<IntFilter>;
  city?: InputMaybe<FreightCityRelationFilter>;
  city_id?: InputMaybe<IntFilter>;
  city_name?: InputMaybe<StringFilter>;
  closing_hour?: InputMaybe<DateTimeFilter>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  dirt_road_distance?: InputMaybe<IntFilter>;
  distance_measure?: InputMaybe<EnumUnitMeasureEnumFilter>;
  has_balance?: InputMaybe<BoolFilter>;
  has_dirt_road?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<StringFilter>;
  longitude?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringNullableFilter>;
  opening_hour?: InputMaybe<DateTimeFilter>;
  state_id?: InputMaybe<StringFilter>;
  state_name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type Policy = {
  __typename?: 'Policy';
  bucket_url: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expires_in: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type PolicyInput = {
  company_id?: InputMaybe<Scalars['String']['input']>;
  expires_in: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyListRelationFilter = {
  every?: InputMaybe<PolicyWhereInput>;
  none?: InputMaybe<PolicyWhereInput>;
  some?: InputMaybe<PolicyWhereInput>;
};

export type PolicyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PolicyWhereInput = {
  AND?: InputMaybe<Array<PolicyWhereInput>>;
  NOT?: InputMaybe<Array<PolicyWhereInput>>;
  OR?: InputMaybe<Array<PolicyWhereInput>>;
  bucket_url?: InputMaybe<StringFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  company_id?: InputMaybe<UuidNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  expires_in?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  user_id?: InputMaybe<UuidNullableFilter>;
};

export type Product = {
  __typename?: 'Product';
  _count: ProductCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<FreightCompany>;
  owner_id?: Maybe<Scalars['String']['output']>;
  product_type: ProductType;
  type_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  varieties?: Maybe<Array<Variety>>;
};

export type ProductCount = {
  __typename?: 'ProductCount';
  freights: Scalars['Int']['output'];
  varieties: Scalars['Int']['output'];
};

export type ProductGraphQlOutput = {
  __typename?: 'ProductGraphQLOutput';
  _count: ProductCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<FreightCompanyMinimalGraphQlOutput>;
  owner_id?: Maybe<Scalars['String']['output']>;
  product_type: ProductTypeMinimalGraphQlOutput;
  type_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  varieties?: Maybe<Array<VarietyMinimalGraphQlOutput>>;
};

export type ProductMinimalGraphQlOutput = {
  __typename?: 'ProductMinimalGraphQLOutput';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner_id?: Maybe<Scalars['String']['output']>;
  type_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProductOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  owner_id?: InputMaybe<SortOrder>;
  product_type?: InputMaybe<ProductTypeOrderByWithRelationInput>;
  type_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type ProductRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductType = {
  __typename?: 'ProductType';
  _count: ProductTypeCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  freight?: Maybe<Array<Freight>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<Array<Product>>;
  product_type_has_packing?: Maybe<Array<ProductTypeHasPacking>>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProductTypeCount = {
  __typename?: 'ProductTypeCount';
  freight: Scalars['Int']['output'];
  product: Scalars['Int']['output'];
  product_type_has_packing: Scalars['Int']['output'];
};

export type ProductTypeHasPacking = {
  __typename?: 'ProductTypeHasPacking';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  packing: Packing;
  packing_id: Scalars['String']['output'];
  product_type: ProductType;
  product_type_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProductTypeHasPackingListRelationFilter = {
  every?: InputMaybe<ProductTypeHasPackingWhereInput>;
  none?: InputMaybe<ProductTypeHasPackingWhereInput>;
  some?: InputMaybe<ProductTypeHasPackingWhereInput>;
};

export type ProductTypeHasPackingMinimalGraphQlResponse = {
  __typename?: 'ProductTypeHasPackingMinimalGraphQLResponse';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  packing: PackingMinimalGraphQlOutput;
  packing_id: Scalars['String']['output'];
  product_type: ProductTypeMinimalGraphQlOutput;
  product_type_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProductTypeHasPackingObject = {
  packing_id: Scalars['String']['input'];
  product_type_id: Scalars['String']['input'];
};

export type ProductTypeHasPackingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductTypeHasPackingOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  packing?: InputMaybe<PackingOrderByWithRelationInput>;
  packing_id?: InputMaybe<SortOrder>;
  product_type?: InputMaybe<ProductTypeOrderByWithRelationInput>;
  product_type_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type ProductTypeHasPackingWhereInput = {
  AND?: InputMaybe<Array<ProductTypeHasPackingWhereInput>>;
  NOT?: InputMaybe<Array<ProductTypeHasPackingWhereInput>>;
  OR?: InputMaybe<Array<ProductTypeHasPackingWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  packing?: InputMaybe<PackingRelationFilter>;
  packing_id?: InputMaybe<UuidFilter>;
  product_type?: InputMaybe<ProductTypeRelationFilter>;
  product_type_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type ProductTypeId = {
  id: Scalars['String']['input'];
};

export type ProductTypeMinimalGraphQlOutput = {
  __typename?: 'ProductTypeMinimalGraphQLOutput';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProductTypeName = {
  name: Scalars['String']['input'];
};

export type ProductTypeOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  product_type_has_packing?: InputMaybe<ProductTypeHasPackingOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export type ProductTypeRelationFilter = {
  is?: InputMaybe<ProductTypeWhereInput>;
  isNot?: InputMaybe<ProductTypeWhereInput>;
};

export type ProductTypeWhereInput = {
  AND?: InputMaybe<Array<ProductTypeWhereInput>>;
  NOT?: InputMaybe<Array<ProductTypeWhereInput>>;
  OR?: InputMaybe<Array<ProductTypeWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  product_type_has_packing?: InputMaybe<ProductTypeHasPackingListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<FreightCompanyRelationFilter>;
  owner_id?: InputMaybe<UuidNullableFilter>;
  product_type?: InputMaybe<ProductTypeRelationFilter>;
  type_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type ProductsGraphQlOutput = {
  __typename?: 'ProductsGraphQLOutput';
  data: Array<ProductGraphQlOutput>;
  length: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  AggregateFreights: AggregateFreight;
  FindCancellation: Cancellation;
  FindCancellationReason: CancellationReason;
  FindCancellations: Array<Cancellation>;
  FindCities: Array<FindCities>;
  FindCompanies: Array<Company>;
  FindCompany: Company;
  FindCompanyRating: CompanyRating;
  FindCompanySettings: CompanySettingsGraphQlOutput;
  FindDriver: Driver;
  FindFreight: Freight;
  FindFreightRating: FreightRating;
  FindGroup: Group;
  FindManyCancellationReasons: Array<CancellationReason>;
  FindManyFreightRatings: Array<FreightRating>;
  FindManyFreights: Array<Freight>;
  FindManyGroups: Groups;
  FindManyModules: Array<Module>;
  FindManyPackings: PackingsGraphQlOutput;
  FindManyProductTypes: Array<ProductType>;
  FindManyProductTypesHasPackings: Array<ProductTypeHasPacking>;
  FindManyProducts: ProductsGraphQlOutput;
  FindManyQuotation: Array<Quotation>;
  FindManyQuotationRatings: Array<QuotationRating>;
  FindManyRatingReasons: Array<RatingReason>;
  FindManyRefusalReasons: Array<RefusalReason>;
  FindManyThemes: FindManyThemesGraphQlOuput;
  FindManyUserHasPermissions: Array<UserHasPermission>;
  FindManyUserPermissions: Array<UserPermission>;
  FindManyUsers: Array<FindUserGraphQlOutput>;
  FindManyVarieties: VarietiesGraphQlOutput;
  FindPermissionTemplate: Array<PermissionTemplate>;
  FindPlace: Place;
  FindPlaces: Array<Place>;
  FindQuotation: Quotation;
  FindQuotationRating: QuotationRating;
  FindQuotingFreights: Freights;
  FindRatingReason: RatingReason;
  FindRefusal: Refusal;
  FindRefusalReason: RefusalReason;
  FindRefusals: Array<Refusal>;
  FindReproach: FindReproachResponse;
  FindRole: Role;
  FindRoles: Array<Role>;
  FindRoute: Route;
  FindRoutes: Array<Route>;
  FindSystemRating: SystemRating;
  FindTheme: ThemeGraphQlOutput;
  FindUser: FindUserGraphQlOutput;
  FindVehicleType: VehicleType;
  FindVehicleTypes: Array<VehicleType>;
  FindZipCode: FindZipCode;
  GetUserRoles: UserRoles;
  HasSomeRole: UserHasSomeRoleResponse;
  ListAllFreightAttachments: FreightAttachmentsGraphQlResponse;
  ValidateToken: ValidateTokenResponse;
};


export type QueryAggregateFreightsArgs = {
  aggregations: AggregatorsFreightsInput;
  order_by?: InputMaybe<FreightOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where: FreightWhereInput;
};


export type QueryFindCancellationArgs = {
  cancellation_id: Scalars['String']['input'];
};


export type QueryFindCancellationReasonArgs = {
  cancellation_reason_id: Scalars['String']['input'];
};


export type QueryFindCancellationsArgs = {
  order_by?: InputMaybe<CancellationOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<CancellationWhereInput>;
};


export type QueryFindCitiesArgs = {
  state_id: Scalars['String']['input'];
};


export type QueryFindCompaniesArgs = {
  order_by?: InputMaybe<CompanyOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryFindCompanyArgs = {
  company_id: Scalars['String']['input'];
};


export type QueryFindCompanyRatingArgs = {
  company_id: Scalars['String']['input'];
};


export type QueryFindCompanySettingsArgs = {
  company_id: Scalars['ID']['input'];
};


export type QueryFindDriverArgs = {
  carrier_id: Scalars['String']['input'];
  cnh: Scalars['String']['input'];
};


export type QueryFindFreightArgs = {
  freight_id: Scalars['String']['input'];
};


export type QueryFindFreightRatingArgs = {
  rating_id: Scalars['String']['input'];
};


export type QueryFindGroupArgs = {
  group_id: Scalars['String']['input'];
};


export type QueryFindManyCancellationReasonsArgs = {
  order_by?: InputMaybe<CancellationReasonOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<CustomCancellationReasonsWhereInput>;
};


export type QueryFindManyFreightRatingsArgs = {
  order_by?: InputMaybe<FreightRatingOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FreightRatingWhereInput>;
};


export type QueryFindManyFreightsArgs = {
  order_by?: InputMaybe<FreightOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FreightWhereInput>;
};


export type QueryFindManyGroupsArgs = {
  order_by?: InputMaybe<GroupOrderByWithRelationInput>;
  owner_id: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<GroupWhereInput>;
};


export type QueryFindManyModulesArgs = {
  order_by?: InputMaybe<ModuleOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<ModuleWhereInput>;
};


export type QueryFindManyPackingsArgs = {
  order_by?: InputMaybe<PackingOrderByWithRelationInput>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  product_type_id?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PackingWhereInput>;
};


export type QueryFindManyProductTypesArgs = {
  order_by?: InputMaybe<ProductTypeOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<ProductTypeWhereInput>;
};


export type QueryFindManyProductTypesHasPackingsArgs = {
  order_by?: InputMaybe<ProductTypeHasPackingOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<ProductTypeHasPackingWhereInput>;
};


export type QueryFindManyProductsArgs = {
  order_by?: InputMaybe<ProductOrderByWithRelationInput>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryFindManyQuotationArgs = {
  order_by?: InputMaybe<QuotationOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<QuotationWhereInput>;
};


export type QueryFindManyQuotationRatingsArgs = {
  order_by?: InputMaybe<QuotationRatingOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<QuotationRatingWhereInput>;
};


export type QueryFindManyRatingReasonsArgs = {
  order_by?: InputMaybe<RatingReasonOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<RatingReasonWhereInput>;
};


export type QueryFindManyRefusalReasonsArgs = {
  order_by?: InputMaybe<RefusalReasonOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<RefusalReasonWhereInput>;
};


export type QueryFindManyThemesArgs = {
  order_by?: InputMaybe<ThemeOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<ThemeWhereInput>;
};


export type QueryFindManyUserHasPermissionsArgs = {
  order_by?: InputMaybe<UserHasPermissionOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<UserHasPermissionWhereInput>;
};


export type QueryFindManyUserPermissionsArgs = {
  order_by?: InputMaybe<UserPermissionOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<UserPermissionWhereInput>;
};


export type QueryFindManyUsersArgs = {
  order_by?: InputMaybe<UserOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindManyVarietiesArgs = {
  order_by?: InputMaybe<VarietyOrderByWithRelationInput>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<Pagination>;
  product_id: Scalars['ID']['input'];
  where?: InputMaybe<VarietyWhereInput>;
};


export type QueryFindPermissionTemplateArgs = {
  role: TruckerRolesEnum;
};


export type QueryFindPlaceArgs = {
  input: FindPlaceInput;
};


export type QueryFindPlacesArgs = {
  order_by?: InputMaybe<PlaceOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where: FindPlacesWhereInput;
};


export type QueryFindQuotationArgs = {
  quotation_id: Scalars['String']['input'];
};


export type QueryFindQuotationRatingArgs = {
  rating_id: Scalars['String']['input'];
};


export type QueryFindQuotingFreightsArgs = {
  carrier_id: Scalars['String']['input'];
  order_by?: InputMaybe<FreightOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FreightWhereInput>;
};


export type QueryFindRatingReasonArgs = {
  reason_id: Scalars['String']['input'];
};


export type QueryFindRefusalArgs = {
  refusal_id: Scalars['String']['input'];
};


export type QueryFindRefusalReasonArgs = {
  refusal_reason_id: Scalars['String']['input'];
};


export type QueryFindRefusalsArgs = {
  order_by?: InputMaybe<RefusalOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<RefusalWhereInput>;
};


export type QueryFindReproachArgs = {
  input: FindReproachInput;
};


export type QueryFindRoleArgs = {
  input: FindRoleInput;
};


export type QueryFindRolesArgs = {
  order_by?: InputMaybe<RoleOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryFindRouteArgs = {
  input: FindRouteInput;
};


export type QueryFindRoutesArgs = {
  order_by?: InputMaybe<RouteOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where: CustomRoutesWhereInput;
};


export type QueryFindThemeArgs = {
  theme_id: Scalars['String']['input'];
};


export type QueryFindUserArgs = {
  user_id: Scalars['String']['input'];
};


export type QueryFindVehicleTypeArgs = {
  input: FindVehicleTypeInput;
};


export type QueryFindVehicleTypesArgs = {
  order_by?: InputMaybe<VehicleTypeOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<VehicleTypeWhereInput>;
};


export type QueryFindZipCodeArgs = {
  input: FindZipCodeDto;
};


export type QueryGetUserRolesArgs = {
  input: GetUserRolesInput;
};


export type QueryHasSomeRoleArgs = {
  input: UserHasSomeRoleInput;
};


export type QueryListAllFreightAttachmentsArgs = {
  freight_id: Scalars['String']['input'];
  order_by?: InputMaybe<FreightAttachmentOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<FreightAttachmentWhereInput>;
};


export type QueryValidateTokenArgs = {
  input: ValidateTokenInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Quotation = {
  __typename?: 'Quotation';
  _count: QuotationCount;
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  cancellation?: Maybe<Array<Cancellation>>;
  commission_ammount?: Maybe<Scalars['Int']['output']>;
  confirmations?: Maybe<Array<QuotationConfirmation>>;
  created_at: Scalars['DateTime']['output'];
  creator: FreightUser;
  creator_id: Scalars['String']['output'];
  ctes?: Maybe<Array<Cte>>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  dropped_at?: Maybe<Scalars['DateTime']['output']>;
  expires_in?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  freight: Freight;
  freight_id: Scalars['String']['output'];
  has_vehicle: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  loaded_volume: Scalars['Int']['output'];
  owner: FreightCompany;
  owner_id: Scalars['String']['output'];
  paid_in?: Maybe<Scalars['DateTime']['output']>;
  quotation_rating?: Maybe<QuotationRating>;
  refused_at?: Maybe<Scalars['DateTime']['output']>;
  requested_volume: Scalars['Int']['output'];
  shipper?: Maybe<FreightCompany>;
  shipper_id?: Maybe<Scalars['String']['output']>;
  status: QuotationStatus;
  status_id: Scalars['String']['output'];
  total_volume: Scalars['Int']['output'];
  unallocated_volume: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
  value_per_unit: Scalars['Int']['output'];
  value_unit_type: UnitTypeEnum;
};

export type QuotationConfirmation = {
  __typename?: 'QuotationConfirmation';
  _count: QuotationConfirmationCount;
  assigned_volume: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  ctes?: Maybe<Array<Cte>>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  driver: Driver;
  driver_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  quotation: Quotation;
  quotation_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  vehicle_plate: Scalars['String']['output'];
  vehicle_type: VehicleType;
  vehicle_type_id: Scalars['String']['output'];
};

export type QuotationConfirmationCount = {
  __typename?: 'QuotationConfirmationCount';
  ctes: Scalars['Int']['output'];
};

export type QuotationConfirmationListRelationFilter = {
  every?: InputMaybe<QuotationConfirmationWhereInput>;
  none?: InputMaybe<QuotationConfirmationWhereInput>;
  some?: InputMaybe<QuotationConfirmationWhereInput>;
};

export type QuotationConfirmationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuotationConfirmationRelationFilter = {
  is?: InputMaybe<QuotationConfirmationWhereInput>;
  isNot?: InputMaybe<QuotationConfirmationWhereInput>;
};

export type QuotationConfirmationWhereInput = {
  AND?: InputMaybe<Array<QuotationConfirmationWhereInput>>;
  NOT?: InputMaybe<Array<QuotationConfirmationWhereInput>>;
  OR?: InputMaybe<Array<QuotationConfirmationWhereInput>>;
  assigned_volume?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  ctes?: InputMaybe<CteListRelationFilter>;
  driver?: InputMaybe<DriverRelationFilter>;
  driver_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  quotation?: InputMaybe<QuotationRelationFilter>;
  quotation_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  vehicle_plate?: InputMaybe<StringFilter>;
  vehicle_type?: InputMaybe<VehicleTypeRelationFilter>;
  vehicle_type_id?: InputMaybe<UuidFilter>;
};

export type QuotationCount = {
  __typename?: 'QuotationCount';
  cancellation: Scalars['Int']['output'];
  confirmations: Scalars['Int']['output'];
  ctes: Scalars['Int']['output'];
};

export type QuotationListRelationFilter = {
  every?: InputMaybe<QuotationWhereInput>;
  none?: InputMaybe<QuotationWhereInput>;
  some?: InputMaybe<QuotationWhereInput>;
};

export type QuotationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuotationOrderByWithRelationInput = {
  cancellation?: InputMaybe<CancellationOrderByRelationAggregateInput>;
  confirmations?: InputMaybe<QuotationConfirmationOrderByRelationAggregateInput>;
  created_at?: InputMaybe<SortOrder>;
  creator?: InputMaybe<FreightUserOrderByWithRelationInput>;
  creator_id?: InputMaybe<SortOrder>;
  ctes?: InputMaybe<CteOrderByRelationAggregateInput>;
  expires_in?: InputMaybe<SortOrder>;
  freight?: InputMaybe<FreightOrderByWithRelationInput>;
  freight_id?: InputMaybe<SortOrder>;
  has_vehicle?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  loaded_volume?: InputMaybe<SortOrder>;
  owner?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  owner_id?: InputMaybe<SortOrder>;
  quotation_rating?: InputMaybe<QuotationRatingOrderByWithRelationInput>;
  requested_volume?: InputMaybe<SortOrder>;
  shipper?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  shipper_id?: InputMaybe<SortOrder>;
  status?: InputMaybe<QuotationStatusOrderByWithRelationInput>;
  status_id?: InputMaybe<SortOrder>;
  total_volume?: InputMaybe<SortOrder>;
  unallocated_volume?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  value_per_unit?: InputMaybe<SortOrder>;
  value_unit_type?: InputMaybe<SortOrder>;
};

export type QuotationRating = {
  __typename?: 'QuotationRating';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  evaluator: FreightCompany;
  evaluator_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  quotation: Quotation;
  quotation_id: Scalars['String']['output'];
  rated: FreightCompany;
  rated_id: Scalars['String']['output'];
  reason?: Maybe<RatingReason>;
  reason_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type QuotationRatingListRelationFilter = {
  every?: InputMaybe<QuotationRatingWhereInput>;
  none?: InputMaybe<QuotationRatingWhereInput>;
  some?: InputMaybe<QuotationRatingWhereInput>;
};

export type QuotationRatingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuotationRatingOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  evaluator?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  evaluator_id?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quotation?: InputMaybe<QuotationOrderByWithRelationInput>;
  quotation_id?: InputMaybe<SortOrder>;
  rated?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  rated_id?: InputMaybe<SortOrder>;
  reason?: InputMaybe<RatingReasonOrderByWithRelationInput>;
  reason_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type QuotationRatingRelationFilter = {
  is?: InputMaybe<QuotationRatingWhereInput>;
  isNot?: InputMaybe<QuotationRatingWhereInput>;
};

export type QuotationRatingWhereInput = {
  AND?: InputMaybe<Array<QuotationRatingWhereInput>>;
  NOT?: InputMaybe<Array<QuotationRatingWhereInput>>;
  OR?: InputMaybe<Array<QuotationRatingWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  evaluator?: InputMaybe<FreightCompanyRelationFilter>;
  evaluator_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  quotation?: InputMaybe<QuotationRelationFilter>;
  quotation_id?: InputMaybe<UuidFilter>;
  rated?: InputMaybe<FreightCompanyRelationFilter>;
  rated_id?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<RatingReasonRelationFilter>;
  reason_id?: InputMaybe<UuidNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<IntFilter>;
};

export type QuotationRelationFilter = {
  is?: InputMaybe<QuotationWhereInput>;
  isNot?: InputMaybe<QuotationWhereInput>;
};

export type QuotationStatus = {
  __typename?: 'QuotationStatus';
  _count: QuotationStatusCount;
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quotations?: Maybe<Array<Quotation>>;
  updated_at: Scalars['DateTime']['output'];
};

export type QuotationStatusCount = {
  __typename?: 'QuotationStatusCount';
  quotations: Scalars['Int']['output'];
};

export type QuotationStatusOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  quotations?: InputMaybe<QuotationOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export type QuotationStatusRelationFilter = {
  is?: InputMaybe<QuotationStatusWhereInput>;
  isNot?: InputMaybe<QuotationStatusWhereInput>;
};

export type QuotationStatusWhereInput = {
  AND?: InputMaybe<Array<QuotationStatusWhereInput>>;
  NOT?: InputMaybe<Array<QuotationStatusWhereInput>>;
  OR?: InputMaybe<Array<QuotationStatusWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  quotations?: InputMaybe<QuotationListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type QuotationVolumeInput = {
  proposed_volume: Scalars['Int']['input'];
  quotation_id: Scalars['String']['input'];
};

export type QuotationWhereInput = {
  AND?: InputMaybe<Array<QuotationWhereInput>>;
  NOT?: InputMaybe<Array<QuotationWhereInput>>;
  OR?: InputMaybe<Array<QuotationWhereInput>>;
  cancellation?: InputMaybe<CancellationListRelationFilter>;
  confirmations?: InputMaybe<QuotationConfirmationListRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<FreightUserRelationFilter>;
  creator_id?: InputMaybe<UuidFilter>;
  ctes?: InputMaybe<CteListRelationFilter>;
  expires_in?: InputMaybe<DateTimeNullableFilter>;
  freight?: InputMaybe<FreightRelationFilter>;
  freight_id?: InputMaybe<UuidFilter>;
  has_vehicle?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  loaded_volume?: InputMaybe<IntFilter>;
  owner?: InputMaybe<FreightCompanyRelationFilter>;
  owner_id?: InputMaybe<UuidFilter>;
  quotation_rating?: InputMaybe<QuotationRatingRelationFilter>;
  requested_volume?: InputMaybe<IntFilter>;
  shipper?: InputMaybe<FreightCompanyRelationFilter>;
  shipper_id?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<QuotationStatusRelationFilter>;
  status_id?: InputMaybe<UuidFilter>;
  total_volume?: InputMaybe<IntFilter>;
  unallocated_volume?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<IntFilter>;
  value_per_unit?: InputMaybe<IntFilter>;
  value_unit_type?: InputMaybe<EnumUnitTypeEnumFilter>;
};

export type RatingReason = {
  __typename?: 'RatingReason';
  _count: RatingReasonCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  freight_rating?: Maybe<Array<FreightRating>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quotation_ratings?: Maybe<Array<QuotationRating>>;
  trigger: RatingTriggerEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type RatingReasonCount = {
  __typename?: 'RatingReasonCount';
  freight_rating: Scalars['Int']['output'];
  quotation_ratings: Scalars['Int']['output'];
};

export type RatingReasonOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  freight_rating?: InputMaybe<FreightRatingOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  quotation_ratings?: InputMaybe<QuotationRatingOrderByRelationAggregateInput>;
  trigger?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type RatingReasonRelationFilter = {
  is?: InputMaybe<RatingReasonWhereInput>;
  isNot?: InputMaybe<RatingReasonWhereInput>;
};

export type RatingReasonWhereInput = {
  AND?: InputMaybe<Array<RatingReasonWhereInput>>;
  NOT?: InputMaybe<Array<RatingReasonWhereInput>>;
  OR?: InputMaybe<Array<RatingReasonWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  freight_rating?: InputMaybe<FreightRatingListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  quotation_ratings?: InputMaybe<QuotationRatingListRelationFilter>;
  trigger?: InputMaybe<EnumRatingTriggerEnumFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export enum RatingTriggerEnum {
  Freight = 'FREIGHT',
  Quotation = 'QUOTATION'
}

export type Reason = {
  __typename?: 'Reason';
  _count: ReasonCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason_type: ReasonTypeEnum;
  reference_function: FunctionEnum;
  reproachs?: Maybe<Array<ReproachHasReason>>;
  updated_at: Scalars['DateTime']['output'];
};

export type ReasonCount = {
  __typename?: 'ReasonCount';
  reproachs: Scalars['Int']['output'];
};

export enum ReasonTypeEnum {
  CompanyAddress = 'COMPANY_ADDRESS',
  CompanyContact = 'COMPANY_CONTACT',
  CompanyData = 'COMPANY_DATA',
  CompanyOperationArea = 'COMPANY_OPERATION_AREA',
  CompanyPolicies = 'COMPANY_POLICIES',
  Other = 'OTHER'
}

export type RecoveryPasswordInput = {
  new_password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RectifyCompanyInput = {
  areas_to_include?: InputMaybe<Array<Scalars['String']['input']>>;
  areas_to_remove?: InputMaybe<Array<Scalars['String']['input']>>;
  company_function?: InputMaybe<FunctionEnum>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  company_type?: InputMaybe<CompanyTypeEnum>;
  contact_id?: InputMaybe<Scalars['String']['input']>;
  document_number?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<DocumentTypeEnum>;
  fleet_quantity?: InputMaybe<Scalars['Int']['input']>;
  has_fleet?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  new_address?: InputMaybe<UpdateAddressCompanyInput>;
  new_contact?: InputMaybe<ContactUncheckedUpdateInput>;
  new_mother_company_id?: InputMaybe<Scalars['String']['input']>;
  new_reference_company_id?: InputMaybe<Scalars['String']['input']>;
  parent_company_data?: InputMaybe<CreateParentCompanyInput>;
  trade_name?: InputMaybe<Scalars['String']['input']>;
  url_logo?: InputMaybe<Scalars['String']['input']>;
};

export type Refusal = {
  __typename?: 'Refusal';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  freight: Freight;
  freight_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: FreightCompany;
  owner_id: Scalars['String']['output'];
  reason: RefusalReason;
  reason_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RefusalListRelationFilter = {
  every?: InputMaybe<RefusalWhereInput>;
  none?: InputMaybe<RefusalWhereInput>;
  some?: InputMaybe<RefusalWhereInput>;
};

export type RefusalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RefusalOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  freight?: InputMaybe<FreightOrderByWithRelationInput>;
  freight_id?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  owner_id?: InputMaybe<SortOrder>;
  reason?: InputMaybe<RefusalReasonOrderByWithRelationInput>;
  reason_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type RefusalReason = {
  __typename?: 'RefusalReason';
  _count: RefusalReasonCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  refusals?: Maybe<Array<Refusal>>;
  trigger: RefusalTriggerEnum;
  updated_at: Scalars['DateTime']['output'];
};

export type RefusalReasonCount = {
  __typename?: 'RefusalReasonCount';
  refusals: Scalars['Int']['output'];
};

export type RefusalReasonOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  refusals?: InputMaybe<RefusalOrderByRelationAggregateInput>;
  trigger?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type RefusalReasonRelationFilter = {
  is?: InputMaybe<RefusalReasonWhereInput>;
  isNot?: InputMaybe<RefusalReasonWhereInput>;
};

export type RefusalReasonWhereInput = {
  AND?: InputMaybe<Array<RefusalReasonWhereInput>>;
  NOT?: InputMaybe<Array<RefusalReasonWhereInput>>;
  OR?: InputMaybe<Array<RefusalReasonWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  refusals?: InputMaybe<RefusalListRelationFilter>;
  trigger?: InputMaybe<EnumRefusalTriggerEnumFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export enum RefusalTriggerEnum {
  Cancel = 'CANCEL',
  Hide = 'HIDE'
}

export type RefusalWhereInput = {
  AND?: InputMaybe<Array<RefusalWhereInput>>;
  NOT?: InputMaybe<Array<RefusalWhereInput>>;
  OR?: InputMaybe<Array<RefusalWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  freight?: InputMaybe<FreightRelationFilter>;
  freight_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  owner?: InputMaybe<FreightCompanyRelationFilter>;
  owner_id?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<RefusalReasonRelationFilter>;
  reason_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type RemoveUserInternallyInput = {
  company_id: Scalars['String']['input'];
  user_company_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type Reproach = {
  __typename?: 'Reproach';
  _count: ReproachCount;
  blocked_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_blocked: Scalars['Boolean']['output'];
  reasons?: Maybe<Array<ReproachHasReason>>;
  reference_company_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ReproachCompanyInput = {
  company_id: Scalars['String']['input'];
  is_block?: InputMaybe<Scalars['Boolean']['input']>;
  manager_id: Scalars['String']['input'];
  reasons: Array<ReproachReasonInput>;
  reproach_description: Scalars['String']['input'];
};

export type ReproachCount = {
  __typename?: 'ReproachCount';
  reasons: Scalars['Int']['output'];
};

export type ReproachHasReason = {
  __typename?: 'ReproachHasReason';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  reaproach_id: Scalars['String']['output'];
  reason: Reason;
  reason_id: Scalars['String']['output'];
  reproach: Reproach;
  updated_at: Scalars['DateTime']['output'];
};

export type ReproachReasonInput = {
  description: Scalars['String']['input'];
  reason_type: ReasonTypeEnum;
};

export type Role = {
  __typename?: 'Role';
  _count: RoleCount;
  abbreviation: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parents?: Maybe<Array<RoleHasRole>>;
  subroles?: Maybe<Array<RoleHasRole>>;
  templates?: Maybe<Array<PermissionTemplate>>;
  updated_at: Scalars['DateTime']['output'];
  users?: Maybe<Array<UserHasRole>>;
};

export type RoleCount = {
  __typename?: 'RoleCount';
  parents: Scalars['Int']['output'];
  subroles: Scalars['Int']['output'];
  templates: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type RoleHasRole = {
  __typename?: 'RoleHasRole';
  child_role: Role;
  child_role_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  parent_role: Role;
  parent_role_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RoleOrderByWithRelationInput = {
  abbreviation?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  templates?: InputMaybe<PermissionTemplateOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export enum RoleTruckerUserEnum {
  Adm = 'ADM',
  Sup = 'SUP'
}

export type RoleWhereInput = {
  AND?: InputMaybe<Array<RoleWhereInput>>;
  NOT?: InputMaybe<Array<RoleWhereInput>>;
  OR?: InputMaybe<Array<RoleWhereInput>>;
  abbreviation?: InputMaybe<StringFilter>;
  active?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  templates?: InputMaybe<PermissionTemplateListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type Route = {
  __typename?: 'Route';
  _count: RouteCount;
  company: FreightCompany;
  company_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  estimate_time: Scalars['Int']['output'];
  freights?: Maybe<Array<Freight>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  places?: Maybe<Array<PlaceRoute>>;
  total_distance: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RouteCount = {
  __typename?: 'RouteCount';
  freights: Scalars['Int']['output'];
  places: Scalars['Int']['output'];
};

export type RouteListRelationFilter = {
  every?: InputMaybe<RouteWhereInput>;
  none?: InputMaybe<RouteWhereInput>;
  some?: InputMaybe<RouteWhereInput>;
};

export type RouteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RouteOrderByWithRelationInput = {
  company?: InputMaybe<FreightCompanyOrderByWithRelationInput>;
  company_id?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  estimate_time?: InputMaybe<SortOrder>;
  freights?: InputMaybe<FreightOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  places?: InputMaybe<PlaceRouteOrderByRelationAggregateInput>;
  total_distance?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type RouteRelationFilter = {
  is?: InputMaybe<RouteWhereInput>;
  isNot?: InputMaybe<RouteWhereInput>;
};

export type RouteWhereInput = {
  AND?: InputMaybe<Array<RouteWhereInput>>;
  NOT?: InputMaybe<Array<RouteWhereInput>>;
  OR?: InputMaybe<Array<RouteWhereInput>>;
  company?: InputMaybe<FreightCompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  estimate_time?: InputMaybe<IntFilter>;
  freights?: InputMaybe<FreightListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  places?: InputMaybe<PlaceRouteListRelationFilter>;
  total_distance?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type SendRecoveryCodeInput = {
  email: Scalars['String']['input'];
};

export type SendValidationEmailInput = {
  company_function: FunctionEnum;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SendValidationEmailResponse = {
  __typename?: 'SendValidationEmailResponse';
  has_success: Scalars['Boolean']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type State = {
  __typename?: 'State';
  _count: StateCount;
  address?: Maybe<Array<Address>>;
  capital?: Maybe<Scalars['String']['output']>;
  capital_without_accent?: Maybe<Scalars['String']['output']>;
  cities?: Maybe<Array<City>>;
  country?: Maybe<Country>;
  country_id?: Maybe<Scalars['String']['output']>;
  districts?: Maybe<Array<District>>;
  final_zip_code?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  operationArea?: Maybe<Array<OperationArea>>;
  region?: Maybe<Scalars['String']['output']>;
  region_without_accent?: Maybe<Scalars['String']['output']>;
  starting_zip_code?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_name_without_accent?: Maybe<Scalars['String']['output']>;
  zip_codes?: Maybe<Array<ZipCode>>;
};

export type StateCount = {
  __typename?: 'StateCount';
  address: Scalars['Int']['output'];
  cities: Scalars['Int']['output'];
  districts: Scalars['Int']['output'];
  operationArea: Scalars['Int']['output'];
  zip_codes: Scalars['Int']['output'];
};

export type StateGraphQlOutput = {
  __typename?: 'StateGraphQLOutput';
  capital?: Maybe<Scalars['String']['output']>;
  capital_without_accent?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryGraphQlOutput>;
  country_id?: Maybe<Scalars['String']['output']>;
  final_zip_code?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_without_accent?: Maybe<Scalars['String']['output']>;
  starting_zip_code?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  state_name_without_accent?: Maybe<Scalars['String']['output']>;
};

export type StateListRelationFilter = {
  every?: InputMaybe<StateWhereInput>;
  none?: InputMaybe<StateWhereInput>;
  some?: InputMaybe<StateWhereInput>;
};

export type StateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StateOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByRelationAggregateInput>;
  capital?: InputMaybe<SortOrderInput>;
  capital_without_accent?: InputMaybe<SortOrderInput>;
  cities?: InputMaybe<CityOrderByRelationAggregateInput>;
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  country_id?: InputMaybe<SortOrderInput>;
  districts?: InputMaybe<DistrictOrderByRelationAggregateInput>;
  final_zip_code?: InputMaybe<SortOrderInput>;
  initials?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  operationArea?: InputMaybe<OperationAreaOrderByRelationAggregateInput>;
  region?: InputMaybe<SortOrderInput>;
  region_without_accent?: InputMaybe<SortOrderInput>;
  starting_zip_code?: InputMaybe<SortOrderInput>;
  state_name?: InputMaybe<SortOrderInput>;
  state_name_without_accent?: InputMaybe<SortOrderInput>;
  zip_codes?: InputMaybe<ZipCodeOrderByRelationAggregateInput>;
};

export type StateRelationFilter = {
  is?: InputMaybe<StateWhereInput>;
  isNot?: InputMaybe<StateWhereInput>;
};

export type StateWhereInput = {
  AND?: InputMaybe<Array<StateWhereInput>>;
  NOT?: InputMaybe<Array<StateWhereInput>>;
  OR?: InputMaybe<Array<StateWhereInput>>;
  address?: InputMaybe<AddressListRelationFilter>;
  capital?: InputMaybe<StringNullableFilter>;
  capital_without_accent?: InputMaybe<StringNullableFilter>;
  cities?: InputMaybe<CityListRelationFilter>;
  country?: InputMaybe<CountryRelationFilter>;
  country_id?: InputMaybe<StringNullableFilter>;
  districts?: InputMaybe<DistrictListRelationFilter>;
  final_zip_code?: InputMaybe<StringNullableFilter>;
  initials?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  operationArea?: InputMaybe<OperationAreaListRelationFilter>;
  region?: InputMaybe<StringNullableFilter>;
  region_without_accent?: InputMaybe<StringNullableFilter>;
  starting_zip_code?: InputMaybe<StringNullableFilter>;
  state_name?: InputMaybe<StringNullableFilter>;
  state_name_without_accent?: InputMaybe<StringNullableFilter>;
  zip_codes?: InputMaybe<ZipCodeListRelationFilter>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SystemRating = {
  __typename?: 'SystemRating';
  carrier_average: Scalars['Int']['output'];
  carrier_average_sum: Scalars['Int']['output'];
  carrier_count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  shipper_average: Scalars['Int']['output'];
  shipper_average_sum: Scalars['Int']['output'];
  shipper_count: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TemplateLine = {
  available: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type Theme = {
  __typename?: 'Theme';
  _count: ThemeCount;
  company_settings?: Maybe<Array<CompanySettings>>;
  config: Scalars['JSON']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ThemeCount = {
  __typename?: 'ThemeCount';
  company_settings: Scalars['Int']['output'];
};

export type ThemeCountGraphQlOutput = {
  __typename?: 'ThemeCountGraphQLOutput';
  company_settings: Scalars['Int']['output'];
};

export type ThemeGraphQlOutput = {
  __typename?: 'ThemeGraphQLOutput';
  _count: ThemeCountGraphQlOutput;
  config: Scalars['JSONObject']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ThemeOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type ThemeWhereInput = {
  AND?: InputMaybe<Array<ThemeWhereInput>>;
  NOT?: InputMaybe<Array<ThemeWhereInput>>;
  OR?: InputMaybe<Array<ThemeWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export enum TruckerRolesEnum {
  Administrator = 'ADMINISTRATOR',
  Carrier = 'CARRIER',
  Quotator = 'QUOTATOR',
  Shipper = 'SHIPPER',
  Support = 'SUPPORT'
}

export enum UnitMeasureEnum {
  Centimeters = 'CENTIMETERS',
  Grams = 'GRAMS',
  Kilograms = 'KILOGRAMS',
  Kilometers = 'KILOMETERS',
  Meters = 'METERS',
  Milimeters = 'MILIMETERS',
  Milligrams = 'MILLIGRAMS',
  Tons = 'TONS'
}

export enum UnitTypeEnum {
  Kg = 'KG',
  Ton = 'TON',
  Unit = 'UNIT'
}

export type UnlinkRoleInput = {
  role_to_unlink: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type UnloadInput = {
  cte_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
};

export type UpdateAddressCompanyInput = {
  city_id?: InputMaybe<Scalars['Int']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip_code_address?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCancellationReason = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<CancellationTriggerEnum>;
};

export type UpdateCommissionPaymentInput = {
  paid_in?: InputMaybe<Scalars['DateTime']['input']>;
  quotation_id: Scalars['String']['input'];
};

export type UpdateCompanySettingsGraphQlInput = {
  changer_id: Scalars['String']['input'];
  company_id: Scalars['String']['input'];
  theme_id: Scalars['String']['input'];
};

export type UpdateGroupInput = {
  carriers_to_add?: InputMaybe<Array<IdDto>>;
  carriers_to_remove?: InputMaybe<Array<IdDto>>;
  group_id: Scalars['String']['input'];
  new_name?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
};

export type UpdateManyCancellationReasonInput = {
  cancellation_reasons: Array<UpdateCancellationReason>;
};

export type UpdateManyPackingsGraphQlInput = {
  data: Array<UpdatePackingGraphQlInput>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProductsInput = {
  data: Array<UpdateProductInput>;
};

export type UpdateManyUserHasPermissionsInput = {
  permissions: Array<EnablePermissionInput>;
  user_id: Scalars['String']['input'];
};

export type UpdateManyUserPermissionsInput = {
  data: Array<UpdateUserPermissionInput>;
};

export type UpdateModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePackingGraphQlInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  measuring_unity?: InputMaybe<UnitTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  packing_id: Scalars['String']['input'];
};

export type UpdatePermissionTemplateInput = {
  new_permissions_ids: Array<PermissionId>;
  permission_ids_to_delete: Array<PermissionId>;
  role: TruckerRolesEnum;
};

export type UpdatePlaceInput = {
  balance_capacity?: InputMaybe<Scalars['Int']['input']>;
  cadence?: InputMaybe<Scalars['Int']['input']>;
  city_id?: InputMaybe<Scalars['Int']['input']>;
  closing_hour?: InputMaybe<Scalars['DateTime']['input']>;
  dirt_road_distance?: InputMaybe<Scalars['Int']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  has_dirt_road?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  opening_hour?: InputMaybe<Scalars['DateTime']['input']>;
  state_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['String']['input'];
  type_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuotationConfirmationInput = {
  assigned_volume?: InputMaybe<Scalars['Int']['input']>;
  confirmation_id: Scalars['String']['input'];
  vehicle_plate?: InputMaybe<Scalars['String']['input']>;
  vehicle_type_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuotationConfirmationsInput = {
  data: Array<UpdateQuotationConfirmationInput>;
  quotation_id: Scalars['String']['input'];
};

export type UpdateRatingReasonInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<RatingTriggerEnum>;
};

export type UpdateRefusalReasonInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<RefusalTriggerEnum>;
};

export type UpdateRefusalReasonsInput = {
  data: Array<UpdateRefusalReasonInput>;
};

export type UpdateThemeGraphQlInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  theme_id: Scalars['ID']['input'];
};

export type UpdateUserPermissionInput = {
  active: Scalars['Boolean']['input'];
  user_permission_id: Scalars['String']['input'];
};

export type UploadLogoInput = {
  company_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  _count: UserCount;
  active: Scalars['Boolean']['output'];
  changed_company_settings?: Maybe<Array<CompanySettings>>;
  companies?: Maybe<Array<UserHasCompany>>;
  companiesStatus?: Maybe<Array<CompanyHasStatus>>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  files?: Maybe<Array<Files>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  policies?: Maybe<Array<Policy>>;
  updated_at: Scalars['DateTime']['output'];
};

export type UserCount = {
  __typename?: 'UserCount';
  changed_company_settings: Scalars['Int']['output'];
  companies: Scalars['Int']['output'];
  companiesStatus: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  policies: Scalars['Int']['output'];
};

export type UserHasCompany = {
  __typename?: 'UserHasCompany';
  company: Company;
  company_id: Scalars['String']['output'];
  user: User;
  user_id: Scalars['String']['output'];
};

export type UserHasCompanyGraphqQlOutput = {
  __typename?: 'UserHasCompanyGraphqQLOutput';
  company: CompanyGraphQlOutput;
  company_id: Scalars['ID']['output'];
  user: UserMinimalGraphQlOutput;
  user_id: Scalars['ID']['output'];
};

export type UserHasCompanyListRelationFilter = {
  every?: InputMaybe<UserHasCompanyWhereInput>;
  none?: InputMaybe<UserHasCompanyWhereInput>;
  some?: InputMaybe<UserHasCompanyWhereInput>;
};

export type UserHasCompanyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserHasCompanyWhereInput = {
  AND?: InputMaybe<Array<UserHasCompanyWhereInput>>;
  NOT?: InputMaybe<Array<UserHasCompanyWhereInput>>;
  OR?: InputMaybe<Array<UserHasCompanyWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  company_id?: InputMaybe<UuidFilter>;
  user?: InputMaybe<UserRelationFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type UserHasPermission = {
  __typename?: 'UserHasPermission';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  enable: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  user: AuthUser;
  user_id: Scalars['String']['output'];
  user_permission: UserPermission;
  user_permission_id: Scalars['String']['output'];
};

export type UserHasPermissionListRelationFilter = {
  every?: InputMaybe<UserHasPermissionWhereInput>;
  none?: InputMaybe<UserHasPermissionWhereInput>;
  some?: InputMaybe<UserHasPermissionWhereInput>;
};

export type UserHasPermissionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserHasPermissionOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  enable?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  user?: InputMaybe<AuthUserOrderByWithRelationInput>;
  user_id?: InputMaybe<SortOrder>;
  user_permission?: InputMaybe<UserPermissionOrderByWithRelationInput>;
  user_permission_id?: InputMaybe<SortOrder>;
};

export type UserHasPermissionWhereInput = {
  AND?: InputMaybe<Array<UserHasPermissionWhereInput>>;
  NOT?: InputMaybe<Array<UserHasPermissionWhereInput>>;
  OR?: InputMaybe<Array<UserHasPermissionWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  enable?: InputMaybe<BoolFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<AuthUserRelationFilter>;
  user_id?: InputMaybe<UuidFilter>;
  user_permission?: InputMaybe<UserPermissionRelationFilter>;
  user_permission_id?: InputMaybe<UuidFilter>;
};

export type UserHasRole = {
  __typename?: 'UserHasRole';
  active: Scalars['Boolean']['output'];
  role: Role;
  role_id: Scalars['String']['output'];
  user: AuthUser;
  user_id: Scalars['String']['output'];
};

export type UserHasSomeRoleInput = {
  roles: Array<Scalars['String']['input']>;
  user_id: Scalars['String']['input'];
};

export type UserHasSomeRoleResponse = {
  __typename?: 'UserHasSomeRoleResponse';
  has_some: Scalars['Boolean']['output'];
};

export enum UserInternalAvailableRolesEnum {
  Carrier = 'CARRIER',
  Quotator = 'QUOTATOR',
  Shipper = 'SHIPPER'
}

export type UserMinimalGraphQlOutput = {
  __typename?: 'UserMinimalGraphQLOutput';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type UserModel = {
  __typename?: 'UserModel';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type UserOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  companies?: InputMaybe<UserHasCompanyOrderByRelationAggregateInput>;
  companiesStatus?: InputMaybe<CompanyHasStatusOrderByRelationAggregateInput>;
  created_at?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  files?: InputMaybe<FilesOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  policies?: InputMaybe<PolicyOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  _count: UserPermissionCount;
  action: Action;
  action_id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  module: Module;
  module_id: Scalars['String']['output'];
  permissions?: Maybe<Array<UserHasPermission>>;
  templates?: Maybe<Array<PermissionTemplate>>;
  updated_at: Scalars['DateTime']['output'];
};

export type UserPermissionCount = {
  __typename?: 'UserPermissionCount';
  permissions: Scalars['Int']['output'];
  templates: Scalars['Int']['output'];
};

export type UserPermissionOrderByWithRelationInput = {
  action?: InputMaybe<ActionOrderByWithRelationInput>;
  action_id?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  module?: InputMaybe<ModuleOrderByWithRelationInput>;
  module_id?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<UserHasPermissionOrderByRelationAggregateInput>;
  templates?: InputMaybe<PermissionTemplateOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export type UserPermissionRelationFilter = {
  is?: InputMaybe<UserPermissionWhereInput>;
  isNot?: InputMaybe<UserPermissionWhereInput>;
};

export type UserPermissionWhereInput = {
  AND?: InputMaybe<Array<UserPermissionWhereInput>>;
  NOT?: InputMaybe<Array<UserPermissionWhereInput>>;
  OR?: InputMaybe<Array<UserPermissionWhereInput>>;
  action?: InputMaybe<ActionRelationFilter>;
  action_id?: InputMaybe<UuidFilter>;
  active?: InputMaybe<BoolFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  module?: InputMaybe<ModuleRelationFilter>;
  module_id?: InputMaybe<UuidFilter>;
  permissions?: InputMaybe<UserHasPermissionListRelationFilter>;
  templates?: InputMaybe<PermissionTemplateListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserRoles = {
  __typename?: 'UserRoles';
  roles?: Maybe<Array<Scalars['String']['output']>>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  companies?: InputMaybe<UserHasCompanyListRelationFilter>;
  companiesStatus?: InputMaybe<CompanyHasStatusListRelationFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  files?: InputMaybe<FilesListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  policies?: InputMaybe<PolicyListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ValidateTokenInput = {
  token: Scalars['String']['input'];
};

export type ValidateTokenResponse = {
  __typename?: 'ValidateTokenResponse';
  user_id: Scalars['String']['output'];
};

export type VarietiesGraphQlOutput = {
  __typename?: 'VarietiesGraphQLOutput';
  data: Array<VarietyGraphQlOutput>;
  length: Scalars['Int']['output'];
};

export type Variety = {
  __typename?: 'Variety';
  _count: VarietyCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<FreightCompany>;
  owner_id?: Maybe<Scalars['String']['output']>;
  product: Product;
  product_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type VarietyCount = {
  __typename?: 'VarietyCount';
  freights: Scalars['Int']['output'];
};

export type VarietyGraphQlOutput = {
  __typename?: 'VarietyGraphQLOutput';
  _count: VarietyCount;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<FreightCompanyMinimalGraphQlOutput>;
  owner_id?: Maybe<Scalars['String']['output']>;
  product: ProductMinimalGraphQlOutput;
  product_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type VarietyMinimalGraphQlOutput = {
  __typename?: 'VarietyMinimalGraphQLOutput';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner_id?: Maybe<Scalars['String']['output']>;
  product_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type VarietyOrderByWithRelationInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner_id?: InputMaybe<SortOrder>;
  product_id?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type VarietyRelationFilter = {
  is?: InputMaybe<VarietyWhereInput>;
  isNot?: InputMaybe<VarietyWhereInput>;
};

export type VarietyWhereInput = {
  AND?: InputMaybe<Array<VarietyWhereInput>>;
  NOT?: InputMaybe<Array<VarietyWhereInput>>;
  OR?: InputMaybe<Array<VarietyWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  owner_id?: InputMaybe<UuidNullableFilter>;
  product_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  _count: VehicleTypeCount;
  capacity: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  measuring_unity: UnitMeasureEnum;
  name: Scalars['String']['output'];
  quotation_confirmations?: Maybe<Array<QuotationConfirmation>>;
  updated_at: Scalars['DateTime']['output'];
};

export type VehicleTypeCount = {
  __typename?: 'VehicleTypeCount';
  quotation_confirmations: Scalars['Int']['output'];
};

export type VehicleTypeOrderByWithRelationInput = {
  capacity?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  measuring_unity?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  quotation_confirmations?: InputMaybe<QuotationConfirmationOrderByRelationAggregateInput>;
  updated_at?: InputMaybe<SortOrder>;
};

export type VehicleTypeRelationFilter = {
  is?: InputMaybe<VehicleTypeWhereInput>;
  isNot?: InputMaybe<VehicleTypeWhereInput>;
};

export type VehicleTypeWhereInput = {
  AND?: InputMaybe<Array<VehicleTypeWhereInput>>;
  NOT?: InputMaybe<Array<VehicleTypeWhereInput>>;
  OR?: InputMaybe<Array<VehicleTypeWhereInput>>;
  capacity?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  measuring_unity?: InputMaybe<EnumUnitMeasureEnumFilter>;
  name?: InputMaybe<StringFilter>;
  quotation_confirmations?: InputMaybe<QuotationConfirmationListRelationFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type WaiverQuotationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  quotation_id: Scalars['String']['input'];
  reason_id: Scalars['String']['input'];
};

export type ZipCode = {
  __typename?: 'ZipCode';
  _count: ZipCodeCount;
  active: Scalars['Int']['output'];
  address?: Maybe<Array<Address>>;
  city?: Maybe<City>;
  city_id?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<District>;
  district_id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_name_without_accent?: Maybe<Scalars['String']['output']>;
  street_without_accent?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_without_accent?: Maybe<Scalars['String']['output']>;
  zip_code: Scalars['String']['output'];
};

export type ZipCodeCount = {
  __typename?: 'ZipCodeCount';
  address: Scalars['Int']['output'];
};

export type ZipCodeGraphQlOutput = {
  __typename?: 'ZipCodeGraphQLOutput';
  active: Scalars['Int']['output'];
  city?: Maybe<CityGraphQlOutput>;
  city_id?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<DistrictGraphQlOutput>;
  district_id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateGraphQlOutput>;
  state_id?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_name_without_accent?: Maybe<Scalars['String']['output']>;
  street_without_accent?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_without_accent?: Maybe<Scalars['String']['output']>;
  zip_code: Scalars['String']['output'];
};

export type ZipCodeListRelationFilter = {
  every?: InputMaybe<ZipCodeWhereInput>;
  none?: InputMaybe<ZipCodeWhereInput>;
  some?: InputMaybe<ZipCodeWhereInput>;
};

export type ZipCodeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ZipCodeOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  address?: InputMaybe<AddressOrderByRelationAggregateInput>;
  city?: InputMaybe<CityOrderByWithRelationInput>;
  city_id?: InputMaybe<SortOrderInput>;
  district?: InputMaybe<DistrictOrderByWithRelationInput>;
  district_id?: InputMaybe<SortOrderInput>;
  latitude?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<StateOrderByWithRelationInput>;
  state_id?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrderInput>;
  street_name?: InputMaybe<SortOrderInput>;
  street_name_without_accent?: InputMaybe<SortOrderInput>;
  street_without_accent?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  type_without_accent?: InputMaybe<SortOrderInput>;
  zip_code?: InputMaybe<SortOrder>;
};

export type ZipCodeRelationFilter = {
  is?: InputMaybe<ZipCodeWhereInput>;
  isNot?: InputMaybe<ZipCodeWhereInput>;
};

export type ZipCodeWhereInput = {
  AND?: InputMaybe<Array<ZipCodeWhereInput>>;
  NOT?: InputMaybe<Array<ZipCodeWhereInput>>;
  OR?: InputMaybe<Array<ZipCodeWhereInput>>;
  active?: InputMaybe<IntFilter>;
  address?: InputMaybe<AddressListRelationFilter>;
  city?: InputMaybe<CityRelationFilter>;
  city_id?: InputMaybe<IntNullableFilter>;
  district?: InputMaybe<DistrictRelationFilter>;
  district_id?: InputMaybe<IntNullableFilter>;
  latitude?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StateRelationFilter>;
  state_id?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  street_name?: InputMaybe<StringNullableFilter>;
  street_name_without_accent?: InputMaybe<StringNullableFilter>;
  street_without_accent?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  type_without_accent?: InputMaybe<StringNullableFilter>;
  zip_code?: InputMaybe<StringFilter>;
};

export type CompanyAddressDescriptionsFragment = { __typename?: 'Address', id: string, zip_code_address?: string | null, street?: string | null, number?: string | null, district?: { __typename?: 'District', district_name: string } | null, state?: { __typename?: 'State', initials: string } | null, city: { __typename?: 'City', city_name: string } };

export type CompanyDataDescriptionsFragment = { __typename?: 'Company', id: string, document_number: string, trade_name?: string | null, company_name: string, company_type: CompanyTypeEnum, company_function: FunctionEnum };

export type CompanyNameFragment = { __typename?: 'Company', company_name: string, trade_name?: string | null, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null };

export type FreightCompanyNameFragment = { __typename?: 'FreightCompany', company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null };

export type CompanyGraphQlOutputNameFragment = { __typename?: 'CompanyGraphQLOutput', company_name: string, trade_name?: string | null, address?: { __typename?: 'AddressGraphQLOutput', city?: { __typename?: 'CityGraphQLOutput', city_name: string, state_id: string } | null } | null };

export type CompanySelectFragment = { __typename?: 'Company', id: string, document_number: string, company_function: FunctionEnum, company_name: string, trade_name?: string | null, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null };

export type FreightCompanySelectFragment = { __typename?: 'FreightCompany', id: string, document_number: string, company_function: FreightFunctionEnum, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null };

export type LastCompanyStatusTagFragment = { __typename?: 'CompanyHasStatus', status: CompanyStatusEnum, updated_at: string };

export type FormattedRouteFragment = { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null };

export type CarrierHiredFreightFragment = { __typename?: 'Quotation', id: string, value_per_unit: number, value_unit_type: UnitTypeEnum, requested_volume: number, freight: { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, unit_type: UnitTypeEnum, status: { __typename?: 'FreightStatus', name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number } }, status: { __typename?: 'QuotationStatus', name: string } };

export type CarrierListFreightsQueryVariables = Exact<{
  carrierId: Scalars['String']['input'];
  quotingInput?: InputMaybe<FreightWhereInput>;
  pagination?: InputMaybe<Pagination>;
}>;


export type CarrierListFreightsQuery = { __typename?: 'Query', FindManyCarrierFreightsQuoting: { __typename?: 'Freights', length: number, data: Array<{ __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, quote_limit: string, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, product: { __typename?: 'Product', id: string, name: string }, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, quotations?: Array<{ __typename?: 'Quotation', id: string }> | null }> } };

export type ListFreightsByQuotationQueryVariables = Exact<{
  quotedInput?: InputMaybe<QuotationWhereInput>;
  hiredInput?: InputMaybe<QuotationWhereInput>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ListFreightsByQuotationQuery = { __typename?: 'Query', FindManyQuotationQuoted: Array<{ __typename?: 'Quotation', id: string, value_per_unit: number, value_unit_type: UnitTypeEnum, total_volume: number, freight: { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, quote_limit: string, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number } } }>, FindManyQuotationHired: Array<{ __typename?: 'Quotation', id: string, value_per_unit: number, value_unit_type: UnitTypeEnum, requested_volume: number, freight: { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, status: { __typename?: 'FreightStatus', name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number } }, status: { __typename?: 'QuotationStatus', name: string } }> };

export type CarrierQuotedFreightFragment = { __typename?: 'Quotation', id: string, value_per_unit: number, value_unit_type: UnitTypeEnum, total_volume: number, freight: { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, quote_limit: string, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number } } };

export type CarrierQuotingFreightFragment = { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, quote_limit: string, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number } };

export type AttachmentsTableModal_DetachFileMutationVariables = Exact<{
  input: DetachOneFileFromFreightGraphQlRequest;
}>;


export type AttachmentsTableModal_DetachFileMutation = { __typename?: 'Mutation', DetachOneFileFromFreight: { __typename?: 'DetachOneFileFromFreightGraphQLResponse', attachment_id: string } };

export type AttachmentsTableModal_FindAllAttachmentsQueryVariables = Exact<{
  freightId: Scalars['String']['input'];
}>;


export type AttachmentsTableModal_FindAllAttachmentsQuery = { __typename?: 'Query', ListAllFreightAttachments: { __typename?: 'FreightAttachmentsGraphQLResponse', length: number, data: Array<{ __typename?: 'FreightAttachmentGraphQLResponse', created_at: string, short_description?: string | null, file_id: string, file?: { __typename?: 'FileGraphQLResponse', filename: string, mimetype: string, url: string } | null }> } };

export type FreightDetails_CompanyDetailsFragment = { __typename?: 'Company', id: string, document_number: string, trade_name?: string | null, company_name: string, company_type: CompanyTypeEnum, company_function: FunctionEnum, address?: { __typename?: 'Address', id: string, zip_code_address?: string | null, street?: string | null, number?: string | null, district?: { __typename?: 'District', district_name: string } | null, state?: { __typename?: 'State', initials: string } | null, city: { __typename?: 'City', city_name: string } } | null, contacts?: Array<{ __typename?: 'Contact', phone: string, email: string }> | null, policies?: Array<{ __typename?: 'Policy', id: string, name: string, expires_in: string, bucket_url: string }> | null };

export type FreightDetailsQueryVariables = Exact<{
  freightId: Scalars['String']['input'];
}>;


export type FreightDetailsQuery = { __typename?: 'Query', FindFreight: { __typename?: 'Freight', id: string, total_volume: number, suggested_value?: number | null, note_value?: number | null, observation?: string | null, landing_date: string, shipment_date: string, quote_limit: string, allocated_volume: number, loaded_volume: number, unallocated_volume: number, unit_type: UnitTypeEnum, child?: { __typename?: 'Freight', id: string } | null, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string }, route: { __typename?: 'Route', id: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, move_type: MoveTypeEnum, name: string, city: { __typename?: 'FreightCity', city_name: string, state_id: string } }> | null }, quotations?: Array<{ __typename?: 'Quotation', id: string, has_vehicle: boolean, total_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, loaded_volume: number, owner: { __typename?: 'FreightCompany', id: string, reference_external_company_id: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, status: { __typename?: 'QuotationStatus', id: string, name: string }, creator: { __typename?: 'FreightUser', email: string }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum } }> | null, status: { __typename?: 'FreightStatus', id: string, name: string }, related_groups?: Array<{ __typename?: 'GroupFreight', group: { __typename?: 'Group', id: string, name: string, created_at: string, updated_at: string, members?: Array<{ __typename?: 'CompanyInGroup', company: { __typename?: 'FreightCompany', id: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null } }> | null } }> | null } };

export type FreightDetails_CompanyDetailsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type FreightDetails_CompanyDetailsQuery = { __typename?: 'Query', FindCompany: { __typename?: 'Company', id: string, document_number: string, trade_name?: string | null, company_name: string, company_type: CompanyTypeEnum, company_function: FunctionEnum, address?: { __typename?: 'Address', id: string, zip_code_address?: string | null, street?: string | null, number?: string | null, district?: { __typename?: 'District', district_name: string } | null, state?: { __typename?: 'State', initials: string } | null, city: { __typename?: 'City', city_name: string } } | null, contacts?: Array<{ __typename?: 'Contact', phone: string, email: string }> | null, policies?: Array<{ __typename?: 'Policy', id: string, name: string, expires_in: string, bucket_url: string }> | null } };

export type HireQuotationsMutationVariables = Exact<{
  input: HireQuotationsInput;
}>;


export type HireQuotationsMutation = { __typename?: 'Mutation', HireQuotations: { __typename?: 'Freight', id: string } };

export type FreightLoadDescriptionsFragment = { __typename?: 'Freight', id: string, total_volume: number, unit_type: UnitTypeEnum, suggested_value?: number | null, note_value?: number | null, observation?: string | null, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string } };

export type FreightPlaceDescriptionsFragment = { __typename?: 'Freight', landing_date: string, shipment_date: string, quote_limit: string, route: { __typename?: 'Route', id: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, move_type: MoveTypeEnum, name: string, city: { __typename?: 'FreightCity', city_name: string, state_id: string } }> | null } };

export type FreightVolumeBarFragment = { __typename?: 'Freight', allocated_volume: number, loaded_volume: number, total_volume: number, unallocated_volume: number, unit_type: UnitTypeEnum };

export type ConfirmFreightDatesFragment = { __typename?: 'Freight', shipment_date: string, landing_date: string };

export type ConfirmFreightLoadFragment = { __typename?: 'Freight', note_value?: number | null, observation?: string | null, suggested_value?: number | null, total_volume: number, unit_type: UnitTypeEnum, packing: { __typename?: 'Packing', name: string }, product: { __typename?: 'Product', name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, product_type: { __typename?: 'ProductType', name: string } };

export type CreateFreightMutationVariables = Exact<{
  input: CreateFreightInput;
}>;


export type CreateFreightMutation = { __typename?: 'Mutation', CreateFreight: { __typename?: 'Freight', id: string } };

export type CreateMissingFreightMutationVariables = Exact<{
  input: CreateMissingFreightInput;
}>;


export type CreateMissingFreightMutation = { __typename?: 'Mutation', CreateMissingFreight: { __typename?: 'Freight', id: string } };

export type CreatePlaceModalMutationVariables = Exact<{
  input: CreatePlaceInput;
}>;


export type CreatePlaceModalMutation = { __typename?: 'Mutation', CreatePlace: { __typename?: 'Place', id: string, name: string, state_id: string, city_id: number, city_name: string, cadence: number, has_dirt_road: boolean, dirt_road_distance: number, has_balance: boolean, balance_capacity?: number | null, note?: string | null } };

export type FindPlacesForPlaceTableQueryVariables = Exact<{
  where: FindPlacesWhereInput;
}>;


export type FindPlacesForPlaceTableQuery = { __typename?: 'Query', FindPlaces: Array<{ __typename?: 'Place', id: string, name: string, state_id: string, city_id: number, city_name: string, cadence: number, has_dirt_road: boolean, dirt_road_distance: number, has_balance: boolean, note?: string | null }> };

export type PlaceTableItemFragment = { __typename?: 'Place', id: string, name: string, state_id: string, city_id: number, city_name: string, cadence: number, has_dirt_road: boolean, dirt_road_distance: number, has_balance: boolean, note?: string | null };

export type PlaceDetailsModalQueryVariables = Exact<{
  input: FindPlaceInput;
}>;


export type PlaceDetailsModalQuery = { __typename?: 'Query', FindPlace: { __typename?: 'Place', id: string, name: string, state_id: string, city_name: string, opening_hour: string, closing_hour: string, cadence: number, balance_capacity?: number | null, dirt_road_distance: number, note?: string | null, latitude: string, longitude: string } };

export type UpdatePlaceMutationVariables = Exact<{
  input: UpdatePlaceInput;
}>;


export type UpdatePlaceMutation = { __typename?: 'Mutation', UpdatePlace: { __typename?: 'Place', id: string, name: string, state_id: string, city_id: number, city_name: string, cadence: number, has_dirt_road: boolean, dirt_road_distance: number, has_balance: boolean, note?: string | null } };

export type PlaceForViewPlaceFragment = { __typename?: 'PlaceRoute', id: string, name: string, state_id: string, city_name: string, cadence: number, dirt_road_distance: number, has_dirt_road: boolean, balance_capacity?: number | null, note?: string | null, opening_hour: string, closing_hour: string };

export type PlaceRouteForViewPlaceFragment = { __typename?: 'Place', id: string, name: string, state_id: string, city_name: string, cadence: number, dirt_road_distance: number, has_dirt_road: boolean, balance_capacity?: number | null, note?: string | null, opening_hour: string, closing_hour: string };

export type QuotationShortDescriptionFragment = { __typename?: 'Quotation', value_per_unit: number, value_unit_type: UnitTypeEnum, total_volume: number, requested_volume: number, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum } };

export type RefusalReasonSelectQueryVariables = Exact<{
  where?: InputMaybe<RefusalReasonWhereInput>;
  pagination?: InputMaybe<Pagination>;
}>;


export type RefusalReasonSelectQuery = { __typename?: 'Query', FindManyRefusalReasons: Array<{ __typename?: 'RefusalReason', value: string, label: string }> };

export type CreateRouteMutationVariables = Exact<{
  input: CreateRouteInput;
}>;


export type CreateRouteMutation = { __typename?: 'Mutation', CreateRoute: { __typename?: 'Route', id: string, name: string, total_distance: number, estimate_time: number, places?: Array<{ __typename?: 'PlaceRoute', id: string, name: string, city_name: string, city_id: number, state_id: string, move_type: MoveTypeEnum }> | null } };

export type ListRoutesQueryVariables = Exact<{
  where: CustomRoutesWhereInput;
}>;


export type ListRoutesQuery = { __typename?: 'Query', FindRoutes: Array<{ __typename?: 'Route', id: string, name: string, total_distance: number, estimate_time: number, places?: Array<{ __typename?: 'PlaceRoute', id: string, name: string, city_name: string, city_id: number, state_id: string, move_type: MoveTypeEnum }> | null }> };

export type FindRouteForViewRouteQueryVariables = Exact<{
  input: FindRouteInput;
}>;


export type FindRouteForViewRouteQuery = { __typename?: 'Query', FindRoute: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, name: string, state_id: string, city_name: string, cadence: number, dirt_road_distance: number, has_dirt_road: boolean, balance_capacity?: number | null, note?: string | null, opening_hour: string, closing_hour: string, move_type: MoveTypeEnum, latitude: string, longitude: string }> | null } };

export type CancelFreightMutationVariables = Exact<{
  input: CancelFreightInput;
}>;


export type CancelFreightMutation = { __typename?: 'Mutation', CancelFreight: { __typename?: 'Freight', id: string } };

export type HiredFreightFragment = { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, status: { __typename?: 'FreightStatus', id: string, name: string }, quotations?: Array<{ __typename?: 'Quotation', id: string, value_per_unit: number, value_unit_type: UnitTypeEnum, status: { __typename?: 'QuotationStatus', id: string, name: string } }> | null };

export type ListFreightsQueryVariables = Exact<{
  quotingInput?: InputMaybe<FreightWhereInput>;
  quotedInput?: InputMaybe<FreightWhereInput>;
  hiredInput?: InputMaybe<FreightWhereInput>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ListFreightsQuery = { __typename?: 'Query', FindManyFreightsQuoting: Array<{ __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, quote_limit: string, expires_in?: string | null, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, quotations?: Array<{ __typename?: 'Quotation', id: string }> | null }>, FindManyFreightsQuoted: Array<{ __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, expires_in?: string | null, quote_limit: string, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, quotations?: Array<{ __typename?: 'Quotation', id: string }> | null }>, FindManyFreightsHired: Array<{ __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, status: { __typename?: 'FreightStatus', id: string, name: string }, quotations?: Array<{ __typename?: 'Quotation', id: string, value_per_unit: number, value_unit_type: UnitTypeEnum, status: { __typename?: 'QuotationStatus', id: string, name: string } }> | null }> };

export type QuotedFreightFragment = { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, expires_in?: string | null, quote_limit: string, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, quotations?: Array<{ __typename?: 'Quotation', id: string }> | null };

export type QuotingFreightFragment = { __typename?: 'Freight', id: string, numeric_id: number, landing_date: string, shipment_date: string, total_volume: number, unit_type: UnitTypeEnum, quote_limit: string, expires_in?: string | null, status: { __typename?: 'FreightStatus', id: string, name: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, city_name: string, state_id: string, move_type: MoveTypeEnum }> | null }, product_type: { __typename?: 'ProductType', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null, packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number }, quotations?: Array<{ __typename?: 'Quotation', id: string }> | null };

export type AttachmentForm_AttachFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  input: AttachFileOnFreightGraphQlRequest;
}>;


export type AttachmentForm_AttachFileMutation = { __typename?: 'Mutation', AttachFileOnFreight: { __typename?: 'FreightAttachmentGraphQLResponse', created_at: string, short_description?: string | null, file_id: string, file?: { __typename?: 'FileGraphQLResponse', filename: string, mimetype: string, url: string } | null } };

export type AttachmentsTableFragment = { __typename?: 'FreightAttachmentGraphQLResponse', created_at: string, short_description?: string | null, file_id: string, file?: { __typename?: 'FileGraphQLResponse', filename: string, mimetype: string, url: string } | null };

export type FindPackagesQueryVariables = Exact<{
  where?: InputMaybe<PackingWhereInput>;
  pagination?: InputMaybe<Pagination>;
  order_by?: InputMaybe<PackingOrderByWithRelationInput>;
}>;


export type FindPackagesQuery = { __typename?: 'Query', FindManyPackings: { __typename?: 'PackingsGraphQLOutput', length: number, data: Array<{ __typename?: 'PackingGraphQLOutput', id: string, name: string, measuring_unity: UnitTypeEnum }> } };

export type CreateManyProductsMutationVariables = Exact<{
  input: CreateManyProductsInput;
}>;


export type CreateManyProductsMutation = { __typename?: 'Mutation', CreateManyProducts: { __typename?: 'ProductsGraphQLOutput', length: number, data: Array<{ __typename?: 'ProductGraphQLOutput', id: string, name: string, product_type: { __typename?: 'ProductTypeMinimalGraphQLOutput', id: string, name: string } }> } };

export type DeleteProductsMutationVariables = Exact<{
  input: DeleteManyProductsInput;
}>;


export type DeleteProductsMutation = { __typename?: 'Mutation', DeleteManyProducts: { __typename?: 'ProductsGraphQLOutput', length: number, data: Array<{ __typename?: 'ProductGraphQLOutput', id: string }> } };

export type FindProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
  pagination?: InputMaybe<Pagination>;
  order_by?: InputMaybe<ProductOrderByWithRelationInput>;
}>;


export type FindProductsQuery = { __typename?: 'Query', FindManyProducts: { __typename?: 'ProductsGraphQLOutput', length: number, data: Array<{ __typename?: 'ProductGraphQLOutput', id: string, name: string, product_type: { __typename?: 'ProductTypeMinimalGraphQLOutput', id: string, name: string } }> } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateManyProductsInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', UpdateManyProducts: { __typename?: 'ProductsGraphQLOutput', length: number, data: Array<{ __typename?: 'ProductGraphQLOutput', id: string, name: string, product_type: { __typename?: 'ProductTypeMinimalGraphQLOutput', id: string, name: string } }> } };

export type ProductWithVarietyFragment = { __typename?: 'Freight', product: { __typename?: 'Product', name: string }, product_variety?: { __typename?: 'Variety', id: string, name: string } | null };

export type CreateProductTypesMutationVariables = Exact<{
  input: CreateManyProductTypesInput;
}>;


export type CreateProductTypesMutation = { __typename?: 'Mutation', CreateManyProductTypes: Array<{ __typename?: 'ProductType', id: string, name: string }> };

export type DeleteProductTypesMutationVariables = Exact<{
  input: DeleteManyProductTypesInput;
}>;


export type DeleteProductTypesMutation = { __typename?: 'Mutation', DeleteManyProductTypes: Array<{ __typename?: 'ProductType', id: string }> };

export type FindProductTypesQueryVariables = Exact<{
  where?: InputMaybe<ProductTypeWhereInput>;
  pagination?: InputMaybe<Pagination>;
  order_by?: InputMaybe<ProductTypeOrderByWithRelationInput>;
  detailed?: Scalars['Boolean']['input'];
}>;


export type FindProductTypesQuery = { __typename?: 'Query', FindManyProductTypes: Array<{ __typename?: 'ProductType', id: string, name: string, product?: Array<{ __typename?: 'Product', id: string, name: string }> | null, product_type_has_packing?: Array<{ __typename?: 'ProductTypeHasPacking', packing: { __typename?: 'Packing', id: string, name: string, measuring_unity: UnitTypeEnum, capacity: number } }> | null }> };

export type ProductVarietyQueryVariables = Exact<{
  orderBy?: InputMaybe<VarietyOrderByWithRelationInput>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<Pagination>;
  productId: Scalars['ID']['input'];
  where?: InputMaybe<VarietyWhereInput>;
}>;


export type ProductVarietyQuery = { __typename?: 'Query', FindManyVarieties: { __typename?: 'VarietiesGraphQLOutput', length: number, data: Array<{ __typename?: 'VarietyGraphQLOutput', id: string, name: string }> } };

export type AbandonOrCancelQuotationModalQueryVariables = Exact<{
  quotation_id: Scalars['String']['input'];
}>;


export type AbandonOrCancelQuotationModalQuery = { __typename?: 'Query', FindQuotation: { __typename?: 'Quotation', id: string, has_vehicle: boolean, loaded_volume: number, requested_volume: number, unallocated_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, owner: { __typename?: 'FreightCompany', company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum } } };

export type AbandonQuotationMutationVariables = Exact<{
  input: AbandonQuotationInput;
}>;


export type AbandonQuotationMutation = { __typename?: 'Mutation', AbandonQuotation: { __typename?: 'Quotation', id: string } };

export type CancelQuotationMutationVariables = Exact<{
  input: CancelQuotationInput;
}>;


export type CancelQuotationMutation = { __typename?: 'Mutation', CancelQuotation: { __typename?: 'Quotation', id: string, has_vehicle: boolean, loaded_volume: number, requested_volume: number, unallocated_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, owner: { __typename?: 'FreightCompany', company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum }, status: { __typename?: 'QuotationStatus', id: string, name: string } } };

export type CancellationReasonsSelectQueryVariables = Exact<{
  where?: InputMaybe<CustomCancellationReasonsWhereInput>;
  pagination?: InputMaybe<Pagination>;
}>;


export type CancellationReasonsSelectQuery = { __typename?: 'Query', FindManyCancellationReasons: Array<{ __typename?: 'CancellationReason', value: string, label: string }> };

export type ConfirmQuotationFragment = { __typename?: 'Quotation', id: string, expires_in?: string | null, requested_volume: number, unallocated_volume: number, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum, route: { __typename?: 'Route', places?: Array<{ __typename?: 'PlaceRoute', has_balance: boolean, balance_capacity?: number | null, move_type: MoveTypeEnum }> | null } }, confirmations?: Array<{ __typename?: 'QuotationConfirmation', id: string, assigned_volume: number, vehicle_plate: string, driver: { __typename?: 'Driver', id: string, name: string, cnh: string }, vehicle_type: { __typename?: 'VehicleType', id: string, name: string } }> | null };

export type ConfirmQuotationFormFragment = { __typename?: 'Quotation', requested_volume: number, unallocated_volume: number, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum, route: { __typename?: 'Route', places?: Array<{ __typename?: 'PlaceRoute', has_balance: boolean, balance_capacity?: number | null, move_type: MoveTypeEnum }> | null } } };

export type FindDriverQueryVariables = Exact<{
  cnh: Scalars['String']['input'];
  carrier_id: Scalars['String']['input'];
}>;


export type FindDriverQuery = { __typename?: 'Query', FindDriver: { __typename?: 'Driver', id: string, name: string } };

export type QuotationConfirmationSelectFragment = { __typename?: 'QuotationConfirmation', id: string, vehicle_plate: string, driver: { __typename?: 'Driver', name: string } };

export type QuotationConfirmationTableFragment = { __typename?: 'QuotationConfirmation', id: string, assigned_volume: number, vehicle_plate: string, driver: { __typename?: 'Driver', id: string, name: string, cnh: string }, vehicle_type: { __typename?: 'VehicleType', id: string, name: string }, ctes?: Array<{ __typename?: 'Cte', loaded_volume: number, unit_type: UnitTypeEnum }> | null };

export type CreateQuotationMutationVariables = Exact<{
  input: CreateQuotationInput;
}>;


export type CreateQuotationMutation = { __typename?: 'Mutation', CreateQuotation: { __typename?: 'Quotation', id: string } };

export type FindFreightForCreateQuotationQueryVariables = Exact<{
  freightId: Scalars['String']['input'];
}>;


export type FindFreightForCreateQuotationQuery = { __typename?: 'Query', FindFreight: { __typename?: 'Freight', id: string, landing_date: string, observation?: string | null, quote_limit: string, route_id: string, shipment_date: string, suggested_value?: number | null, note_value?: number | null, total_volume: number, unit_type: UnitTypeEnum, packing_id: { __typename?: 'Packing', value: string, label: string }, product_id: { __typename?: 'Product', value: string, label: string }, product_variety_id?: { __typename?: 'Variety', value: string, label: string } | null, product_type_id: { __typename?: 'ProductType', value: string, label: string }, quotations?: Array<{ __typename?: 'Quotation', value_per_unit: number, value: number }> | null, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, name: string, state_id: string, city_name: string, cadence: number, dirt_road_distance: number, has_dirt_road: boolean, balance_capacity?: number | null, note?: string | null, opening_hour: string, closing_hour: string, move_type: MoveTypeEnum, latitude: string, longitude: string }> | null } } };

export type CteTableFragment = { __typename?: 'Cte', id: string, filename: string, created_at: string, url: string, loaded_volume: number, unit_type: UnitTypeEnum, confirmation: { __typename?: 'QuotationConfirmation', id: string, vehicle_plate: string }, driver: { __typename?: 'Driver', id: string, name: string } };

export type UnloadMutationVariables = Exact<{
  input: UnloadInput;
}>;


export type UnloadMutation = { __typename?: 'Mutation', Unload: { __typename?: 'Quotation', id: string, ctes?: Array<{ __typename?: 'Cte', id: string, filename: string, url: string, created_at: string }> | null } };

export type FinishQuotationModalMutationVariables = Exact<{
  input: FinishQuotationInput;
}>;


export type FinishQuotationModalMutation = { __typename?: 'Mutation', FinishQuotation: { __typename?: 'Quotation', id: string } };

export type HireQuotationTableFragment = { __typename?: 'Quotation', id: string, has_vehicle: boolean, total_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, loaded_volume: number, owner: { __typename?: 'FreightCompany', id: string, reference_external_company_id: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, status: { __typename?: 'QuotationStatus', id: string, name: string }, creator: { __typename?: 'FreightUser', email: string }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum } };

export type QuotationDescriptionsFragment = { __typename?: 'Quotation', has_vehicle: boolean, loaded_volume: number, requested_volume: number, unallocated_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, owner: { __typename?: 'FreightCompany', company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum } };

export type CreateQuotationConfirmationsMutationVariables = Exact<{
  input: CreateQuotationConfirmationsInput;
}>;


export type CreateQuotationConfirmationsMutation = { __typename?: 'Mutation', CreateQuotationConfirmations: Array<{ __typename?: 'QuotationConfirmation', id: string, assigned_volume: number, vehicle_plate: string, driver: { __typename?: 'Driver', id: string, name: string, cnh: string }, vehicle_type: { __typename?: 'VehicleType', id: string, name: string } }> };

export type DeleteQuotationConfirmationsMutationVariables = Exact<{
  input: DeleteQuotationConfirmationsInput;
}>;


export type DeleteQuotationConfirmationsMutation = { __typename?: 'Mutation', DeleteQuotationConfirmations: Array<{ __typename?: 'QuotationConfirmation', id: string }> };

export type UpdateQuotationConfirmationsMutationVariables = Exact<{
  input: UpdateQuotationConfirmationsInput;
}>;


export type UpdateQuotationConfirmationsMutation = { __typename?: 'Mutation', UpdateQuotationConfirmations: Array<{ __typename?: 'QuotationConfirmation', id: string, assigned_volume: number, vehicle_plate: string, driver: { __typename?: 'Driver', id: string, name: string, cnh: string }, vehicle_type: { __typename?: 'VehicleType', id: string, name: string } }> };

export type QuotationDetailsQueryVariables = Exact<{
  quotationId: Scalars['String']['input'];
}>;


export type QuotationDetailsQuery = { __typename?: 'Query', FindQuotation: { __typename?: 'Quotation', id: string, requested_volume: number, unallocated_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, total_volume: number, expires_in?: string | null, status: { __typename?: 'QuotationStatus', id: string, name: string }, freight: { __typename?: 'Freight', id: string, landing_date: string, observation?: string | null, shipment_date: string, suggested_value?: number | null, total_volume: number, unit_type: UnitTypeEnum, note_value?: number | null, status: { __typename?: 'FreightStatus', name: string }, packing_id: { __typename?: 'Packing', value: string, label: string }, product_id: { __typename?: 'Product', value: string, label: string }, product_variety_id?: { __typename?: 'Variety', value: string, label: string } | null, product_type_id: { __typename?: 'ProductType', value: string, label: string }, route: { __typename?: 'Route', id: string, name: string, places?: Array<{ __typename?: 'PlaceRoute', id: string, name: string, state_id: string, city_name: string, cadence: number, dirt_road_distance: number, has_dirt_road: boolean, balance_capacity?: number | null, has_balance: boolean, note?: string | null, opening_hour: string, closing_hour: string, move_type: MoveTypeEnum, latitude: string, longitude: string }> | null } }, confirmations?: Array<{ __typename?: 'QuotationConfirmation', id: string, assigned_volume: number, vehicle_plate: string, driver: { __typename?: 'Driver', id: string, name: string, cnh: string }, vehicle_type: { __typename?: 'VehicleType', id: string, name: string }, ctes?: Array<{ __typename?: 'Cte', id: string, filename: string, created_at: string, url: string, loaded_volume: number, unit_type: UnitTypeEnum, confirmation: { __typename?: 'QuotationConfirmation', id: string, vehicle_plate: string }, driver: { __typename?: 'Driver', id: string, name: string } }> | null }> | null, cancellation?: Array<{ __typename?: 'Cancellation', description?: string | null, cancellationReason: { __typename?: 'CancellationReason', description: string } }> | null } };

export type RefuseQuotationModalMutationVariables = Exact<{
  input: HideFreightInput;
}>;


export type RefuseQuotationModalMutation = { __typename?: 'Mutation', HideFreight: { __typename?: 'Refusal', id: string } };

export type CanceledQuotationModalQueryVariables = Exact<{
  quotation_id: Scalars['String']['input'];
}>;


export type CanceledQuotationModalQuery = { __typename?: 'Query', FindQuotation: { __typename?: 'Quotation', id: string, has_vehicle: boolean, loaded_volume: number, requested_volume: number, unallocated_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, owner: { __typename?: 'FreightCompany', company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum }, cancellation?: Array<{ __typename?: 'Cancellation', description?: string | null, cancellationReason: { __typename?: 'CancellationReason', name: string } }> | null } };

export type CarrierHiredDetailsModalQueryVariables = Exact<{
  quotation_id: Scalars['String']['input'];
}>;


export type CarrierHiredDetailsModalQuery = { __typename?: 'Query', FindQuotation: { __typename?: 'Quotation', id: string, has_vehicle: boolean, loaded_volume: number, requested_volume: number, unallocated_volume: number, value_per_unit: number, value_unit_type: UnitTypeEnum, owner: { __typename?: 'FreightCompany', company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null }, freight: { __typename?: 'Freight', unit_type: UnitTypeEnum } } };

export type UploadCteModalMutationVariables = Exact<{
  input: LoadInput;
  file: Scalars['Upload']['input'];
}>;


export type UploadCteModalMutation = { __typename?: 'Mutation', Load: { __typename?: 'Quotation', ctes?: Array<{ __typename?: 'Cte', id: string, filename: string, created_at: string, url: string, loaded_volume: number, unit_type: UnitTypeEnum, confirmation: { __typename?: 'QuotationConfirmation', id: string, vehicle_plate: string }, driver: { __typename?: 'Driver', id: string, name: string } }> | null } };

export type WaiveQuotationModalMutationVariables = Exact<{
  input: WaiverQuotationInput;
}>;


export type WaiveQuotationModalMutation = { __typename?: 'Mutation', WaiverQuotation: { __typename?: 'Quotation', id: string } };

export type UserDetailsFragment = { __typename?: 'Company', id: string, company_name: string, company_type: CompanyTypeEnum, company_function: FunctionEnum, companyStatus?: Array<{ __typename?: 'CompanyHasStatus', id: string, status: CompanyStatusEnum, updated_at: string }> | null };

export type UserDetails_UpdateCompanySettingsMutationVariables = Exact<{
  input: UpdateCompanySettingsGraphQlInput;
}>;


export type UserDetails_UpdateCompanySettingsMutation = { __typename?: 'Mutation', UpdateCompanySettings: { __typename?: 'CompanySettingsGraphQLOutput', id: string } };

export type UserDetailsQueryVariables = Exact<{
  where?: InputMaybe<CompanyWhereInput>;
  order_by?: InputMaybe<CompanyOrderByWithRelationInput>;
}>;


export type UserDetailsQuery = { __typename?: 'Query', FindCompanies: Array<{ __typename?: 'Company', id: string, company_name: string, company_type: CompanyTypeEnum, company_function: FunctionEnum, document_number: string, companyStatus?: Array<{ __typename?: 'CompanyHasStatus', id: string, status: CompanyStatusEnum, updated_at: string }> | null }> };

export type VehicleTypeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypeSelectQuery = { __typename?: 'Query', FindVehicleTypes: Array<{ __typename?: 'VehicleType', value: string, label: string }> };

export type FindManyThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyThemesQuery = { __typename?: 'Query', FindManyThemes: { __typename?: 'FindManyThemesGraphQLOuput', data: Array<{ __typename?: 'ThemeGraphQLOutput', id: string, name: string }> } };

export type FindThemeQueryVariables = Exact<{
  themeId: Scalars['String']['input'];
}>;


export type FindThemeQuery = { __typename?: 'Query', FindTheme: { __typename?: 'ThemeGraphQLOutput', id: string, name: string, config: IJSONObject } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', Login: { __typename?: 'Login', access_token: string, refresh_token: string, roles?: Array<string> | null, permissions?: Array<{ __typename?: 'CachePermission', module: string, actions: Array<string> }> | null } };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', RefreshToken: { __typename?: 'Login', access_token: string, refresh_token: string, roles?: Array<string> | null, permissions?: Array<{ __typename?: 'CachePermission', module: string, actions: Array<string> }> | null } };

export type FindUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FindUserQuery = { __typename?: 'Query', FindUser: { __typename?: 'FindUserGraphQLOutput', id: string, name: string, email: string, companies?: Array<{ __typename?: 'UserHasCompanyGraphqQLOutput', company: { __typename?: 'CompanyGraphQLOutput', id: string, trade_name?: string | null, company_function: FunctionEnum, company_type: CompanyTypeEnum, document_number: string, companyStatus?: Array<{ __typename?: 'CompanyHasStatusGraphQLOutput', id: string, status: CompanyStatusEnum, updated_at: string }> | null, settings?: { __typename?: 'CompanySettingsGraphQLOutput', theme?: { __typename?: 'ThemeGraphQLOutput', id: string, config: IJSONObject } | null } | null } }> | null } };

export type DeletePlaceMutationVariables = Exact<{
  input: DeletePlaceInput;
}>;


export type DeletePlaceMutation = { __typename?: 'Mutation', DeletePlace: { __typename?: 'Place', id: string } };

export type FindPlaceQueryVariables = Exact<{
  input: FindPlaceInput;
}>;


export type FindPlaceQuery = { __typename?: 'Query', FindPlace: { __typename?: 'Place', id: string, city_id: number, city_name: string, state_id: string, opening_hour: string, closing_hour: string, cadence: number, name: string, note?: string | null, latitude: string, longitude: string, has_balance: boolean, balance_capacity?: number | null, has_dirt_road: boolean, dirt_road_distance: number } };

export type FindPlacesNamesQueryVariables = Exact<{
  where: FindPlacesWhereInput;
}>;


export type FindPlacesNamesQuery = { __typename?: 'Query', FindPlacesNames: Array<{ __typename?: 'Place', id: string, name: string }> };

export type FindCitiesByStateQueryVariables = Exact<{
  stateInitials: Scalars['String']['input'];
  withCoordinates?: Scalars['Boolean']['input'];
}>;


export type FindCitiesByStateQuery = { __typename?: 'Query', findCities: Array<{ __typename?: 'FindCities', id: number, latitude?: string | null, longitude?: string | null, cityName: string }> };

export type RecoverPassword_SendRecoveryCodeMutationVariables = Exact<{
  input: SendRecoveryCodeInput;
}>;


export type RecoverPassword_SendRecoveryCodeMutation = { __typename?: 'Mutation', SendRecoveryCode: { __typename?: 'HasSuccess', has_success: boolean } };

export type RecoverPassword_NewPasswordMutationVariables = Exact<{
  input: RecoveryPasswordInput;
}>;


export type RecoverPassword_NewPasswordMutation = { __typename?: 'Mutation', RecoveryPassword: { __typename?: 'HasSuccess', has_success: boolean } };

export type ActivateUserPageMutationVariables = Exact<{
  input: ActivateInternalUserInput;
}>;


export type ActivateUserPageMutation = { __typename?: 'Mutation', ActivateUser: { __typename?: 'HasSuccess', has_success: boolean } };

export type SignUpContext_RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type SignUpContext_RefreshTokenMutation = { __typename?: 'Mutation', RefreshToken: { __typename?: 'Login', access_token: string, refresh_token: string } };

export type TermsOfUsePageMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type TermsOfUsePageMutation = { __typename?: 'Mutation', Login: { __typename?: 'Login', access_token: string, refresh_token: string } };

export type CompaniesPageQueryVariables = Exact<{
  orderBy?: InputMaybe<CompanyOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<CompanyWhereInput>;
}>;


export type CompaniesPageQuery = { __typename?: 'Query', FindCompanies: Array<{ __typename?: 'Company', id: string, document_number: string, company_name: string, trade_name?: string | null, company_function: FunctionEnum, company_type: CompanyTypeEnum, created_at: string, updated_at: string, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null, companyStatus?: Array<{ __typename?: 'CompanyHasStatus', status: CompanyStatusEnum, updated_at: string }> | null }>, Count: Array<{ __typename?: 'Company', id: string }> };

export type CompanyDetailsPage_BeginCompanyAnalysisMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyDetailsPage_BeginCompanyAnalysisMutation = { __typename?: 'Mutation', ChangeCompanyStatus: { __typename?: 'CompanyHasStatus', id: string, status: CompanyStatusEnum, updated_at: string, manager?: { __typename?: 'User', id: string, email: string } | null } };

export type CompanyDetailsPageQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type CompanyDetailsPageQuery = { __typename?: 'Query', FindCompany: { __typename?: 'Company', id: string, document_number: string, trade_name?: string | null, company_name: string, company_function: FunctionEnum, company_type: CompanyTypeEnum, url_logo?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, has_fleet?: boolean | null, fleet_quantity?: number | null, companyStatus?: Array<{ __typename?: 'CompanyHasStatus', id: string, status: CompanyStatusEnum, updated_at: string, manager?: { __typename?: 'User', id: string, email: string } | null }> | null, users?: Array<{ __typename?: 'UserHasCompany', user: { __typename?: 'User', id: string, name: string, email: string, active: boolean, created_at: string, updated_at: string, deleted_at?: string | null } }> | null, address?: { __typename?: 'Address', id: string, zip_code_address?: string | null, street?: string | null, number?: string | null, district?: { __typename?: 'District', district_name: string } | null, state?: { __typename?: 'State', initials: string } | null, city: { __typename?: 'City', city_name: string, state_id: string } } | null, contacts?: Array<{ __typename?: 'Contact', id: string, email: string, phone: string }> | null, mother_company?: { __typename?: 'Company', id: string, document_number: string, trade_name?: string | null, company_name: string, company_function: FunctionEnum, company_type: CompanyTypeEnum, url_logo?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, companyStatus?: Array<{ __typename?: 'CompanyHasStatus', id: string, status: CompanyStatusEnum, updated_at: string }> | null } | null, children_companies?: Array<{ __typename?: 'Company', id: string, document_number: string, company_name: string, trade_name?: string | null, company_function: FunctionEnum, company_type: CompanyTypeEnum, created_at: string, updated_at: string, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null, companyStatus?: Array<{ __typename?: 'CompanyHasStatus', status: CompanyStatusEnum, updated_at: string }> | null }> | null, policies?: Array<{ __typename?: 'Policy', id: string, name: string, bucket_url: string, expires_in: string, created_at: string, updated_at: string }> | null, operationArea?: Array<{ __typename?: 'OperationArea', created_at: string, updated_at: string, state: { __typename?: 'State', initials: string, state_name?: string | null } }> | null } };

export type ApproveCompanyMutationVariables = Exact<{
  input: ApproveCompanyInput;
}>;


export type ApproveCompanyMutation = { __typename?: 'Mutation', ApproveCompany: { __typename?: 'CompanyHasStatus', id: string, company_id: string, status: CompanyStatusEnum } };

export type DisapproveCompanyModalMutationVariables = Exact<{
  input: ReproachCompanyInput;
}>;


export type DisapproveCompanyModalMutation = { __typename?: 'Mutation', ReproachCompany: { __typename?: 'Reproach', reference_company_id: string } };

export type LinkUserToCompanyForm_FindManyUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkUserToCompanyForm_FindManyUsersQuery = { __typename?: 'Query', FindManyUsers: Array<{ __typename?: 'FindUserGraphQLOutput', id: string, name: string, email: string }> };

export type LinkUserToCompanyForm_FindCompaniesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkUserToCompanyForm_FindCompaniesQuery = { __typename?: 'Query', FindCompanies: Array<{ __typename?: 'Company', id: string, document_number: string, company_function: FunctionEnum, company_name: string, trade_name?: string | null, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null }> };

export type LinkUserToCompanyMutationVariables = Exact<{
  input: LinkUserToCompanyInput;
}>;


export type LinkUserToCompanyMutation = { __typename?: 'Mutation', LinkUserToCompany: { __typename?: 'FindUserGraphQLOutput', id: string } };

export type UnlinkUserFromCompanyMutationVariables = Exact<{
  input: RemoveUserInternallyInput;
}>;


export type UnlinkUserFromCompanyMutation = { __typename?: 'Mutation', UnlinkUserCompany: { __typename?: 'FindUserGraphQLOutput', id: string } };

export type UserPermissionsTableFragment = { __typename?: 'UserHasPermission', enable: boolean, user_permission: { __typename?: 'UserPermission', id: string, action: { __typename?: 'Action', name: string }, module: { __typename?: 'Module', name: string } } };

export type UserDetailsPage_UpdateManyUserHasPermissionsMutationVariables = Exact<{
  input: UpdateManyUserHasPermissionsInput;
}>;


export type UserDetailsPage_UpdateManyUserHasPermissionsMutation = { __typename?: 'Mutation', UpdateManyUserHasPermissions: Array<{ __typename?: 'UserHasPermission', user_permission: { __typename?: 'UserPermission', id: string } }> };

export type UserDetailsPage_FindUserAndPermissionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserDetailsPage_FindUserAndPermissionsQuery = { __typename?: 'Query', FindUser: { __typename?: 'FindUserGraphQLOutput', id: string, name: string, email: string, active: boolean, created_at: string, updated_at: string, deleted_at?: string | null, companies?: Array<{ __typename?: 'UserHasCompanyGraphqQLOutput', company: { __typename?: 'CompanyGraphQLOutput', id: string, document_number: string, company_name: string, trade_name?: string | null, company_function: FunctionEnum, company_type: CompanyTypeEnum, created_at: string, updated_at: string, address?: { __typename?: 'AddressGraphQLOutput', city?: { __typename?: 'CityGraphQLOutput', city_name: string, state_id: string } | null } | null, companyStatus?: Array<{ __typename?: 'CompanyHasStatusGraphQLOutput', status: CompanyStatusEnum, updated_at: string }> | null } }> | null }, FindManyUserHasPermissions: Array<{ __typename?: 'UserHasPermission', enable: boolean, user_permission: { __typename?: 'UserPermission', id: string, action: { __typename?: 'Action', name: string }, module: { __typename?: 'Module', name: string } } }> };

export type UserDetailsPage_FindUserPermissionTemplateQueryVariables = Exact<{
  roleName: TruckerRolesEnum;
}>;


export type UserDetailsPage_FindUserPermissionTemplateQuery = { __typename?: 'Query', FindPermissionTemplate: Array<{ __typename?: 'PermissionTemplate', permission_id: string, available: boolean }> };

export type UsersPage_CreateUserInternallyMutationVariables = Exact<{
  input: CreateUserInternallyInput;
}>;


export type UsersPage_CreateUserInternallyMutation = { __typename?: 'Mutation', CreateUserInternally: { __typename?: 'FindUserGraphQLOutput', id: string } };

export type UsersPage_CreateTruckerUserMutationVariables = Exact<{
  input: CreateTruckerUserInput;
}>;


export type UsersPage_CreateTruckerUserMutation = { __typename?: 'Mutation', CreateTruckerUser: { __typename?: 'UserModel', id: string } };

export type UsersPageQueryVariables = Exact<{
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type UsersPageQuery = { __typename?: 'Query', FindManyUsers: Array<{ __typename?: 'FindUserGraphQLOutput', id: string, name: string, email: string, active: boolean, created_at: string, updated_at: string, deleted_at?: string | null, companies?: Array<{ __typename?: 'UserHasCompanyGraphqQLOutput', company: { __typename?: 'CompanyGraphQLOutput', id: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'AddressGraphQLOutput', city?: { __typename?: 'CityGraphQLOutput', city_name: string, state_id: string } | null } | null } }> | null }>, Count: Array<{ __typename?: 'FindUserGraphQLOutput', id: string }> };

export type UsersPage_FindCompaniesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersPage_FindCompaniesQuery = { __typename?: 'Query', FindCompanies: Array<{ __typename?: 'Company', id: string, document_number: string, company_function: FunctionEnum, company_name: string, trade_name?: string | null, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null }> };

export type QuotationGroupFormModal_CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type QuotationGroupFormModal_CreateGroupMutation = { __typename?: 'Mutation', CreateGroup: { __typename?: 'Group', id: string } };

export type QuotationGroupFormModal_UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type QuotationGroupFormModal_UpdateGroupMutation = { __typename?: 'Mutation', UpdateGroup: { __typename?: 'Group', id: string } };

export type QuotationGroupFormModal_FindCarrierCompaniesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type QuotationGroupFormModal_FindCarrierCompaniesQuery = { __typename?: 'Query', FindCompanies: Array<{ __typename?: 'Company', id: string, document_number: string, company_function: FunctionEnum, company_name: string, trade_name?: string | null, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null }> };

export type QuotationGroupFormModal_FindQuotationGroupQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type QuotationGroupFormModal_FindQuotationGroupQuery = { __typename?: 'Query', FindGroup: { __typename?: 'Group', id: string, name: string, created_at: string, updated_at: string, members?: Array<{ __typename?: 'CompanyInGroup', created_at: string, company: { __typename?: 'FreightCompany', document_number: string, company_function: FreightFunctionEnum, company_name: string, trade_name?: string | null, id: string, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null } }> | null } };

export type QuotationGroupMembersTableFragment = { __typename?: 'Company', id: string, document_number: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'Address', city: { __typename?: 'City', city_name: string, state_id: string } } | null };

export type FreightQuotationGroupMembersTableFragment = { __typename?: 'FreightCompany', id: string, document_number: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null };

export type QuotationGroupMembersTable_FindCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type QuotationGroupMembersTable_FindCompanyQuery = { __typename?: 'Query', FindCompany: { __typename?: 'Company', id: string, document_number: string, trade_name?: string | null, company_name: string, company_type: CompanyTypeEnum, company_function: FunctionEnum, address?: { __typename?: 'Address', id: string, zip_code_address?: string | null, street?: string | null, number?: string | null, district?: { __typename?: 'District', district_name: string } | null, state?: { __typename?: 'State', initials: string } | null, city: { __typename?: 'City', city_name: string } } | null, contacts?: Array<{ __typename?: 'Contact', phone: string, email: string }> | null, policies?: Array<{ __typename?: 'Policy', id: string, name: string, expires_in: string, bucket_url: string }> | null } };

export type QuotationGroupTableFragment = { __typename?: 'Group', id: string, name: string, created_at: string, updated_at: string, members?: Array<{ __typename?: 'CompanyInGroup', company: { __typename?: 'FreightCompany', id: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null } }> | null };

export type QuotationGroups_DeleteQuotationGroupMutationVariables = Exact<{
  input: DeleteGroupInput;
}>;


export type QuotationGroups_DeleteQuotationGroupMutation = { __typename?: 'Mutation', DeleteGroup: { __typename?: 'Group', id: string } };

export type QuotationGroups_ListQuotationGroupsQueryVariables = Exact<{
  orderBy?: InputMaybe<GroupOrderByWithRelationInput>;
  ownerId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  where?: InputMaybe<GroupWhereInput>;
}>;


export type QuotationGroups_ListQuotationGroupsQuery = { __typename?: 'Query', FindManyGroups: { __typename?: 'Groups', length: number, data: Array<{ __typename?: 'Group', id: string, name: string, created_at: string, updated_at: string, members?: Array<{ __typename?: 'CompanyInGroup', company: { __typename?: 'FreightCompany', id: string, company_name: string, trade_name?: string | null, address?: { __typename?: 'FreightAddress', city: { __typename?: 'FreightCity', city_name: string, state_id: string } } | null } }> | null }> } };

export const CompanyAddressDescriptionsFragmentDoc = gql`
    fragment CompanyAddressDescriptions on Address {
  id
  zip_code_address
  district {
    district_name
  }
  street
  number
  state {
    initials
  }
  city {
    city_name
  }
}
    `;
export const CompanyDataDescriptionsFragmentDoc = gql`
    fragment CompanyDataDescriptions on Company {
  id
  document_number
  trade_name
  company_name
  company_type
  company_function
}
    `;
export const CompanyNameFragmentDoc = gql`
    fragment CompanyName on Company {
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const FreightCompanyNameFragmentDoc = gql`
    fragment FreightCompanyName on FreightCompany {
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const CompanyGraphQlOutputNameFragmentDoc = gql`
    fragment CompanyGraphQLOutputName on CompanyGraphQLOutput {
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const CompanySelectFragmentDoc = gql`
    fragment CompanySelect on Company {
  id
  document_number
  company_function
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const FreightCompanySelectFragmentDoc = gql`
    fragment FreightCompanySelect on FreightCompany {
  id
  document_number
  company_function
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const LastCompanyStatusTagFragmentDoc = gql`
    fragment LastCompanyStatusTag on CompanyHasStatus {
  status
  updated_at
}
    `;
export const FormattedRouteFragmentDoc = gql`
    fragment FormattedRoute on Route {
  id
  name
  places {
    id
    city_name
    state_id
    move_type
  }
}
    `;
export const CarrierHiredFreightFragmentDoc = gql`
    fragment CarrierHiredFreight on Quotation {
  id
  value_per_unit
  value_unit_type
  freight {
    id
    numeric_id
    status {
      name
    }
    route {
      id
      name
      places {
        id
        city_name
        state_id
        move_type
      }
    }
    landing_date
    shipment_date
    product_type {
      id
      name
    }
    product {
      id
      name
    }
    product_variety {
      id
      name
    }
    packing {
      id
      name
      measuring_unity
      capacity
    }
    unit_type
  }
  status {
    name
  }
  requested_volume
}
    `;
export const CarrierQuotedFreightFragmentDoc = gql`
    fragment CarrierQuotedFreight on Quotation {
  id
  value_per_unit
  value_unit_type
  freight {
    id
    numeric_id
    status {
      id
      name
    }
    route {
      id
      name
      places {
        id
        city_name
        state_id
        move_type
      }
    }
    landing_date
    shipment_date
    product_type {
      id
      name
    }
    product {
      id
      name
    }
    product_variety {
      id
      name
    }
    packing {
      id
      name
      measuring_unity
      capacity
    }
    total_volume
    unit_type
    quote_limit
  }
  total_volume
}
    `;
export const CarrierQuotingFreightFragmentDoc = gql`
    fragment CarrierQuotingFreight on Freight {
  id
  numeric_id
  route {
    id
    name
    places {
      id
      city_name
      state_id
      move_type
    }
  }
  landing_date
  shipment_date
  product_type {
    id
    name
  }
  product {
    id
    name
  }
  product_variety {
    id
    name
  }
  packing {
    id
    name
    measuring_unity
    capacity
  }
  total_volume
  unit_type
  quote_limit
}
    `;
export const FreightDetails_CompanyDetailsFragmentDoc = gql`
    fragment FreightDetails_CompanyDetails on Company {
  id
  document_number
  trade_name
  company_name
  company_type
  company_function
  address {
    id
    zip_code_address
    district {
      district_name
    }
    street
    number
    state {
      initials
    }
    city {
      city_name
    }
  }
  contacts {
    phone
    email
  }
  policies {
    id
    name
    expires_in
    bucket_url
  }
}
    `;
export const FreightLoadDescriptionsFragmentDoc = gql`
    fragment FreightLoadDescriptions on Freight {
  id
  product_type {
    id
    name
  }
  product {
    id
    name
  }
  product_variety {
    id
    name
  }
  packing {
    id
    name
  }
  total_volume
  unit_type
  suggested_value
  note_value
  observation
}
    `;
export const FreightPlaceDescriptionsFragmentDoc = gql`
    fragment FreightPlaceDescriptions on Freight {
  landing_date
  shipment_date
  quote_limit
  route {
    id
    places {
      id
      city {
        city_name
        state_id
      }
      move_type
      name
    }
  }
}
    `;
export const FreightVolumeBarFragmentDoc = gql`
    fragment FreightVolumeBar on Freight {
  allocated_volume
  loaded_volume
  total_volume
  unallocated_volume
  unit_type
}
    `;
export const ConfirmFreightDatesFragmentDoc = gql`
    fragment ConfirmFreightDates on Freight {
  shipment_date
  landing_date
}
    `;
export const ConfirmFreightLoadFragmentDoc = gql`
    fragment ConfirmFreightLoad on Freight {
  note_value
  observation
  suggested_value
  total_volume
  unit_type
  packing {
    name
  }
  product {
    name
  }
  product_variety {
    id
    name
  }
  product_type {
    name
  }
}
    `;
export const PlaceTableItemFragmentDoc = gql`
    fragment PlaceTableItem on Place {
  id
  name
  state_id
  city_id
  city_name
  cadence
  has_dirt_road
  dirt_road_distance
  has_balance
  note
}
    `;
export const PlaceForViewPlaceFragmentDoc = gql`
    fragment PlaceForViewPlace on PlaceRoute {
  id
  name
  state_id
  city_name
  cadence
  dirt_road_distance
  has_dirt_road
  balance_capacity
  note
  opening_hour
  closing_hour
}
    `;
export const PlaceRouteForViewPlaceFragmentDoc = gql`
    fragment PlaceRouteForViewPlace on Place {
  id
  name
  state_id
  city_name
  cadence
  dirt_road_distance
  has_dirt_road
  balance_capacity
  note
  opening_hour
  closing_hour
}
    `;
export const QuotationShortDescriptionFragmentDoc = gql`
    fragment QuotationShortDescription on Quotation {
  value_per_unit
  value_unit_type
  total_volume
  requested_volume
  freight {
    unit_type
  }
}
    `;
export const HiredFreightFragmentDoc = gql`
    fragment HiredFreight on Freight {
  id
  numeric_id
  route {
    id
    name
    places {
      id
      city_name
      state_id
      move_type
    }
  }
  landing_date
  shipment_date
  product_type {
    id
    name
  }
  product {
    id
    name
  }
  product_variety {
    id
    name
  }
  packing {
    id
    name
    measuring_unity
    capacity
  }
  total_volume
  unit_type
  status {
    id
    name
  }
  quotations {
    id
    status {
      id
      name
    }
    value_per_unit
    value_unit_type
  }
}
    `;
export const QuotedFreightFragmentDoc = gql`
    fragment QuotedFreight on Freight {
  id
  numeric_id
  status {
    id
    name
  }
  route {
    id
    name
    places {
      id
      city_name
      state_id
      move_type
    }
  }
  landing_date
  shipment_date
  product_type {
    id
    name
  }
  product {
    id
    name
  }
  product_variety {
    id
    name
  }
  packing {
    id
    name
    measuring_unity
    capacity
  }
  total_volume
  unit_type
  expires_in
  quote_limit
  quotations {
    id
  }
}
    `;
export const QuotingFreightFragmentDoc = gql`
    fragment QuotingFreight on Freight {
  id
  numeric_id
  status {
    id
    name
  }
  route {
    id
    name
    places {
      id
      city_name
      state_id
      move_type
    }
  }
  landing_date
  shipment_date
  product_type {
    id
    name
  }
  product {
    id
    name
  }
  product_variety {
    id
    name
  }
  packing {
    id
    name
    measuring_unity
    capacity
  }
  total_volume
  unit_type
  quote_limit
  expires_in
  quotations {
    id
  }
}
    `;
export const AttachmentsTableFragmentDoc = gql`
    fragment AttachmentsTable on FreightAttachmentGraphQLResponse {
  created_at
  short_description
  file_id
  file {
    filename
    mimetype
    url
  }
}
    `;
export const ProductWithVarietyFragmentDoc = gql`
    fragment ProductWithVariety on Freight {
  product {
    name
  }
  product_variety {
    id
    name
  }
}
    `;
export const ConfirmQuotationFragmentDoc = gql`
    fragment ConfirmQuotation on Quotation {
  id
  expires_in
  requested_volume
  unallocated_volume
  freight {
    unit_type
    route {
      places {
        has_balance
        balance_capacity
        move_type
      }
    }
  }
  confirmations {
    id
    assigned_volume
    driver {
      id
      name
      cnh
    }
    vehicle_type {
      id
      name
    }
    vehicle_plate
  }
}
    `;
export const ConfirmQuotationFormFragmentDoc = gql`
    fragment ConfirmQuotationForm on Quotation {
  requested_volume
  unallocated_volume
  freight {
    unit_type
    route {
      places {
        has_balance
        balance_capacity
        move_type
      }
    }
  }
}
    `;
export const QuotationConfirmationSelectFragmentDoc = gql`
    fragment QuotationConfirmationSelect on QuotationConfirmation {
  id
  driver {
    name
  }
  vehicle_plate
}
    `;
export const QuotationConfirmationTableFragmentDoc = gql`
    fragment QuotationConfirmationTable on QuotationConfirmation {
  id
  assigned_volume
  driver {
    id
    name
    cnh
  }
  vehicle_type {
    id
    name
  }
  vehicle_plate
  ctes {
    loaded_volume
    unit_type
  }
}
    `;
export const CteTableFragmentDoc = gql`
    fragment CteTable on Cte {
  id
  filename
  created_at
  url
  loaded_volume
  unit_type
  confirmation {
    id
    vehicle_plate
  }
  driver {
    id
    name
  }
}
    `;
export const HireQuotationTableFragmentDoc = gql`
    fragment HireQuotationTable on Quotation {
  id
  has_vehicle
  total_volume
  value_per_unit
  value_unit_type
  loaded_volume
  owner {
    id
    reference_external_company_id
    company_name
    trade_name
    address {
      city {
        city_name
        state_id
      }
    }
  }
  status {
    id
    name
  }
  creator {
    email
  }
  freight {
    unit_type
  }
}
    `;
export const QuotationDescriptionsFragmentDoc = gql`
    fragment QuotationDescriptions on Quotation {
  owner {
    company_name
    trade_name
    address {
      city {
        city_name
        state_id
      }
    }
  }
  has_vehicle
  loaded_volume
  requested_volume
  unallocated_volume
  value_per_unit
  value_unit_type
  freight {
    unit_type
  }
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on Company {
  id
  company_name
  company_type
  company_function
  companyStatus {
    id
    status
    updated_at
  }
}
    `;
export const UserPermissionsTableFragmentDoc = gql`
    fragment UserPermissionsTable on UserHasPermission {
  enable
  user_permission {
    id
    action {
      name
    }
    module {
      name
    }
  }
}
    `;
export const QuotationGroupMembersTableFragmentDoc = gql`
    fragment QuotationGroupMembersTable on Company {
  id
  document_number
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const FreightQuotationGroupMembersTableFragmentDoc = gql`
    fragment FreightQuotationGroupMembersTable on FreightCompany {
  id
  document_number
  company_name
  trade_name
  address {
    city {
      city_name
      state_id
    }
  }
}
    `;
export const QuotationGroupTableFragmentDoc = gql`
    fragment QuotationGroupTable on Group {
  id
  name
  created_at
  updated_at
  members {
    company {
      id
      company_name
      trade_name
      address {
        city {
          city_name
          state_id
        }
      }
    }
  }
}
    `;
export const CarrierListFreightsDocument = gql`
    query CarrierListFreights($carrierId: String!, $quotingInput: FreightWhereInput, $pagination: Pagination) {
  FindManyCarrierFreightsQuoting: FindQuotingFreights(
    carrier_id: $carrierId
    where: $quotingInput
    pagination: $pagination
    order_by: {created_at: desc}
  ) {
    data {
      id
      numeric_id
      status {
        id
        name
      }
      route {
        id
        name
        places {
          id
          city_name
          state_id
          move_type
        }
      }
      landing_date
      shipment_date
      product_type {
        id
        name
      }
      product_variety {
        id
        name
      }
      product {
        id
        name
      }
      packing {
        id
        name
        measuring_unity
        capacity
      }
      total_volume
      unit_type
      quote_limit
      quotations {
        id
      }
    }
    length
  }
}
    `;

export function useCarrierListFreightsQuery(options: Omit<Urql.UseQueryArgs<CarrierListFreightsQueryVariables>, 'query'>) {
  return Urql.useQuery<CarrierListFreightsQuery, CarrierListFreightsQueryVariables>({ query: CarrierListFreightsDocument, ...options });
};
export const ListFreightsByQuotationDocument = gql`
    query ListFreightsByQuotation($quotedInput: QuotationWhereInput, $hiredInput: QuotationWhereInput, $pagination: Pagination) {
  FindManyQuotationQuoted: FindManyQuotation(
    where: $quotedInput
    pagination: $pagination
    order_by: {created_at: desc}
  ) {
    id
    value_per_unit
    value_unit_type
    freight {
      id
      numeric_id
      status {
        id
        name
      }
      route {
        id
        name
        places {
          id
          city_name
          state_id
          move_type
        }
      }
      landing_date
      shipment_date
      product_type {
        id
        name
      }
      product {
        id
        name
      }
      product_variety {
        id
        name
      }
      packing {
        id
        name
        measuring_unity
        capacity
      }
      total_volume
      unit_type
      quote_limit
    }
    total_volume
  }
  FindManyQuotationHired: FindManyQuotation(
    where: $hiredInput
    pagination: $pagination
    order_by: {created_at: desc}
  ) {
    id
    value_per_unit
    value_unit_type
    freight {
      id
      numeric_id
      status {
        name
      }
      route {
        id
        name
        places {
          id
          city_name
          state_id
          move_type
        }
      }
      landing_date
      shipment_date
      product_type {
        id
        name
      }
      product {
        id
        name
      }
      product_variety {
        id
        name
      }
      packing {
        id
        name
        measuring_unity
        capacity
      }
      total_volume
      unit_type
    }
    status {
      name
    }
    requested_volume
  }
}
    `;

export function useListFreightsByQuotationQuery(options?: Omit<Urql.UseQueryArgs<ListFreightsByQuotationQueryVariables>, 'query'>) {
  return Urql.useQuery<ListFreightsByQuotationQuery, ListFreightsByQuotationQueryVariables>({ query: ListFreightsByQuotationDocument, ...options });
};
export const AttachmentsTableModal_DetachFileDocument = gql`
    mutation AttachmentsTableModal_DetachFile($input: DetachOneFileFromFreightGraphQLRequest!) {
  DetachOneFileFromFreight(input: $input) {
    attachment_id
  }
}
    `;

export function useAttachmentsTableModal_DetachFileMutation() {
  return Urql.useMutation<AttachmentsTableModal_DetachFileMutation, AttachmentsTableModal_DetachFileMutationVariables>(AttachmentsTableModal_DetachFileDocument);
};
export const AttachmentsTableModal_FindAllAttachmentsDocument = gql`
    query AttachmentsTableModal_FindAllAttachments($freightId: String!) {
  ListAllFreightAttachments(freight_id: $freightId) {
    length
    data {
      created_at
      short_description
      file_id
      file {
        filename
        mimetype
        url
      }
    }
  }
}
    `;

export function useAttachmentsTableModal_FindAllAttachmentsQuery(options: Omit<Urql.UseQueryArgs<AttachmentsTableModal_FindAllAttachmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<AttachmentsTableModal_FindAllAttachmentsQuery, AttachmentsTableModal_FindAllAttachmentsQueryVariables>({ query: AttachmentsTableModal_FindAllAttachmentsDocument, ...options });
};
export const FreightDetailsDocument = gql`
    query FreightDetails($freightId: String!) {
  FindFreight(freight_id: $freightId) {
    child {
      id
    }
    id
    product_type {
      id
      name
    }
    product {
      id
      name
    }
    product_variety {
      id
      name
    }
    packing {
      id
      name
    }
    total_volume
    suggested_value
    note_value
    observation
    landing_date
    shipment_date
    quote_limit
    route {
      id
      places {
        id
        city {
          city_name
          state_id
        }
        move_type
        name
      }
    }
    quotations {
      id
      has_vehicle
      total_volume
      value_per_unit
      value_unit_type
      loaded_volume
      owner {
        id
        reference_external_company_id
        company_name
        trade_name
        address {
          city {
            city_name
            state_id
          }
        }
      }
      status {
        id
        name
      }
      creator {
        email
      }
      freight {
        unit_type
      }
    }
    allocated_volume
    loaded_volume
    total_volume
    unallocated_volume
    unit_type
    status {
      id
      name
    }
    related_groups {
      group {
        id
        name
        created_at
        updated_at
        members {
          company {
            id
            company_name
            trade_name
            address {
              city {
                city_name
                state_id
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useFreightDetailsQuery(options: Omit<Urql.UseQueryArgs<FreightDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<FreightDetailsQuery, FreightDetailsQueryVariables>({ query: FreightDetailsDocument, ...options });
};
export const FreightDetails_CompanyDetailsDocument = gql`
    query FreightDetails_CompanyDetails($companyId: String!) {
  FindCompany(company_id: $companyId) {
    id
    document_number
    trade_name
    company_name
    company_type
    company_function
    address {
      id
      zip_code_address
      district {
        district_name
      }
      street
      number
      state {
        initials
      }
      city {
        city_name
      }
    }
    contacts {
      phone
      email
    }
    policies {
      id
      name
      expires_in
      bucket_url
    }
  }
}
    `;

export function useFreightDetails_CompanyDetailsQuery(options: Omit<Urql.UseQueryArgs<FreightDetails_CompanyDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<FreightDetails_CompanyDetailsQuery, FreightDetails_CompanyDetailsQueryVariables>({ query: FreightDetails_CompanyDetailsDocument, ...options });
};
export const HireQuotationsDocument = gql`
    mutation HireQuotations($input: HireQuotationsInput!) {
  HireQuotations(input: $input) {
    id
  }
}
    `;

export function useHireQuotationsMutation() {
  return Urql.useMutation<HireQuotationsMutation, HireQuotationsMutationVariables>(HireQuotationsDocument);
};
export const CreateFreightDocument = gql`
    mutation CreateFreight($input: CreateFreightInput!) {
  CreateFreight(input: $input) {
    id
  }
}
    `;

export function useCreateFreightMutation() {
  return Urql.useMutation<CreateFreightMutation, CreateFreightMutationVariables>(CreateFreightDocument);
};
export const CreateMissingFreightDocument = gql`
    mutation CreateMissingFreight($input: CreateMissingFreightInput!) {
  CreateMissingFreight(input: $input) {
    id
  }
}
    `;

export function useCreateMissingFreightMutation() {
  return Urql.useMutation<CreateMissingFreightMutation, CreateMissingFreightMutationVariables>(CreateMissingFreightDocument);
};
export const CreatePlaceModalDocument = gql`
    mutation CreatePlaceModal($input: CreatePlaceInput!) {
  CreatePlace(input: $input) {
    id
    name
    state_id
    city_id
    city_name
    cadence
    has_dirt_road
    dirt_road_distance
    has_balance
    balance_capacity
    note
  }
}
    `;

export function useCreatePlaceModalMutation() {
  return Urql.useMutation<CreatePlaceModalMutation, CreatePlaceModalMutationVariables>(CreatePlaceModalDocument);
};
export const FindPlacesForPlaceTableDocument = gql`
    query FindPlacesForPlaceTable($where: FindPlacesWhereInput!) {
  FindPlaces(where: $where) {
    id
    name
    state_id
    city_id
    city_name
    cadence
    has_dirt_road
    dirt_road_distance
    has_balance
    note
  }
}
    `;

export function useFindPlacesForPlaceTableQuery(options: Omit<Urql.UseQueryArgs<FindPlacesForPlaceTableQueryVariables>, 'query'>) {
  return Urql.useQuery<FindPlacesForPlaceTableQuery, FindPlacesForPlaceTableQueryVariables>({ query: FindPlacesForPlaceTableDocument, ...options });
};
export const PlaceDetailsModalDocument = gql`
    query PlaceDetailsModal($input: FindPlaceInput!) {
  FindPlace(input: $input) {
    id
    name
    state_id
    city_name
    opening_hour
    closing_hour
    cadence
    balance_capacity
    dirt_road_distance
    note
    latitude
    longitude
  }
}
    `;

export function usePlaceDetailsModalQuery(options: Omit<Urql.UseQueryArgs<PlaceDetailsModalQueryVariables>, 'query'>) {
  return Urql.useQuery<PlaceDetailsModalQuery, PlaceDetailsModalQueryVariables>({ query: PlaceDetailsModalDocument, ...options });
};
export const UpdatePlaceDocument = gql`
    mutation UpdatePlace($input: UpdatePlaceInput!) {
  UpdatePlace(input: $input) {
    id
    name
    state_id
    city_id
    city_name
    cadence
    has_dirt_road
    dirt_road_distance
    has_balance
    note
  }
}
    `;

export function useUpdatePlaceMutation() {
  return Urql.useMutation<UpdatePlaceMutation, UpdatePlaceMutationVariables>(UpdatePlaceDocument);
};
export const RefusalReasonSelectDocument = gql`
    query RefusalReasonSelect($where: RefusalReasonWhereInput, $pagination: Pagination) {
  FindManyRefusalReasons(where: $where, pagination: $pagination) {
    value: id
    label: name
  }
}
    `;

export function useRefusalReasonSelectQuery(options?: Omit<Urql.UseQueryArgs<RefusalReasonSelectQueryVariables>, 'query'>) {
  return Urql.useQuery<RefusalReasonSelectQuery, RefusalReasonSelectQueryVariables>({ query: RefusalReasonSelectDocument, ...options });
};
export const CreateRouteDocument = gql`
    mutation CreateRoute($input: CreateRouteInput!) {
  CreateRoute(input: $input) {
    id
    name
    total_distance
    estimate_time
    places {
      id
      name
      city_name
      city_id
      state_id
      move_type
    }
  }
}
    `;

export function useCreateRouteMutation() {
  return Urql.useMutation<CreateRouteMutation, CreateRouteMutationVariables>(CreateRouteDocument);
};
export const ListRoutesDocument = gql`
    query ListRoutes($where: CustomRoutesWhereInput!) {
  FindRoutes(where: $where) {
    id
    name
    total_distance
    estimate_time
    places {
      id
      name
      city_name
      city_id
      state_id
      move_type
    }
  }
}
    `;

export function useListRoutesQuery(options: Omit<Urql.UseQueryArgs<ListRoutesQueryVariables>, 'query'>) {
  return Urql.useQuery<ListRoutesQuery, ListRoutesQueryVariables>({ query: ListRoutesDocument, ...options });
};
export const FindRouteForViewRouteDocument = gql`
    query FindRouteForViewRoute($input: FindRouteInput!) {
  FindRoute(input: $input) {
    id
    name
    places {
      id
      name
      state_id
      city_name
      cadence
      dirt_road_distance
      has_dirt_road
      balance_capacity
      note
      opening_hour
      closing_hour
      move_type
      latitude
      longitude
    }
  }
}
    `;

export function useFindRouteForViewRouteQuery(options: Omit<Urql.UseQueryArgs<FindRouteForViewRouteQueryVariables>, 'query'>) {
  return Urql.useQuery<FindRouteForViewRouteQuery, FindRouteForViewRouteQueryVariables>({ query: FindRouteForViewRouteDocument, ...options });
};
export const CancelFreightDocument = gql`
    mutation CancelFreight($input: CancelFreightInput!) {
  CancelFreight(input: $input) {
    id
  }
}
    `;

export function useCancelFreightMutation() {
  return Urql.useMutation<CancelFreightMutation, CancelFreightMutationVariables>(CancelFreightDocument);
};
export const ListFreightsDocument = gql`
    query ListFreights($quotingInput: FreightWhereInput, $quotedInput: FreightWhereInput, $hiredInput: FreightWhereInput, $pagination: Pagination) {
  FindManyFreightsQuoting: FindManyFreights(
    where: $quotingInput
    pagination: $pagination
    order_by: {created_at: desc}
  ) {
    id
    numeric_id
    status {
      id
      name
    }
    route {
      id
      name
      places {
        id
        city_name
        state_id
        move_type
      }
    }
    landing_date
    shipment_date
    product_type {
      id
      name
    }
    product {
      id
      name
    }
    product_variety {
      id
      name
    }
    packing {
      id
      name
      measuring_unity
      capacity
    }
    total_volume
    unit_type
    quote_limit
    expires_in
    quotations {
      id
    }
  }
  FindManyFreightsQuoted: FindManyFreights(
    where: $quotedInput
    pagination: $pagination
    order_by: {created_at: desc}
  ) {
    id
    numeric_id
    status {
      id
      name
    }
    route {
      id
      name
      places {
        id
        city_name
        state_id
        move_type
      }
    }
    landing_date
    shipment_date
    product_type {
      id
      name
    }
    product {
      id
      name
    }
    product_variety {
      id
      name
    }
    packing {
      id
      name
      measuring_unity
      capacity
    }
    total_volume
    unit_type
    expires_in
    quote_limit
    quotations {
      id
    }
  }
  FindManyFreightsHired: FindManyFreights(
    where: $hiredInput
    pagination: $pagination
    order_by: {created_at: desc}
  ) {
    id
    numeric_id
    route {
      id
      name
      places {
        id
        city_name
        state_id
        move_type
      }
    }
    landing_date
    shipment_date
    product_type {
      id
      name
    }
    product {
      id
      name
    }
    product_variety {
      id
      name
    }
    packing {
      id
      name
      measuring_unity
      capacity
    }
    total_volume
    unit_type
    status {
      id
      name
    }
    quotations {
      id
      status {
        id
        name
      }
      value_per_unit
      value_unit_type
    }
  }
}
    `;

export function useListFreightsQuery(options?: Omit<Urql.UseQueryArgs<ListFreightsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListFreightsQuery, ListFreightsQueryVariables>({ query: ListFreightsDocument, ...options });
};
export const AttachmentForm_AttachFileDocument = gql`
    mutation AttachmentForm_AttachFile($file: Upload!, $input: AttachFileOnFreightGraphQLRequest!) {
  AttachFileOnFreight(file: $file, input: $input) {
    created_at
    short_description
    file_id
    file {
      filename
      mimetype
      url
    }
  }
}
    `;

export function useAttachmentForm_AttachFileMutation() {
  return Urql.useMutation<AttachmentForm_AttachFileMutation, AttachmentForm_AttachFileMutationVariables>(AttachmentForm_AttachFileDocument);
};
export const FindPackagesDocument = gql`
    query FindPackages($where: PackingWhereInput, $pagination: Pagination, $order_by: PackingOrderByWithRelationInput) {
  FindManyPackings(where: $where, pagination: $pagination, order_by: $order_by) {
    length
    data {
      id
      name
      measuring_unity
    }
  }
}
    `;

export function useFindPackagesQuery(options?: Omit<Urql.UseQueryArgs<FindPackagesQueryVariables>, 'query'>) {
  return Urql.useQuery<FindPackagesQuery, FindPackagesQueryVariables>({ query: FindPackagesDocument, ...options });
};
export const CreateManyProductsDocument = gql`
    mutation CreateManyProducts($input: CreateManyProductsInput!) {
  CreateManyProducts(input: $input) {
    length
    data {
      id
      name
      product_type {
        id
        name
      }
    }
  }
}
    `;

export function useCreateManyProductsMutation() {
  return Urql.useMutation<CreateManyProductsMutation, CreateManyProductsMutationVariables>(CreateManyProductsDocument);
};
export const DeleteProductsDocument = gql`
    mutation DeleteProducts($input: DeleteManyProductsInput!) {
  DeleteManyProducts(input: $input) {
    length
    data {
      id
    }
  }
}
    `;

export function useDeleteProductsMutation() {
  return Urql.useMutation<DeleteProductsMutation, DeleteProductsMutationVariables>(DeleteProductsDocument);
};
export const FindProductsDocument = gql`
    query FindProducts($where: ProductWhereInput, $pagination: Pagination, $order_by: ProductOrderByWithRelationInput) {
  FindManyProducts(where: $where, pagination: $pagination, order_by: $order_by) {
    length
    data {
      id
      name
      product_type {
        id
        name
      }
    }
  }
}
    `;

export function useFindProductsQuery(options?: Omit<Urql.UseQueryArgs<FindProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<FindProductsQuery, FindProductsQueryVariables>({ query: FindProductsDocument, ...options });
};
export const UpdateProductDocument = gql`
    mutation UpdateProduct($input: UpdateManyProductsInput!) {
  UpdateManyProducts(input: $input) {
    length
    data {
      id
      name
      product_type {
        id
        name
      }
    }
  }
}
    `;

export function useUpdateProductMutation() {
  return Urql.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument);
};
export const CreateProductTypesDocument = gql`
    mutation CreateProductTypes($input: CreateManyProductTypesInput!) {
  CreateManyProductTypes(input: $input) {
    id
    name
  }
}
    `;

export function useCreateProductTypesMutation() {
  return Urql.useMutation<CreateProductTypesMutation, CreateProductTypesMutationVariables>(CreateProductTypesDocument);
};
export const DeleteProductTypesDocument = gql`
    mutation DeleteProductTypes($input: DeleteManyProductTypesInput!) {
  DeleteManyProductTypes(input: $input) {
    id
  }
}
    `;

export function useDeleteProductTypesMutation() {
  return Urql.useMutation<DeleteProductTypesMutation, DeleteProductTypesMutationVariables>(DeleteProductTypesDocument);
};
export const FindProductTypesDocument = gql`
    query FindProductTypes($where: ProductTypeWhereInput, $pagination: Pagination, $order_by: ProductTypeOrderByWithRelationInput, $detailed: Boolean! = false) {
  FindManyProductTypes(
    where: $where
    pagination: $pagination
    order_by: $order_by
  ) {
    id
    name
    product @include(if: $detailed) {
      id
      name
    }
    product_type_has_packing @include(if: $detailed) {
      packing {
        id
        name
        measuring_unity
        capacity
      }
    }
  }
}
    `;

export function useFindProductTypesQuery(options?: Omit<Urql.UseQueryArgs<FindProductTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<FindProductTypesQuery, FindProductTypesQueryVariables>({ query: FindProductTypesDocument, ...options });
};
export const ProductVarietyDocument = gql`
    query ProductVariety($orderBy: VarietyOrderByWithRelationInput, $ownerId: ID, $pagination: Pagination, $productId: ID!, $where: VarietyWhereInput) {
  FindManyVarieties(
    order_by: $orderBy
    owner_id: $ownerId
    pagination: $pagination
    product_id: $productId
    where: $where
  ) {
    length
    data {
      id
      name
    }
  }
}
    `;

export function useProductVarietyQuery(options: Omit<Urql.UseQueryArgs<ProductVarietyQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductVarietyQuery, ProductVarietyQueryVariables>({ query: ProductVarietyDocument, ...options });
};
export const AbandonOrCancelQuotationModalDocument = gql`
    query AbandonOrCancelQuotationModal($quotation_id: String!) {
  FindQuotation(quotation_id: $quotation_id) {
    id
    owner {
      company_name
      trade_name
      address {
        city {
          city_name
          state_id
        }
      }
    }
    has_vehicle
    loaded_volume
    requested_volume
    unallocated_volume
    value_per_unit
    value_unit_type
    freight {
      unit_type
    }
  }
}
    `;

export function useAbandonOrCancelQuotationModalQuery(options: Omit<Urql.UseQueryArgs<AbandonOrCancelQuotationModalQueryVariables>, 'query'>) {
  return Urql.useQuery<AbandonOrCancelQuotationModalQuery, AbandonOrCancelQuotationModalQueryVariables>({ query: AbandonOrCancelQuotationModalDocument, ...options });
};
export const AbandonQuotationDocument = gql`
    mutation AbandonQuotation($input: AbandonQuotationInput!) {
  AbandonQuotation(input: $input) {
    id
  }
}
    `;

export function useAbandonQuotationMutation() {
  return Urql.useMutation<AbandonQuotationMutation, AbandonQuotationMutationVariables>(AbandonQuotationDocument);
};
export const CancelQuotationDocument = gql`
    mutation CancelQuotation($input: CancelQuotationInput!) {
  CancelQuotation(input: $input) {
    id
    owner {
      company_name
      trade_name
      address {
        city {
          city_name
          state_id
        }
      }
    }
    has_vehicle
    loaded_volume
    requested_volume
    unallocated_volume
    value_per_unit
    value_unit_type
    freight {
      unit_type
    }
    status {
      id
      name
    }
  }
}
    `;

export function useCancelQuotationMutation() {
  return Urql.useMutation<CancelQuotationMutation, CancelQuotationMutationVariables>(CancelQuotationDocument);
};
export const CancellationReasonsSelectDocument = gql`
    query CancellationReasonsSelect($where: CustomCancellationReasonsWhereInput, $pagination: Pagination) {
  FindManyCancellationReasons(where: $where, pagination: $pagination) {
    value: id
    label: name
  }
}
    `;

export function useCancellationReasonsSelectQuery(options?: Omit<Urql.UseQueryArgs<CancellationReasonsSelectQueryVariables>, 'query'>) {
  return Urql.useQuery<CancellationReasonsSelectQuery, CancellationReasonsSelectQueryVariables>({ query: CancellationReasonsSelectDocument, ...options });
};
export const FindDriverDocument = gql`
    query FindDriver($cnh: String!, $carrier_id: String!) {
  FindDriver(cnh: $cnh, carrier_id: $carrier_id) {
    id
    name
  }
}
    `;

export function useFindDriverQuery(options: Omit<Urql.UseQueryArgs<FindDriverQueryVariables>, 'query'>) {
  return Urql.useQuery<FindDriverQuery, FindDriverQueryVariables>({ query: FindDriverDocument, ...options });
};
export const CreateQuotationDocument = gql`
    mutation CreateQuotation($input: CreateQuotationInput!) {
  CreateQuotation(input: $input) {
    id
  }
}
    `;

export function useCreateQuotationMutation() {
  return Urql.useMutation<CreateQuotationMutation, CreateQuotationMutationVariables>(CreateQuotationDocument);
};
export const FindFreightForCreateQuotationDocument = gql`
    query FindFreightForCreateQuotation($freightId: String!) {
  FindFreight(freight_id: $freightId) {
    id
    landing_date
    observation
    quote_limit
    route_id
    shipment_date
    suggested_value
    note_value
    total_volume
    unit_type
    packing_id: packing {
      value: id
      label: name
    }
    product_id: product {
      value: id
      label: name
    }
    product_variety_id: product_variety {
      value: id
      label: name
    }
    product_type_id: product_type {
      value: id
      label: name
    }
    quotations {
      value_per_unit
      value
    }
    route {
      id
      name
      places {
        id
        name
        state_id
        city_name
        cadence
        dirt_road_distance
        has_dirt_road
        balance_capacity
        note
        opening_hour
        closing_hour
        move_type
        latitude
        longitude
      }
    }
  }
}
    `;

export function useFindFreightForCreateQuotationQuery(options: Omit<Urql.UseQueryArgs<FindFreightForCreateQuotationQueryVariables>, 'query'>) {
  return Urql.useQuery<FindFreightForCreateQuotationQuery, FindFreightForCreateQuotationQueryVariables>({ query: FindFreightForCreateQuotationDocument, ...options });
};
export const UnloadDocument = gql`
    mutation Unload($input: UnloadInput!) {
  Unload(input: $input) {
    id
    ctes {
      id
      filename
      url
      created_at
    }
  }
}
    `;

export function useUnloadMutation() {
  return Urql.useMutation<UnloadMutation, UnloadMutationVariables>(UnloadDocument);
};
export const FinishQuotationModalDocument = gql`
    mutation FinishQuotationModal($input: FinishQuotationInput!) {
  FinishQuotation(input: $input) {
    id
  }
}
    `;

export function useFinishQuotationModalMutation() {
  return Urql.useMutation<FinishQuotationModalMutation, FinishQuotationModalMutationVariables>(FinishQuotationModalDocument);
};
export const CreateQuotationConfirmationsDocument = gql`
    mutation CreateQuotationConfirmations($input: CreateQuotationConfirmationsInput!) {
  CreateQuotationConfirmations(input: $input) {
    id
    assigned_volume
    driver {
      id
      name
      cnh
    }
    vehicle_type {
      id
      name
    }
    vehicle_plate
  }
}
    `;

export function useCreateQuotationConfirmationsMutation() {
  return Urql.useMutation<CreateQuotationConfirmationsMutation, CreateQuotationConfirmationsMutationVariables>(CreateQuotationConfirmationsDocument);
};
export const DeleteQuotationConfirmationsDocument = gql`
    mutation DeleteQuotationConfirmations($input: DeleteQuotationConfirmationsInput!) {
  DeleteQuotationConfirmations(input: $input) {
    id
  }
}
    `;

export function useDeleteQuotationConfirmationsMutation() {
  return Urql.useMutation<DeleteQuotationConfirmationsMutation, DeleteQuotationConfirmationsMutationVariables>(DeleteQuotationConfirmationsDocument);
};
export const UpdateQuotationConfirmationsDocument = gql`
    mutation UpdateQuotationConfirmations($input: UpdateQuotationConfirmationsInput!) {
  UpdateQuotationConfirmations(input: $input) {
    id
    assigned_volume
    driver {
      id
      name
      cnh
    }
    vehicle_type {
      id
      name
    }
    vehicle_plate
  }
}
    `;

export function useUpdateQuotationConfirmationsMutation() {
  return Urql.useMutation<UpdateQuotationConfirmationsMutation, UpdateQuotationConfirmationsMutationVariables>(UpdateQuotationConfirmationsDocument);
};
export const QuotationDetailsDocument = gql`
    query QuotationDetails($quotationId: String!) {
  FindQuotation(quotation_id: $quotationId) {
    id
    requested_volume
    unallocated_volume
    value_per_unit
    value_unit_type
    total_volume
    expires_in
    status {
      id
      name
    }
    freight {
      id
      landing_date
      observation
      shipment_date
      suggested_value
      total_volume
      unit_type
      note_value
      status {
        name
      }
      packing_id: packing {
        value: id
        label: name
      }
      product_id: product {
        value: id
        label: name
      }
      product_variety_id: product_variety {
        value: id
        label: name
      }
      product_type_id: product_type {
        value: id
        label: name
      }
      route {
        id
        name
        places {
          id
          name
          state_id
          city_name
          cadence
          dirt_road_distance
          has_dirt_road
          balance_capacity
          has_balance
          note
          opening_hour
          closing_hour
          move_type
          latitude
          longitude
        }
      }
    }
    confirmations {
      id
      assigned_volume
      driver {
        id
        name
        cnh
      }
      vehicle_type {
        id
        name
      }
      vehicle_plate
      ctes {
        id
        filename
        created_at
        url
        loaded_volume
        unit_type
        confirmation {
          id
          vehicle_plate
        }
        driver {
          id
          name
        }
      }
    }
    cancellation {
      cancellationReason {
        description
      }
      description
    }
  }
}
    `;

export function useQuotationDetailsQuery(options: Omit<Urql.UseQueryArgs<QuotationDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<QuotationDetailsQuery, QuotationDetailsQueryVariables>({ query: QuotationDetailsDocument, ...options });
};
export const RefuseQuotationModalDocument = gql`
    mutation RefuseQuotationModal($input: HideFreightInput!) {
  HideFreight(input: $input) {
    id
  }
}
    `;

export function useRefuseQuotationModalMutation() {
  return Urql.useMutation<RefuseQuotationModalMutation, RefuseQuotationModalMutationVariables>(RefuseQuotationModalDocument);
};
export const CanceledQuotationModalDocument = gql`
    query CanceledQuotationModal($quotation_id: String!) {
  FindQuotation(quotation_id: $quotation_id) {
    id
    owner {
      company_name
      trade_name
      address {
        city {
          city_name
          state_id
        }
      }
    }
    has_vehicle
    loaded_volume
    requested_volume
    unallocated_volume
    value_per_unit
    value_unit_type
    freight {
      unit_type
    }
    cancellation {
      cancellationReason {
        name
      }
      description
    }
  }
}
    `;

export function useCanceledQuotationModalQuery(options: Omit<Urql.UseQueryArgs<CanceledQuotationModalQueryVariables>, 'query'>) {
  return Urql.useQuery<CanceledQuotationModalQuery, CanceledQuotationModalQueryVariables>({ query: CanceledQuotationModalDocument, ...options });
};
export const CarrierHiredDetailsModalDocument = gql`
    query CarrierHiredDetailsModal($quotation_id: String!) {
  FindQuotation(quotation_id: $quotation_id) {
    id
    owner {
      company_name
      trade_name
      address {
        city {
          city_name
          state_id
        }
      }
    }
    has_vehicle
    loaded_volume
    requested_volume
    unallocated_volume
    value_per_unit
    value_unit_type
    freight {
      unit_type
    }
    unallocated_volume
  }
}
    `;

export function useCarrierHiredDetailsModalQuery(options: Omit<Urql.UseQueryArgs<CarrierHiredDetailsModalQueryVariables>, 'query'>) {
  return Urql.useQuery<CarrierHiredDetailsModalQuery, CarrierHiredDetailsModalQueryVariables>({ query: CarrierHiredDetailsModalDocument, ...options });
};
export const UploadCteModalDocument = gql`
    mutation UploadCteModal($input: LoadInput!, $file: Upload!) {
  Load(input: $input, file: $file) {
    ctes {
      id
      filename
      created_at
      url
      loaded_volume
      unit_type
      confirmation {
        id
        vehicle_plate
      }
      driver {
        id
        name
      }
    }
  }
}
    `;

export function useUploadCteModalMutation() {
  return Urql.useMutation<UploadCteModalMutation, UploadCteModalMutationVariables>(UploadCteModalDocument);
};
export const WaiveQuotationModalDocument = gql`
    mutation WaiveQuotationModal($input: WaiverQuotationInput!) {
  WaiverQuotation(input: $input) {
    id
  }
}
    `;

export function useWaiveQuotationModalMutation() {
  return Urql.useMutation<WaiveQuotationModalMutation, WaiveQuotationModalMutationVariables>(WaiveQuotationModalDocument);
};
export const UserDetails_UpdateCompanySettingsDocument = gql`
    mutation UserDetails_UpdateCompanySettings($input: UpdateCompanySettingsGraphQLInput!) {
  UpdateCompanySettings(input: $input) {
    id
  }
}
    `;

export function useUserDetails_UpdateCompanySettingsMutation() {
  return Urql.useMutation<UserDetails_UpdateCompanySettingsMutation, UserDetails_UpdateCompanySettingsMutationVariables>(UserDetails_UpdateCompanySettingsDocument);
};
export const UserDetailsDocument = gql`
    query UserDetails($where: CompanyWhereInput, $order_by: CompanyOrderByWithRelationInput) {
  FindCompanies(where: $where, order_by: $order_by) {
    id
    company_name
    company_type
    company_function
    document_number
    companyStatus {
      id
      status
      updated_at
    }
  }
}
    `;

export function useUserDetailsQuery(options?: Omit<Urql.UseQueryArgs<UserDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserDetailsQuery, UserDetailsQueryVariables>({ query: UserDetailsDocument, ...options });
};
export const VehicleTypeSelectDocument = gql`
    query VehicleTypeSelect {
  FindVehicleTypes {
    value: id
    label: name
  }
}
    `;

export function useVehicleTypeSelectQuery(options?: Omit<Urql.UseQueryArgs<VehicleTypeSelectQueryVariables>, 'query'>) {
  return Urql.useQuery<VehicleTypeSelectQuery, VehicleTypeSelectQueryVariables>({ query: VehicleTypeSelectDocument, ...options });
};
export const FindManyThemesDocument = gql`
    query FindManyThemes {
  FindManyThemes {
    data {
      id
      name
    }
  }
}
    `;

export function useFindManyThemesQuery(options?: Omit<Urql.UseQueryArgs<FindManyThemesQueryVariables>, 'query'>) {
  return Urql.useQuery<FindManyThemesQuery, FindManyThemesQueryVariables>({ query: FindManyThemesDocument, ...options });
};
export const FindThemeDocument = gql`
    query FindTheme($themeId: String!) {
  FindTheme(theme_id: $themeId) {
    id
    name
    config
  }
}
    `;

export function useFindThemeQuery(options: Omit<Urql.UseQueryArgs<FindThemeQueryVariables>, 'query'>) {
  return Urql.useQuery<FindThemeQuery, FindThemeQueryVariables>({ query: FindThemeDocument, ...options });
};
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  Login(input: $input) {
    access_token
    refresh_token
    roles
    permissions {
      module
      actions
    }
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  RefreshToken {
    access_token
    refresh_token
    roles
    permissions {
      module
      actions
    }
  }
}
    `;

export function useRefreshTokenMutation() {
  return Urql.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument);
};
export const FindUserDocument = gql`
    query FindUser($userId: String!) {
  FindUser(user_id: $userId) {
    id
    name
    email
    companies {
      company {
        id
        trade_name
        company_function
        company_type
        document_number
        companyStatus {
          id
          status
          updated_at
        }
        settings {
          theme {
            id
            config
          }
        }
      }
    }
  }
}
    `;

export function useFindUserQuery(options: Omit<Urql.UseQueryArgs<FindUserQueryVariables>, 'query'>) {
  return Urql.useQuery<FindUserQuery, FindUserQueryVariables>({ query: FindUserDocument, ...options });
};
export const DeletePlaceDocument = gql`
    mutation DeletePlace($input: DeletePlaceInput!) {
  DeletePlace(input: $input) {
    id
  }
}
    `;

export function useDeletePlaceMutation() {
  return Urql.useMutation<DeletePlaceMutation, DeletePlaceMutationVariables>(DeletePlaceDocument);
};
export const FindPlaceDocument = gql`
    query FindPlace($input: FindPlaceInput!) {
  FindPlace(input: $input) {
    id
    city_id
    city_name
    state_id
    opening_hour
    closing_hour
    cadence
    name
    note
    latitude
    longitude
    has_balance
    balance_capacity
    has_dirt_road
    dirt_road_distance
  }
}
    `;

export function useFindPlaceQuery(options: Omit<Urql.UseQueryArgs<FindPlaceQueryVariables>, 'query'>) {
  return Urql.useQuery<FindPlaceQuery, FindPlaceQueryVariables>({ query: FindPlaceDocument, ...options });
};
export const FindPlacesNamesDocument = gql`
    query FindPlacesNames($where: FindPlacesWhereInput!) {
  FindPlacesNames: FindPlaces(where: $where) {
    id
    name
  }
}
    `;

export function useFindPlacesNamesQuery(options: Omit<Urql.UseQueryArgs<FindPlacesNamesQueryVariables>, 'query'>) {
  return Urql.useQuery<FindPlacesNamesQuery, FindPlacesNamesQueryVariables>({ query: FindPlacesNamesDocument, ...options });
};
export const FindCitiesByStateDocument = gql`
    query FindCitiesByState($stateInitials: String!, $withCoordinates: Boolean! = false) {
  findCities: FindCities(state_id: $stateInitials) {
    id
    cityName: city_name
    latitude @include(if: $withCoordinates)
    longitude @include(if: $withCoordinates)
  }
}
    `;

export function useFindCitiesByStateQuery(options: Omit<Urql.UseQueryArgs<FindCitiesByStateQueryVariables>, 'query'>) {
  return Urql.useQuery<FindCitiesByStateQuery, FindCitiesByStateQueryVariables>({ query: FindCitiesByStateDocument, ...options });
};
export const RecoverPassword_SendRecoveryCodeDocument = gql`
    mutation RecoverPassword_SendRecoveryCode($input: SendRecoveryCodeInput!) {
  SendRecoveryCode(input: $input) {
    has_success
  }
}
    `;

export function useRecoverPassword_SendRecoveryCodeMutation() {
  return Urql.useMutation<RecoverPassword_SendRecoveryCodeMutation, RecoverPassword_SendRecoveryCodeMutationVariables>(RecoverPassword_SendRecoveryCodeDocument);
};
export const RecoverPassword_NewPasswordDocument = gql`
    mutation RecoverPassword_NewPassword($input: RecoveryPasswordInput!) {
  RecoveryPassword(input: $input) {
    has_success
  }
}
    `;

export function useRecoverPassword_NewPasswordMutation() {
  return Urql.useMutation<RecoverPassword_NewPasswordMutation, RecoverPassword_NewPasswordMutationVariables>(RecoverPassword_NewPasswordDocument);
};
export const ActivateUserPageDocument = gql`
    mutation ActivateUserPage($input: ActivateInternalUserInput!) {
  ActivateUser(input: $input) {
    has_success
  }
}
    `;

export function useActivateUserPageMutation() {
  return Urql.useMutation<ActivateUserPageMutation, ActivateUserPageMutationVariables>(ActivateUserPageDocument);
};
export const SignUpContext_RefreshTokenDocument = gql`
    mutation SignUpContext_RefreshToken {
  RefreshToken {
    access_token
    refresh_token
  }
}
    `;

export function useSignUpContext_RefreshTokenMutation() {
  return Urql.useMutation<SignUpContext_RefreshTokenMutation, SignUpContext_RefreshTokenMutationVariables>(SignUpContext_RefreshTokenDocument);
};
export const TermsOfUsePageDocument = gql`
    mutation TermsOfUsePage($email: String!, $password: String!) {
  Login(input: {credential: $email, password: $password}) {
    access_token
    refresh_token
  }
}
    `;

export function useTermsOfUsePageMutation() {
  return Urql.useMutation<TermsOfUsePageMutation, TermsOfUsePageMutationVariables>(TermsOfUsePageDocument);
};
export const CompaniesPageDocument = gql`
    query CompaniesPage($orderBy: CompanyOrderByWithRelationInput, $pagination: Pagination, $where: CompanyWhereInput) {
  FindCompanies(order_by: $orderBy, pagination: $pagination, where: $where) {
    id
    document_number
    company_name
    trade_name
    address {
      city {
        city_name
        state_id
      }
    }
    company_function
    company_type
    companyStatus {
      status
      updated_at
    }
    created_at
    updated_at
  }
  Count: FindCompanies(
    order_by: $orderBy
    pagination: {skip: 0, take: 1000}
    where: $where
  ) {
    id
  }
}
    `;

export function useCompaniesPageQuery(options?: Omit<Urql.UseQueryArgs<CompaniesPageQueryVariables>, 'query'>) {
  return Urql.useQuery<CompaniesPageQuery, CompaniesPageQueryVariables>({ query: CompaniesPageDocument, ...options });
};
export const CompanyDetailsPage_BeginCompanyAnalysisDocument = gql`
    mutation CompanyDetailsPage_BeginCompanyAnalysis($companyId: String!, $managerId: String) {
  ChangeCompanyStatus(
    input: {new_status: IN_ANALYSIS, company_id: $companyId, manager_id: $managerId}
  ) {
    id
    status
    manager {
      id
      email
    }
    updated_at
  }
}
    `;

export function useCompanyDetailsPage_BeginCompanyAnalysisMutation() {
  return Urql.useMutation<CompanyDetailsPage_BeginCompanyAnalysisMutation, CompanyDetailsPage_BeginCompanyAnalysisMutationVariables>(CompanyDetailsPage_BeginCompanyAnalysisDocument);
};
export const CompanyDetailsPageDocument = gql`
    query CompanyDetailsPage($companyId: String!) {
  FindCompany(company_id: $companyId) {
    id
    document_number
    trade_name
    company_name
    company_function
    company_type
    url_logo
    companyStatus {
      id
      status
      manager {
        id
        email
      }
      updated_at
    }
    users {
      user {
        id
        name
        email
        active
        created_at
        updated_at
        deleted_at
      }
    }
    address {
      id
      zip_code_address
      district {
        district_name
      }
      street
      number
      state {
        initials
      }
      city {
        city_name
        state_id
      }
    }
    contacts {
      id
      email
      phone
    }
    mother_company {
      id
      document_number
      trade_name
      company_name
      company_function
      company_type
      url_logo
      companyStatus {
        id
        status
        updated_at
      }
      created_at
      updated_at
      deleted_at
    }
    children_companies {
      id
      document_number
      company_name
      trade_name
      address {
        city {
          city_name
          state_id
        }
      }
      company_function
      company_type
      companyStatus {
        status
        updated_at
      }
      created_at
      updated_at
    }
    created_at
    updated_at
    deleted_at
    has_fleet
    fleet_quantity
    policies {
      id
      name
      bucket_url
      expires_in
      created_at
      updated_at
    }
    operationArea {
      created_at
      updated_at
      state {
        initials
        state_name
      }
    }
  }
}
    `;

export function useCompanyDetailsPageQuery(options: Omit<Urql.UseQueryArgs<CompanyDetailsPageQueryVariables>, 'query'>) {
  return Urql.useQuery<CompanyDetailsPageQuery, CompanyDetailsPageQueryVariables>({ query: CompanyDetailsPageDocument, ...options });
};
export const ApproveCompanyDocument = gql`
    mutation ApproveCompany($input: ApproveCompanyInput!) {
  ApproveCompany(input: $input) {
    id
    company_id
    status
  }
}
    `;

export function useApproveCompanyMutation() {
  return Urql.useMutation<ApproveCompanyMutation, ApproveCompanyMutationVariables>(ApproveCompanyDocument);
};
export const DisapproveCompanyModalDocument = gql`
    mutation DisapproveCompanyModal($input: ReproachCompanyInput!) {
  ReproachCompany(input: $input) {
    reference_company_id
  }
}
    `;

export function useDisapproveCompanyModalMutation() {
  return Urql.useMutation<DisapproveCompanyModalMutation, DisapproveCompanyModalMutationVariables>(DisapproveCompanyModalDocument);
};
export const LinkUserToCompanyForm_FindManyUsersDocument = gql`
    query LinkUserToCompanyForm_FindManyUsers($search: String) {
  FindManyUsers(
    where: {active: {equals: true}, companies: {none: {company: {is: {document_number: {contains: ""}}}}}, OR: [{name: {contains: $search, mode: insensitive}}, {email: {contains: $search, mode: insensitive}}]}
    order_by: {email: asc}
    pagination: {skip: 0, take: 20}
  ) {
    id
    name
    email
  }
}
    `;

export function useLinkUserToCompanyForm_FindManyUsersQuery(options?: Omit<Urql.UseQueryArgs<LinkUserToCompanyForm_FindManyUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<LinkUserToCompanyForm_FindManyUsersQuery, LinkUserToCompanyForm_FindManyUsersQueryVariables>({ query: LinkUserToCompanyForm_FindManyUsersDocument, ...options });
};
export const LinkUserToCompanyForm_FindCompaniesDocument = gql`
    query LinkUserToCompanyForm_FindCompanies($search: String) {
  FindCompanies(
    where: {companyStatus: {some: {status: {equals: APPROVED}}}, OR: [{trade_name: {contains: $search, mode: insensitive}}, {company_name: {contains: $search, mode: insensitive}}, {document_number: {contains: $search, mode: insensitive}}, {address: {is: {city: {is: {city_name: {contains: $search, mode: insensitive}}}}}}, {address: {is: {city: {is: {city_name_without_accent: {contains: $search, mode: insensitive}}}}}}]}
    order_by: {trade_name: {sort: asc}}
    pagination: {skip: 0, take: 20}
  ) {
    id
    document_number
    company_function
    company_name
    trade_name
    address {
      city {
        city_name
        state_id
      }
    }
  }
}
    `;

export function useLinkUserToCompanyForm_FindCompaniesQuery(options?: Omit<Urql.UseQueryArgs<LinkUserToCompanyForm_FindCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<LinkUserToCompanyForm_FindCompaniesQuery, LinkUserToCompanyForm_FindCompaniesQueryVariables>({ query: LinkUserToCompanyForm_FindCompaniesDocument, ...options });
};
export const LinkUserToCompanyDocument = gql`
    mutation LinkUserToCompany($input: LinkUserToCompanyInput!) {
  LinkUserToCompany(input: $input) {
    id
  }
}
    `;

export function useLinkUserToCompanyMutation() {
  return Urql.useMutation<LinkUserToCompanyMutation, LinkUserToCompanyMutationVariables>(LinkUserToCompanyDocument);
};
export const UnlinkUserFromCompanyDocument = gql`
    mutation UnlinkUserFromCompany($input: RemoveUserInternallyInput!) {
  UnlinkUserCompany(input: $input) {
    id
  }
}
    `;

export function useUnlinkUserFromCompanyMutation() {
  return Urql.useMutation<UnlinkUserFromCompanyMutation, UnlinkUserFromCompanyMutationVariables>(UnlinkUserFromCompanyDocument);
};
export const UserDetailsPage_UpdateManyUserHasPermissionsDocument = gql`
    mutation UserDetailsPage_UpdateManyUserHasPermissions($input: UpdateManyUserHasPermissionsInput!) {
  UpdateManyUserHasPermissions(input: $input) {
    user_permission {
      id
    }
  }
}
    `;

export function useUserDetailsPage_UpdateManyUserHasPermissionsMutation() {
  return Urql.useMutation<UserDetailsPage_UpdateManyUserHasPermissionsMutation, UserDetailsPage_UpdateManyUserHasPermissionsMutationVariables>(UserDetailsPage_UpdateManyUserHasPermissionsDocument);
};
export const UserDetailsPage_FindUserAndPermissionsDocument = gql`
    query UserDetailsPage_FindUserAndPermissions($userId: String!) {
  FindUser(user_id: $userId) {
    id
    name
    email
    active
    created_at
    updated_at
    deleted_at
    companies {
      company {
        id
        document_number
        company_name
        trade_name
        address {
          city {
            city_name
            state_id
          }
        }
        company_function
        company_type
        companyStatus {
          status
          updated_at
        }
        created_at
        updated_at
      }
    }
  }
  FindManyUserHasPermissions(
    where: {user: {is: {reference_user_id: {equals: $userId}}}}
  ) {
    enable
    user_permission {
      id
      action {
        name
      }
      module {
        name
      }
    }
  }
}
    `;

export function useUserDetailsPage_FindUserAndPermissionsQuery(options: Omit<Urql.UseQueryArgs<UserDetailsPage_FindUserAndPermissionsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserDetailsPage_FindUserAndPermissionsQuery, UserDetailsPage_FindUserAndPermissionsQueryVariables>({ query: UserDetailsPage_FindUserAndPermissionsDocument, ...options });
};
export const UserDetailsPage_FindUserPermissionTemplateDocument = gql`
    query UserDetailsPage_FindUserPermissionTemplate($roleName: TruckerRolesEnum!) {
  FindPermissionTemplate(role: $roleName) {
    permission_id
    available
  }
}
    `;

export function useUserDetailsPage_FindUserPermissionTemplateQuery(options: Omit<Urql.UseQueryArgs<UserDetailsPage_FindUserPermissionTemplateQueryVariables>, 'query'>) {
  return Urql.useQuery<UserDetailsPage_FindUserPermissionTemplateQuery, UserDetailsPage_FindUserPermissionTemplateQueryVariables>({ query: UserDetailsPage_FindUserPermissionTemplateDocument, ...options });
};
export const UsersPage_CreateUserInternallyDocument = gql`
    mutation UsersPage_CreateUserInternally($input: CreateUserInternallyInput!) {
  CreateUserInternally(input: $input) {
    id
  }
}
    `;

export function useUsersPage_CreateUserInternallyMutation() {
  return Urql.useMutation<UsersPage_CreateUserInternallyMutation, UsersPage_CreateUserInternallyMutationVariables>(UsersPage_CreateUserInternallyDocument);
};
export const UsersPage_CreateTruckerUserDocument = gql`
    mutation UsersPage_CreateTruckerUser($input: CreateTruckerUserInput!) {
  CreateTruckerUser(input: $input) {
    id
  }
}
    `;

export function useUsersPage_CreateTruckerUserMutation() {
  return Urql.useMutation<UsersPage_CreateTruckerUserMutation, UsersPage_CreateTruckerUserMutationVariables>(UsersPage_CreateTruckerUserDocument);
};
export const UsersPageDocument = gql`
    query UsersPage($orderBy: UserOrderByWithRelationInput, $pagination: Pagination, $where: UserWhereInput) {
  FindManyUsers(order_by: $orderBy, pagination: $pagination, where: $where) {
    id
    name
    email
    active
    created_at
    updated_at
    deleted_at
    companies {
      company {
        id
        company_name
        trade_name
        address {
          city {
            city_name
            state_id
          }
        }
      }
    }
  }
  Count: FindManyUsers(
    order_by: $orderBy
    pagination: {skip: 0, take: 1000}
    where: $where
  ) {
    id
  }
}
    `;

export function useUsersPageQuery(options?: Omit<Urql.UseQueryArgs<UsersPageQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersPageQuery, UsersPageQueryVariables>({ query: UsersPageDocument, ...options });
};
export const UsersPage_FindCompaniesDocument = gql`
    query UsersPage_FindCompanies($search: String) {
  FindCompanies(
    where: {companyStatus: {some: {status: {equals: APPROVED}}}, OR: [{trade_name: {contains: $search, mode: insensitive}}, {company_name: {contains: $search, mode: insensitive}}, {document_number: {contains: $search, mode: insensitive}}, {address: {is: {city: {is: {city_name: {contains: $search, mode: insensitive}}}}}}, {address: {is: {city: {is: {city_name_without_accent: {contains: $search, mode: insensitive}}}}}}]}
    order_by: {trade_name: {sort: asc}}
    pagination: {skip: 0, take: 20}
  ) {
    id
    document_number
    company_function
    company_name
    trade_name
    address {
      city {
        city_name
        state_id
      }
    }
  }
}
    `;

export function useUsersPage_FindCompaniesQuery(options?: Omit<Urql.UseQueryArgs<UsersPage_FindCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersPage_FindCompaniesQuery, UsersPage_FindCompaniesQueryVariables>({ query: UsersPage_FindCompaniesDocument, ...options });
};
export const QuotationGroupFormModal_CreateGroupDocument = gql`
    mutation QuotationGroupFormModal_CreateGroup($input: CreateGroupInput!) {
  CreateGroup(input: $input) {
    id
  }
}
    `;

export function useQuotationGroupFormModal_CreateGroupMutation() {
  return Urql.useMutation<QuotationGroupFormModal_CreateGroupMutation, QuotationGroupFormModal_CreateGroupMutationVariables>(QuotationGroupFormModal_CreateGroupDocument);
};
export const QuotationGroupFormModal_UpdateGroupDocument = gql`
    mutation QuotationGroupFormModal_UpdateGroup($input: UpdateGroupInput!) {
  UpdateGroup(input: $input) {
    id
  }
}
    `;

export function useQuotationGroupFormModal_UpdateGroupMutation() {
  return Urql.useMutation<QuotationGroupFormModal_UpdateGroupMutation, QuotationGroupFormModal_UpdateGroupMutationVariables>(QuotationGroupFormModal_UpdateGroupDocument);
};
export const QuotationGroupFormModal_FindCarrierCompaniesDocument = gql`
    query QuotationGroupFormModal_FindCarrierCompanies($search: String, $excludeIds: [String!]) {
  FindCompanies(
    where: {id: {notIn: $excludeIds}, companyStatus: {some: {status: {equals: APPROVED}}}, company_function: {equals: CARRIER}, OR: [{trade_name: {contains: $search, mode: insensitive}}, {company_name: {contains: $search, mode: insensitive}}, {document_number: {contains: $search, mode: insensitive}}, {address: {is: {city: {is: {city_name: {contains: $search, mode: insensitive}}}}}}, {address: {is: {city: {is: {city_name_without_accent: {contains: $search, mode: insensitive}}}}}}]}
    order_by: {trade_name: {sort: asc}}
    pagination: {skip: 0, take: 20}
  ) {
    id
    document_number
    company_function
    company_name
    trade_name
    address {
      city {
        city_name
        state_id
      }
    }
  }
}
    `;

export function useQuotationGroupFormModal_FindCarrierCompaniesQuery(options?: Omit<Urql.UseQueryArgs<QuotationGroupFormModal_FindCarrierCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<QuotationGroupFormModal_FindCarrierCompaniesQuery, QuotationGroupFormModal_FindCarrierCompaniesQueryVariables>({ query: QuotationGroupFormModal_FindCarrierCompaniesDocument, ...options });
};
export const QuotationGroupFormModal_FindQuotationGroupDocument = gql`
    query QuotationGroupFormModal_FindQuotationGroup($groupId: String!) {
  FindGroup(group_id: $groupId) {
    id
    name
    created_at
    updated_at
    members {
      company {
        id: reference_external_company_id
        document_number
        company_function
        company_name
        trade_name
        address {
          city {
            city_name
            state_id
          }
        }
      }
      created_at
    }
  }
}
    `;

export function useQuotationGroupFormModal_FindQuotationGroupQuery(options: Omit<Urql.UseQueryArgs<QuotationGroupFormModal_FindQuotationGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<QuotationGroupFormModal_FindQuotationGroupQuery, QuotationGroupFormModal_FindQuotationGroupQueryVariables>({ query: QuotationGroupFormModal_FindQuotationGroupDocument, ...options });
};
export const QuotationGroupMembersTable_FindCompanyDocument = gql`
    query QuotationGroupMembersTable_FindCompany($companyId: String!) {
  FindCompany(company_id: $companyId) {
    id
    document_number
    trade_name
    company_name
    company_type
    company_function
    address {
      id
      zip_code_address
      district {
        district_name
      }
      street
      number
      state {
        initials
      }
      city {
        city_name
      }
    }
    contacts {
      phone
      email
    }
    policies {
      id
      name
      expires_in
      bucket_url
    }
  }
}
    `;

export function useQuotationGroupMembersTable_FindCompanyQuery(options: Omit<Urql.UseQueryArgs<QuotationGroupMembersTable_FindCompanyQueryVariables>, 'query'>) {
  return Urql.useQuery<QuotationGroupMembersTable_FindCompanyQuery, QuotationGroupMembersTable_FindCompanyQueryVariables>({ query: QuotationGroupMembersTable_FindCompanyDocument, ...options });
};
export const QuotationGroups_DeleteQuotationGroupDocument = gql`
    mutation QuotationGroups_DeleteQuotationGroup($input: DeleteGroupInput!) {
  DeleteGroup(input: $input) {
    id
  }
}
    `;

export function useQuotationGroups_DeleteQuotationGroupMutation() {
  return Urql.useMutation<QuotationGroups_DeleteQuotationGroupMutation, QuotationGroups_DeleteQuotationGroupMutationVariables>(QuotationGroups_DeleteQuotationGroupDocument);
};
export const QuotationGroups_ListQuotationGroupsDocument = gql`
    query QuotationGroups_ListQuotationGroups($orderBy: GroupOrderByWithRelationInput, $ownerId: String!, $pagination: Pagination, $where: GroupWhereInput) {
  FindManyGroups(
    order_by: $orderBy
    owner_id: $ownerId
    pagination: $pagination
    where: $where
  ) {
    length
    data {
      id
      name
      created_at
      updated_at
      members {
        company {
          id
          company_name
          trade_name
          address {
            city {
              city_name
              state_id
            }
          }
        }
      }
    }
  }
}
    `;

export function useQuotationGroups_ListQuotationGroupsQuery(options: Omit<Urql.UseQueryArgs<QuotationGroups_ListQuotationGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<QuotationGroups_ListQuotationGroupsQuery, QuotationGroups_ListQuotationGroupsQueryVariables>({ query: QuotationGroups_ListQuotationGroupsDocument, ...options });
};